/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (isoformat) */
  Date: { input: string; output: string; }
  /** Date with time (isoformat) */
  DateTime: { input: string; output: string; }
  /** Decimal (fixed-point) */
  Decimal: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  /** Represents a point as `(x, y, z)` or `(x, y)`. */
  Point: { input: any; output: any; }
  /** Time (isoformat) */
  Time: { input: string; output: string; }
  UUID: { input: string; output: string; }
  Upload: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type AccountCreditFilter = {
  AND?: InputMaybe<AccountCreditFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<AccountCreditFilter>;
  OR?: InputMaybe<AccountCreditFilter>;
  creditType?: InputMaybe<BillingAccountCreditCreditTypeEnumFilterLookup>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
};

export type AccountCreditInput = {
  amount: Scalars['String']['input'];
  creditReason?: InputMaybe<BillingAccountCreditCreditReasonEnum>;
  creditType: BillingAccountCreditCreditTypeEnum;
  expirationDate: Scalars['Date']['input'];
  household: OneToManyInput;
  issuedBy?: InputMaybe<OneToManyInput>;
  promo?: InputMaybe<OneToManyInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AccountCreditInputPartial = {
  amount: Scalars['String']['input'];
  creditReason?: InputMaybe<BillingAccountCreditCreditReasonEnum>;
  creditType?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  household?: InputMaybe<OneToManyInput>;
  id: Scalars['ID']['input'];
  issuedBy?: InputMaybe<OneToManyInput>;
  promo?: InputMaybe<OneToManyInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AccountCreditOrder = {
  expirationDate?: InputMaybe<Ordering>;
};

export type AccountCreditType = {
  __typename?: 'AccountCreditType';
  amount: Scalars['Decimal']['output'];
  amountRedeemed: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  creditReason: Maybe<BillingAccountCreditCreditReasonEnum>;
  creditType: BillingAccountCreditCreditTypeEnum;
  expirationDate: Scalars['Date']['output'];
  household: DjangoModelType;
  id: Scalars['ID']['output'];
  isExpired: Scalars['Boolean']['output'];
  issuedBy: Maybe<StaffType>;
  modified: Scalars['DateTime']['output'];
  promo: Maybe<DjangoModelType>;
  reason: Maybe<Scalars['String']['output']>;
  remainingAmount: Scalars['Decimal']['output'];
};

export enum AiTriageBookingFormCategoryEnum {
  AnalGland = 'ANAL_GLAND',
  CarePlanItems = 'CARE_PLAN_ITEMS',
  DecreasedAppetite = 'DECREASED_APPETITE',
  DentalOrProcedureFollowUp = 'DENTAL_OR_PROCEDURE_FOLLOW_UP',
  DiarrheaOrSoftStool = 'DIARRHEA_OR_SOFT_STOOL',
  EyeIssues = 'EYE_ISSUES',
  FleaOrTickIssues = 'FLEA_OR_TICK_ISSUES',
  FollowUp = 'FOLLOW_UP',
  LamenessOrLimping = 'LAMENESS_OR_LIMPING',
  LumpOrBump = 'LUMP_OR_BUMP',
  Seizures = 'SEIZURES',
  Sneezing = 'SNEEZING',
  TechnicianAppointment = 'TECHNICIAN_APPOINTMENT',
  TravelDocuments = 'TRAVEL_DOCUMENTS',
  Vomiting = 'VOMITING',
  WalkingSlowly = 'WALKING_SLOWLY',
  Wellness = 'WELLNESS',
  WoundOrCut = 'WOUND_OR_CUT',
  WoundOrCutAnimalFight = 'WOUND_OR_CUT___ANIMAL_FIGHT'
}

export enum AiTriageBookingRoutingDestinationEnum {
  Booking = 'BOOKING',
  Chat = 'CHAT',
  EmergencyRoom = 'EMERGENCY_ROOM',
  FollowUpQuestion = 'FOLLOW_UP_QUESTION',
  Prescription = 'PRESCRIPTION'
}

export enum AiTriageFormCategoryEnum {
  AccidentalIngestion = 'ACCIDENTAL_INGESTION',
  BleedingInjury = 'BLEEDING_INJURY',
  Diarrhea = 'DIARRHEA',
  EarIssues = 'EAR_ISSUES',
  EyeIssues = 'EYE_ISSUES',
  ItchySkin = 'ITCHY_SKIN',
  LimpingInjury = 'LIMPING_INJURY',
  UrinaryIssues = 'URINARY_ISSUES',
  Vomiting = 'VOMITING'
}

export enum AiTriageFormQuestionTypeEnum {
  Image = 'IMAGE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  SingleChoice = 'SINGLE_CHOICE',
  Video = 'VIDEO'
}

export enum AiTriageRoutingCategoryEnum {
  AccidentalIngestion = 'ACCIDENTAL_INGESTION',
  BleedingInjury = 'BLEEDING_INJURY',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  Diarrhea = 'DIARRHEA',
  EarIssues = 'EAR_ISSUES',
  Emergency = 'EMERGENCY',
  EyeIssues = 'EYE_ISSUES',
  GeneralPrescriptionQuestion = 'GENERAL_PRESCRIPTION_QUESTION',
  ItchySkin = 'ITCHY_SKIN',
  LimpingInjury = 'LIMPING_INJURY',
  Nonsense = 'NONSENSE',
  OtherMedicalIssue = 'OTHER_MEDICAL_ISSUE',
  PrescriptionRefillRequest = 'PRESCRIPTION_REFILL_REQUEST',
  UrinaryIssues = 'URINARY_ISSUES',
  Vomiting = 'VOMITING'
}

export enum AiTriageRoutingDestinationEnum {
  Booking = 'BOOKING',
  Chat = 'CHAT',
  Form = 'FORM',
  PrescriptionRefill = 'PRESCRIPTION_REFILL'
}

export enum AiTriageSupportTypeEnum {
  BookingSupport = 'BOOKING_SUPPORT',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  MedicalSupport = 'MEDICAL_SUPPORT',
  PrescriptionSupport = 'PRESCRIPTION_SUPPORT'
}

export type AppointmentDynamicTextType = {
  __typename?: 'AppointmentDynamicTextType';
  changeOfPlansText: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  dayOfVisitInstructions: Array<Scalars['String']['output']>;
  hoursBeforeLateCancellation: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  type: StaffAppointmentDynamicTextTypeEnum;
  warningOnBookingText: Scalars['String']['output'];
  warningOnCancellationText: Scalars['String']['output'];
};

export type AppointmentFilter = {
  AND?: InputMaybe<AppointmentFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<AppointmentFilter>;
  OR?: InputMaybe<AppointmentFilter>;
  appointmentType?: InputMaybe<StaffAppointmentAppointmentTypeEnumFilterLookup>;
  conversation?: InputMaybe<ConversationFilter>;
  end?: InputMaybe<DatetimeDatetimeFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
  location?: InputMaybe<LocationFilter>;
  patient?: InputMaybe<PatientFilter>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  staff?: InputMaybe<StaffFilter>;
  start?: InputMaybe<DatetimeDatetimeFilterLookup>;
  status?: InputMaybe<StaffAppointmentStatusEnumFilterLookup>;
};

export type AppointmentInput = {
  appointmentType: StaffAppointmentAppointmentTypeEnum;
  dropoffEnd?: InputMaybe<Scalars['Time']['input']>;
  dropoffStart?: InputMaybe<Scalars['Time']['input']>;
  end: Scalars['DateTime']['input'];
  forceDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  isDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  isHoldPlaced?: InputMaybe<Scalars['Boolean']['input']>;
  isPotentialSedation?: InputMaybe<Scalars['Boolean']['input']>;
  isTriageMisbooked?: InputMaybe<Scalars['Boolean']['input']>;
  location: OneToManyInput;
  pabwDate?: InputMaybe<Scalars['Date']['input']>;
  patient: OneToManyInput;
  reasonForVisitDescription: Scalars['String']['input'];
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  slot?: InputMaybe<OneToOneInput>;
  source: StaffAppointmentSourceEnum;
  specialAppointmentInstructions?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  start: Scalars['DateTime']['input'];
  status?: InputMaybe<StaffAppointmentStatusEnum>;
  suppressNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  triageClientResponse?: InputMaybe<Scalars['String']['input']>;
  waiveNoShowOrLateCancellationFee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppointmentInputPartial = {
  appointmentType?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
  dropoffEnd?: InputMaybe<Scalars['Time']['input']>;
  dropoffStart?: InputMaybe<Scalars['Time']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  forceDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  isHoldPlaced?: InputMaybe<Scalars['Boolean']['input']>;
  isPotentialSedation?: InputMaybe<Scalars['Boolean']['input']>;
  isTriageMisbooked?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<OneToManyInput>;
  pabwDate?: InputMaybe<Scalars['Date']['input']>;
  patient?: InputMaybe<OneToManyInput>;
  reasonForVisitDescription?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  slot?: InputMaybe<OneToOneInput>;
  source?: InputMaybe<StaffAppointmentSourceEnum>;
  specialAppointmentInstructions?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<StaffAppointmentStatusEnum>;
  suppressNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  triageClientResponse?: InputMaybe<Scalars['String']['input']>;
  waiveNoShowOrLateCancellationFee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppointmentOrder = {
  start?: InputMaybe<Ordering>;
};

export type AppointmentSlotOrder = {
  start?: InputMaybe<Ordering>;
};

export type AppointmentType = {
  __typename?: 'AppointmentType';
  address: Maybe<Scalars['String']['output']>;
  apartment: Maybe<Scalars['String']['output']>;
  appointmentType: StaffAppointmentAppointmentTypeEnum;
  cancellationDetails: Maybe<Scalars['String']['output']>;
  cancellationReason: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  clinicalRecords: Array<ClinicalRecordType>;
  confirmCancel: Scalars['String']['output'];
  conversation: Maybe<ConversationType>;
  created: Scalars['DateTime']['output'];
  dropoffEnd: Maybe<Scalars['Time']['output']>;
  dropoffStart: Maybe<Scalars['Time']['output']>;
  dynamicText: Maybe<AppointmentDynamicTextType>;
  end: Scalars['DateTime']['output'];
  forceDropOff: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interaction: Maybe<InteractionType>;
  isDropOff: Scalars['Boolean']['output'];
  isEol: Scalars['Boolean']['output'];
  isHoldPlaced: Scalars['Boolean']['output'];
  isPotentialSedation: Scalars['Boolean']['output'];
  isTriageMisbooked: Scalars['Boolean']['output'];
  location: LocationType;
  modified: Scalars['DateTime']['output'];
  pabwDate: Maybe<Scalars['Date']['output']>;
  patient: PatientType;
  reasonForVisitDescription: Scalars['String']['output'];
  rejectCancel: Scalars['String']['output'];
  reviewed: Scalars['Boolean']['output'];
  slot: SlotType;
  source: StaffAppointmentSourceEnum;
  specialAppointmentInstructions: Maybe<Scalars['String']['output']>;
  staff: Maybe<StaffType>;
  start: Scalars['DateTime']['output'];
  state: Maybe<Scalars['String']['output']>;
  status: StaffAppointmentStatusEnum;
  suppressNotifications: Scalars['Boolean']['output'];
  tags: Array<TagSelectorType>;
  timezoneStart: Maybe<Scalars['DateTime']['output']>;
  triageClientResponse: Maybe<Scalars['String']['output']>;
  waiveNoShowOrLateCancellationFee: Scalars['Boolean']['output'];
  warningOnCancel: Scalars['String']['output'];
  zipcode: Maybe<Scalars['String']['output']>;
};


export type AppointmentTypeClinicalRecordsArgs = {
  filters: InputMaybe<ClinicalRecordFilter>;
  order: InputMaybe<ClinicalRecordOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type AppointmentTypeTagsArgs = {
  filters: InputMaybe<TagSelectorFilter>;
};

export type AttachmentFilter = {
  AND?: InputMaybe<AttachmentFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<AttachmentFilter>;
  OR?: InputMaybe<AttachmentFilter>;
  category?: InputMaybe<MedicalAttachmentCategoryEnumFilterLookup>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type AttachmentInput = {
  category: MedicalAttachmentCategoryEnum;
  clinicalRecord?: InputMaybe<OneToManyInput>;
  file: Scalars['Upload']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  patient: OneToManyInput;
};

export type AttachmentInputPartial = {
  id: Scalars['ID']['input'];
};

export type AttachmentType = {
  __typename?: 'AttachmentType';
  aiSummary: Maybe<Scalars['String']['output']>;
  category: MedicalAttachmentCategoryEnum;
  clinicalRecord: Maybe<ClinicalRecordType>;
  created: Scalars['DateTime']['output'];
  file: DjangoFileType;
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  name: Maybe<Scalars['String']['output']>;
  patient: DjangoModelType;
  uniqueId: Scalars['UUID']['output'];
};

export type AuthorizePhone = {
  __typename?: 'AuthorizePhone';
  client: Maybe<ClientType>;
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  phoneHash: Maybe<Scalars['String']['output']>;
  smsSent: Scalars['Boolean']['output'];
};

export type AutoshipFilter = {
  AND?: InputMaybe<AutoshipFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<AutoshipFilter>;
  OR?: InputMaybe<AutoshipFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  prescription?: InputMaybe<PrescriptionFilter>;
  status?: InputMaybe<CustomerAutoshipStatusEnumFilterLookup>;
};

export type AutoshipInput = {
  clinicalRecord?: InputMaybe<OneToManyInput>;
  creditCard: OneToManyInput;
  frequencyInDays?: InputMaybe<Scalars['Int']['input']>;
  isOrderImmediate?: InputMaybe<Scalars['Boolean']['input']>;
  nextProduct: OneToManyInput;
  nextShipDate?: InputMaybe<Scalars['Date']['input']>;
  prescription: OneToManyInput;
  quantity?: InputMaybe<Scalars['String']['input']>;
  setupLocation?: InputMaybe<OneToManyInput>;
  shippingAddress: Scalars['String']['input'];
  shippingApartment?: InputMaybe<Scalars['String']['input']>;
  shippingCity: Scalars['String']['input'];
  shippingState: Scalars['String']['input'];
  shippingZipcode: Scalars['String']['input'];
  source?: InputMaybe<CustomerAutoshipSourceEnum>;
  status?: InputMaybe<CustomerAutoshipStatusEnum>;
};

export type AutoshipInputPartial = {
  clinicalRecord?: InputMaybe<OneToManyInput>;
  creditCard?: InputMaybe<OneToManyInput>;
  frequencyInDays?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  isOrderImmediate?: InputMaybe<Scalars['Boolean']['input']>;
  nextProduct?: InputMaybe<OneToManyInput>;
  nextShipDate?: InputMaybe<Scalars['Date']['input']>;
  prescription?: InputMaybe<OneToManyInput>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  setupLocation?: InputMaybe<OneToManyInput>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  shippingApartment?: InputMaybe<Scalars['String']['input']>;
  shippingCity?: InputMaybe<Scalars['String']['input']>;
  shippingState?: InputMaybe<Scalars['String']['input']>;
  shippingZipcode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CustomerAutoshipSourceEnum>;
  status?: InputMaybe<CustomerAutoshipStatusEnum>;
};

export type AutoshipOrder = {
  nextShipDate?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
};

export type AutoshipType = {
  __typename?: 'AutoshipType';
  blackoutStartDate: Maybe<Scalars['DateTime']['output']>;
  clinicalRecord: Maybe<ClinicalRecordType>;
  created: Scalars['DateTime']['output'];
  creditCard: CreditCardType;
  frequencyInDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  nextProduct: ProductType;
  nextShipDate: Maybe<Scalars['Date']['output']>;
  prescription: PrescriptionType;
  quantity: Scalars['Decimal']['output'];
  setupLocation: DjangoModelType;
  shippingAddress: Scalars['String']['output'];
  shippingApartment: Maybe<Scalars['String']['output']>;
  shippingCity: Scalars['String']['output'];
  shippingState: Scalars['String']['output'];
  shippingZipcode: Scalars['String']['output'];
  source: CustomerAutoshipSourceEnum;
  status: CustomerAutoshipStatusEnum;
};

export enum AvailabilityAttendanceTypeEnum {
  DropOff = 'DROP_OFF',
  InRoom = 'IN_ROOM'
}

export type AvailabilityType = {
  __typename?: 'AvailabilityType';
  availableStaffIds: Array<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  isAvailable: Scalars['Boolean']['output'];
};

export type BaseCarePlanItemType = {
  __typename?: 'BaseCarePlanItemType';
  carePlan: CarePlanGuidanceType;
  dueDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type BaseVaccineType = {
  __typename?: 'BaseVaccineType';
  date: Scalars['Date']['output'];
  expirationDate: Scalars['Date']['output'];
  friendlyVaccine: ClientFriendlyVaccineType;
};

export enum BillingAccountCreditCreditReasonEnum {
  /** Forgot to Use Promo Code */
  ForgotToUsePromoCode = 'Forgot_to_Use_Promo_Code',
  /** Had to Reschedule */
  HadToReschedule = 'Had_to_Reschedule',
  /** Misaligned Expectations */
  MisalignedExpectations = 'Misaligned_Expectations',
  /** Order Damaged Upon Arrival */
  OrderDamagedUponArrival = 'Order_Damaged_Upon_Arrival',
  /** Other */
  Other = 'Other',
  /** Poor Experience */
  PoorExperience = 'Poor_Experience',
  /** Upset About Availability */
  UpsetAboutAvailability = 'Upset_About_Availability',
  /** User Research */
  UserResearch = 'User_Research'
}

export enum BillingAccountCreditCreditTypeEnum {
  /** APPEASEMENT */
  Appeasement = 'APPEASEMENT',
  /** GENERIC */
  Generic = 'GENERIC',
  /** PROCEDURE */
  Procedure = 'PROCEDURE',
  /** REFERRAL */
  Referral = 'REFERRAL',
  /** REFUND */
  Refund = 'REFUND'
}

export type BillingAccountCreditCreditTypeEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<BillingAccountCreditCreditTypeEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<BillingAccountCreditCreditTypeEnum>;
};

export enum BillingCreditCardBinInfoProductEnum {
  /** Amex */
  A = 'A',
  /** Discover */
  D = 'D',
  /** Mastercard */
  M = 'M',
  /** Card */
  N = 'N',
  /** Visa */
  V = 'V'
}

export enum BillingEstimateDiscountReasonEnum {
  /** Already Paid */
  AlreadyPaid = 'Already_Paid',
  /** Medical Error */
  MedicalError = 'Medical_Error',
  /** One-Time Price Match */
  OneTimePriceMatch = 'One_Time_Price_Match',
  /** Order Not Received */
  OrderNotReceived = 'Order_Not_Received',
  /** Other */
  Other = 'Other',
  /** Poor Experience */
  PoorExperience = 'Poor_Experience',
  /** Quoted Wrong Price */
  QuotedWrongPrice = 'Quoted_Wrong_Price'
}

export enum BillingEstimateDiscountTypeEnum {
  /** FLAT */
  Flat = 'FLAT',
  /** OFF */
  Off = 'OFF',
  /** PERCENT */
  Percent = 'PERCENT'
}

export enum BillingEstimateItemDeclinedByEnum {
  /** CLIENT */
  Client = 'CLIENT',
  /** DOCTOR_OR_MEDICAL */
  DoctorOrMedical = 'DOCTOR_OR_MEDICAL'
}

export enum BillingEstimateStatusEnum {
  /** APPROVED */
  Approved = 'APPROVED',
  /** DECLINED */
  Declined = 'DECLINED',
  /** DRAFT */
  Draft = 'DRAFT',
  /** EXPIRED */
  Expired = 'EXPIRED',
  /** SENT */
  Sent = 'SENT'
}

export type BillingEstimateStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<BillingEstimateStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<BillingEstimateStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<BillingEstimateStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<BillingEstimateStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<BillingEstimateStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<BillingEstimateStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<BillingEstimateStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<BillingEstimateStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<BillingEstimateStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<BillingEstimateStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<BillingEstimateStatusEnum>;
};

export enum BillingEstimateTierEnum {
  /** ALL_ACCESS */
  AllAccess = 'ALL_ACCESS',
  /** ESSENTIAL */
  Essential = 'ESSENTIAL',
  /** PAY_AS_YOU_GO */
  PayAsYouGo = 'PAY_AS_YOU_GO'
}

export type BillingEstimateTierEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<BillingEstimateTierEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<BillingEstimateTierEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<BillingEstimateTierEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<BillingEstimateTierEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<BillingEstimateTierEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<BillingEstimateTierEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<BillingEstimateTierEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<BillingEstimateTierEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<BillingEstimateTierEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<BillingEstimateTierEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<BillingEstimateTierEnum>;
};

export enum BillingInvoiceDiscountReasonEnum {
  /** Already Paid */
  AlreadyPaid = 'Already_Paid',
  /** Medical Error */
  MedicalError = 'Medical_Error',
  /** One-Time Price Match */
  OneTimePriceMatch = 'One_Time_Price_Match',
  /** Order Not Received */
  OrderNotReceived = 'Order_Not_Received',
  /** Other */
  Other = 'Other',
  /** Poor Experience */
  PoorExperience = 'Poor_Experience',
  /** Quoted Wrong Price */
  QuotedWrongPrice = 'Quoted_Wrong_Price'
}

export enum BillingInvoiceDiscountTypeEnum {
  /** FLAT */
  Flat = 'FLAT',
  /** OFF */
  Off = 'OFF',
  /** PERCENT */
  Percent = 'PERCENT'
}

export enum BillingInvoiceItemDeclinedByEnum {
  /** CLIENT */
  Client = 'CLIENT',
  /** DOCTOR_OR_MEDICAL */
  DoctorOrMedical = 'DOCTOR_OR_MEDICAL'
}

export enum BillingInvoiceItemReasonForPostponeEnum {
  /** DOCTOR_DISCRETION */
  DoctorDiscretion = 'DOCTOR_DISCRETION',
  /** FAS */
  Fas = 'FAS',
  /** SICK_PATIENT */
  SickPatient = 'SICK_PATIENT'
}

export type BillingInvoiceItemReasonForPostponeEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<BillingInvoiceItemReasonForPostponeEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
};

export enum BillingInvoiceStatusEnum {
  /** DUE */
  Due = 'DUE',
  /** OPEN */
  Open = 'OPEN',
  /** PAID */
  Paid = 'PAID',
  /** VOIDED */
  Voided = 'VOIDED'
}

export type BillingInvoiceStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<BillingInvoiceStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<BillingInvoiceStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<BillingInvoiceStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<BillingInvoiceStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<BillingInvoiceStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<BillingInvoiceStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<BillingInvoiceStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<BillingInvoiceStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<BillingInvoiceStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<BillingInvoiceStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<BillingInvoiceStatusEnum>;
};

export enum BillingInvoiceTierEnum {
  /** ALL_ACCESS */
  AllAccess = 'ALL_ACCESS',
  /** ESSENTIAL */
  Essential = 'ESSENTIAL',
  /** PAY_AS_YOU_GO */
  PayAsYouGo = 'PAY_AS_YOU_GO'
}

export enum BillingTransactionMethodEnum {
  /** AUTHORIZE_CARD_ON_FILE */
  AuthorizeCardOnFile = 'AUTHORIZE_CARD_ON_FILE',
  /** CHARGE_CARD_ON_FILE */
  ChargeCardOnFile = 'CHARGE_CARD_ON_FILE',
  /** CHARGE_WITH_TERMINAL */
  ChargeWithTerminal = 'CHARGE_WITH_TERMINAL',
  /** PAID_WITH_ACCOUNT_CREDIT */
  PaidWithAccountCredit = 'PAID_WITH_ACCOUNT_CREDIT',
  /** PAID_WITH_CASH */
  PaidWithCash = 'PAID_WITH_CASH',
  /** PAID_WITH_CHECK */
  PaidWithCheck = 'PAID_WITH_CHECK',
  /** PAID_WITH_CREDIT_CARD */
  PaidWithCreditCard = 'PAID_WITH_CREDIT_CARD',
  /** PAID_WITH_SCRATCH_PAY */
  PaidWithScratchPay = 'PAID_WITH_SCRATCH_PAY',
  /** PAID_WITH_TRUPANION */
  PaidWithTrupanion = 'PAID_WITH_TRUPANION',
  /** REFUND_AUTHORIZE_CARD_ON_FILE */
  RefundAuthorizeCardOnFile = 'REFUND_AUTHORIZE_CARD_ON_FILE',
  /** REFUND_CHARGE_CARD_ON_FILE */
  RefundChargeCardOnFile = 'REFUND_CHARGE_CARD_ON_FILE',
  /** REFUND_CHARGE_WITH_TERMINAL */
  RefundChargeWithTerminal = 'REFUND_CHARGE_WITH_TERMINAL',
  /** REFUND_PAID_WITH_ACCOUNT_CREDIT */
  RefundPaidWithAccountCredit = 'REFUND_PAID_WITH_ACCOUNT_CREDIT',
  /** REFUND_PAID_WITH_CASH */
  RefundPaidWithCash = 'REFUND_PAID_WITH_CASH',
  /** REFUND_PAID_WITH_CHECK */
  RefundPaidWithCheck = 'REFUND_PAID_WITH_CHECK',
  /** REFUND_PAID_WITH_CREDIT_CARD */
  RefundPaidWithCreditCard = 'REFUND_PAID_WITH_CREDIT_CARD',
  /** REFUND_PAID_WITH_SCRATCH_PAY */
  RefundPaidWithScratchPay = 'REFUND_PAID_WITH_SCRATCH_PAY',
  /** REFUND_PAID_WITH_TRUPANION */
  RefundPaidWithTrupanion = 'REFUND_PAID_WITH_TRUPANION',
  /** VOID_CHARGE_CARD_ON_FILE */
  VoidChargeCardOnFile = 'VOID_CHARGE_CARD_ON_FILE',
  /** VOID_CHARGE_WITH_TERMINAL */
  VoidChargeWithTerminal = 'VOID_CHARGE_WITH_TERMINAL',
  /** VOID_PAID_WITH_CREDIT_CARD */
  VoidPaidWithCreditCard = 'VOID_PAID_WITH_CREDIT_CARD'
}

export enum BillingTransactionStatusEnum {
  /** FAILED */
  Failed = 'FAILED',
  /** PENDING */
  Pending = 'PENDING',
  /** SUCCESSFUL */
  Successful = 'SUCCESSFUL'
}

export type BillingTransactionStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<BillingTransactionStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<BillingTransactionStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<BillingTransactionStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<BillingTransactionStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<BillingTransactionStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<BillingTransactionStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<BillingTransactionStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<BillingTransactionStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<BillingTransactionStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<BillingTransactionStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<BillingTransactionStatusEnum>;
};

export type BoolBaseFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BreedFilter = {
  AND?: InputMaybe<BreedFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<BreedFilter>;
  OR?: InputMaybe<BreedFilter>;
  species?: InputMaybe<CustomerBreedSpeciesEnum>;
};

export type BreedType = {
  __typename?: 'BreedType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CarePlanDiagnosticsType = {
  __typename?: 'CarePlanDiagnosticsType';
  carePlan: BaseCarePlanItemType;
  lastDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nextDue: Scalars['String']['output'];
};

export type CarePlanGuidanceFilter = {
  AND?: InputMaybe<CarePlanGuidanceFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<CarePlanGuidanceFilter>;
  OR?: InputMaybe<CarePlanGuidanceFilter>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxAge?: InputMaybe<FloatComparisonFilterLookup>;
  minAge?: InputMaybe<FloatComparisonFilterLookup>;
  name?: InputMaybe<StrFilterLookup>;
  species?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnumFilterLookup>;
};

export type CarePlanGuidanceOrder = {
  maxAge?: InputMaybe<Ordering>;
  minAge?: InputMaybe<Ordering>;
};

export type CarePlanGuidanceType = {
  __typename?: 'CarePlanGuidanceType';
  details: Maybe<Scalars['String']['output']>;
  highPrice: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  kind: MedicalCarePlanGuidanceKindEnum;
  lowPrice: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  optional: Scalars['Boolean']['output'];
  recReason: Maybe<Scalars['String']['output']>;
  recommendedIntervalInDays: Maybe<Scalars['Int']['output']>;
  recommendedProducts: Array<ProductType>;
  tag: Maybe<TagSelectorType>;
};


export type CarePlanGuidanceTypeRecommendedProductsArgs = {
  filters: InputMaybe<ProductFilter>;
  order: InputMaybe<ProductOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};

export type CarePlanItemFilter = {
  AND?: InputMaybe<CarePlanItemFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<CarePlanItemFilter>;
  OR?: InputMaybe<CarePlanItemFilter>;
  carePlan?: InputMaybe<CarePlanGuidanceFilter>;
  patient?: InputMaybe<PatientFilter>;
  status?: InputMaybe<MedicalCarePlanItemStatusEnumFilterLookup>;
};

export type CarePlanItemInputPartial = {
  carePlan?: InputMaybe<OneToManyInput>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  noHistory?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<OneToManyInput>;
  status?: InputMaybe<MedicalCarePlanItemStatusEnum>;
};

export type CarePlanItemType = {
  __typename?: 'CarePlanItemType';
  carePlan: CarePlanGuidanceType;
  created: Scalars['DateTime']['output'];
  dueDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modified: Scalars['DateTime']['output'];
  modifiedBy: Maybe<StaffType>;
  noHistory: Scalars['Boolean']['output'];
  note: Maybe<Scalars['String']['output']>;
  patient: PatientType;
  status: MedicalCarePlanItemStatusEnum;
};

export enum CatalogProductDiagnosticTypeEnum {
  /** In-House Integrated */
  InHouseIntegrated = 'In_House_Integrated',
  /** In-House Non-Integrated */
  InHouseNonIntegrated = 'In_House_Non_Integrated',
  /** Reference Integrated */
  ReferenceIntegrated = 'Reference_Integrated',
  /** Reference Non-Integrated */
  ReferenceNonIntegrated = 'Reference_Non_Integrated'
}

export type CatalogProductDiagnosticTypeEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<CatalogProductDiagnosticTypeEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<CatalogProductDiagnosticTypeEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<CatalogProductDiagnosticTypeEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<CatalogProductDiagnosticTypeEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<CatalogProductDiagnosticTypeEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<CatalogProductDiagnosticTypeEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<CatalogProductDiagnosticTypeEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<CatalogProductDiagnosticTypeEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<CatalogProductDiagnosticTypeEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<CatalogProductDiagnosticTypeEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<CatalogProductDiagnosticTypeEnum>;
};

export enum CatalogProductUnitsEnum {
  /** bag */
  Bag = 'bag',
  /** bags */
  Bags = 'bags',
  /** bottles */
  Bottles = 'bottles',
  /** boxes */
  Boxes = 'boxes',
  /** cans */
  Cans = 'cans',
  /** capsules */
  Capsules = 'capsules',
  /** case */
  Case = 'case',
  /** chews */
  Chews = 'chews',
  /** drops */
  Drops = 'drops',
  /** gm */
  Gm = 'gm',
  /** inch */
  Inch = 'inch',
  /** inhalations */
  Inhalations = 'inhalations',
  /** jar */
  Jar = 'jar',
  /** lb */
  Lb = 'lb',
  /** mEq */
  MEq = 'mEq',
  /** mL */
  ML = 'mL',
  /** mcg */
  Mcg = 'mcg',
  /** mg */
  Mg = 'mg',
  /** oz */
  Oz = 'oz',
  /** packets */
  Packets = 'packets',
  /** syringes */
  Syringes = 'syringes',
  /** tablets */
  Tablets = 'tablets',
  /** tubes */
  Tubes = 'tubes',
  /** units */
  Units = 'units',
  /** vials */
  Vials = 'vials',
  /** wipes */
  Wipes = 'wipes'
}

export type CatalogProductUnitsEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<CatalogProductUnitsEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<CatalogProductUnitsEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<CatalogProductUnitsEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<CatalogProductUnitsEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<CatalogProductUnitsEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<CatalogProductUnitsEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<CatalogProductUnitsEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<CatalogProductUnitsEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<CatalogProductUnitsEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<CatalogProductUnitsEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<CatalogProductUnitsEnum>;
};

export type ChatCtaFilter = {
  AND?: InputMaybe<ChatCtaFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ChatCtaFilter>;
  OR?: InputMaybe<ChatCtaFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
};

export type ChatCtaType = {
  __typename?: 'ChatCTAType';
  created: Scalars['DateTime']['output'];
  expirationTimingSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  route: CommunicationChatCtaRouteEnum;
  subtitle: Scalars['String']['output'];
  suggestedBody: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ClientCommunicationInput = {
  clinicalRecord: OneToOneInput;
  communicationType?: InputMaybe<Array<MedicalClientCommunicationCommunicationTypeEnum>>;
  documentationPurpose?: InputMaybe<Array<MedicalClientCommunicationDocumentationPurposeEnum>>;
  isSmartSummary?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<ManyToManyInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type ClientCommunicationInputPartial = {
  clinicalRecord?: InputMaybe<OneToOneInput>;
  communicationType?: InputMaybe<Array<MedicalClientCommunicationCommunicationTypeEnum>>;
  documentationPurpose?: InputMaybe<Array<MedicalClientCommunicationDocumentationPurposeEnum>>;
  id: Scalars['ID']['input'];
  isSmartSummary?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<ManyToManyInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type ClientCommunicationType = {
  __typename?: 'ClientCommunicationType';
  clinicalRecord: DjangoModelType;
  communicationType: Array<MedicalClientCommunicationCommunicationTypeEnum>;
  created: Scalars['DateTime']['output'];
  documentationPurpose: Array<MedicalClientCommunicationDocumentationPurposeEnum>;
  id: Scalars['ID']['output'];
  isSmartSummary: Scalars['Boolean']['output'];
  messages: Array<MessageType>;
  modified: Scalars['DateTime']['output'];
  smartSummaryTitle: Maybe<Scalars['String']['output']>;
  summary: Maybe<Scalars['String']['output']>;
};


export type ClientCommunicationTypeMessagesArgs = {
  filters: InputMaybe<MessageFilter>;
  order: InputMaybe<MessageOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};

export type ClientFilter = {
  AND?: InputMaybe<ClientFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ClientFilter>;
  OR?: InputMaybe<ClientFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClientFriendlyVaccineFilter = {
  AND?: InputMaybe<ClientFriendlyVaccineFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ClientFriendlyVaccineFilter>;
  OR?: InputMaybe<ClientFriendlyVaccineFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  name?: InputMaybe<StrFilterLookup>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClientFriendlyVaccineType = {
  __typename?: 'ClientFriendlyVaccineType';
  created: Scalars['DateTime']['output'];
  defaultSiteOfInjection: Maybe<MedicalClientFriendlyVaccineDefaultSiteOfInjectionEnum>;
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type ClientInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  apartment?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  household?: InputMaybe<OneToManyInput>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferencesCommunityEmail?: InputMaybe<Scalars['Boolean']['input']>;
  preferencesRemindersEmail?: InputMaybe<Scalars['Boolean']['input']>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  shippingApartment?: InputMaybe<Scalars['String']['input']>;
  shippingCity?: InputMaybe<Scalars['String']['input']>;
  shippingState?: InputMaybe<Scalars['String']['input']>;
  shippingZipcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type ClientInputPartial = {
  address?: InputMaybe<Scalars['String']['input']>;
  apartment?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  household?: InputMaybe<OneToManyInput>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferencesCommunityEmail?: InputMaybe<Scalars['Boolean']['input']>;
  preferencesRemindersEmail?: InputMaybe<Scalars['Boolean']['input']>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  shippingApartment?: InputMaybe<Scalars['String']['input']>;
  shippingCity?: InputMaybe<Scalars['String']['input']>;
  shippingState?: InputMaybe<Scalars['String']['input']>;
  shippingZipcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type ClientProcedureBookingInput = {
  pabwAppointment?: InputMaybe<AppointmentInput>;
  pickupLocationId?: InputMaybe<Scalars['String']['input']>;
  procedureAppointment: AppointmentInput;
  staffId?: InputMaybe<Scalars['String']['input']>;
};

export type ClientProcedureBookingType = {
  __typename?: 'ClientProcedureBookingType';
  appointments: Array<AppointmentType>;
};

export type ClientType = {
  __typename?: 'ClientType';
  address: Maybe<Scalars['String']['output']>;
  apartment: Maybe<Scalars['String']['output']>;
  birthdate: Maybe<Scalars['Date']['output']>;
  city: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  enableServiceMode: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  hasNotificationsEnabled: Maybe<Scalars['Boolean']['output']>;
  household: HouseholdType;
  id: Scalars['ID']['output'];
  image: Maybe<DjangoImageType>;
  lastName: Scalars['String']['output'];
  location: Maybe<Scalars['Point']['output']>;
  modified: Scalars['DateTime']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
  preferencesCommunityEmail: Scalars['Boolean']['output'];
  preferencesRemindersEmail: Scalars['Boolean']['output'];
  shippingAddress: Maybe<Scalars['String']['output']>;
  shippingApartment: Maybe<Scalars['String']['output']>;
  shippingCity: Maybe<Scalars['String']['output']>;
  shippingState: Maybe<Scalars['String']['output']>;
  shippingZipcode: Maybe<Scalars['String']['output']>;
  staff: Maybe<StaffType>;
  state: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  touches: Array<TouchType>;
  zipcode: Maybe<Scalars['String']['output']>;
};


export type ClientTypeTouchesArgs = {
  order: InputMaybe<TouchOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};

export type ClinicalNoteFilter = {
  AND?: InputMaybe<ClinicalNoteFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ClinicalNoteFilter>;
  OR?: InputMaybe<ClinicalNoteFilter>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClinicalNoteInput = {
  patient?: InputMaybe<OneToManyInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalNoteInputPartial = {
  id: Scalars['ID']['input'];
  patient?: InputMaybe<OneToManyInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalNoteType = {
  __typename?: 'ClinicalNoteType';
  created: Scalars['DateTime']['output'];
  datetime: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  location: Maybe<DjangoModelType>;
  modified: Scalars['DateTime']['output'];
  patient: Maybe<DjangoModelType>;
  text: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type ClinicalRecordFilter = {
  AND?: InputMaybe<ClinicalRecordFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ClinicalRecordFilter>;
  OR?: InputMaybe<ClinicalRecordFilter>;
  appointment?: InputMaybe<AppointmentFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isBlank?: InputMaybe<Scalars['Boolean']['input']>;
  patient?: InputMaybe<PatientFilter>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  signedAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
  staffId?: InputMaybe<Scalars['ID']['input']>;
  vitals?: InputMaybe<VitalsFilter>;
};

export type ClinicalRecordInput = {
  appointment?: InputMaybe<OneToManyInput>;
  assessment?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ManyToOneInput>;
  bodyMap?: InputMaybe<Scalars['Upload']['input']>;
  bodyMapNote?: InputMaybe<Scalars['String']['input']>;
  communication?: InputMaybe<OneToOneInput>;
  dental?: InputMaybe<Scalars['String']['input']>;
  expectedDiagnosticReporting?: InputMaybe<MedicalClinicalRecordExpectedDiagnosticReportingEnum>;
  intakeQuestions?: InputMaybe<OneToOneInput>;
  isReadyForSignature?: InputMaybe<Scalars['Boolean']['input']>;
  location: OneToManyInput;
  medicalNote?: InputMaybe<Scalars['String']['input']>;
  noteForDxTask?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['JSON']['input']>;
  objectiveText?: InputMaybe<Scalars['String']['input']>;
  patient: OneToManyInput;
  planNote?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  smartCareSummary?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  subjective?: InputMaybe<Scalars['String']['input']>;
  surgicalReport?: InputMaybe<Scalars['String']['input']>;
  vitals?: InputMaybe<OneToOneInput>;
};

export type ClinicalRecordInputPartial = {
  appointment?: InputMaybe<OneToManyInput>;
  assessment?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<ManyToOneInput>;
  bodyMap?: InputMaybe<Scalars['Upload']['input']>;
  bodyMapNote?: InputMaybe<Scalars['String']['input']>;
  communication?: InputMaybe<OneToOneInput>;
  dental?: InputMaybe<Scalars['String']['input']>;
  expectedDiagnosticReporting?: InputMaybe<MedicalClinicalRecordExpectedDiagnosticReportingEnum>;
  id: Scalars['ID']['input'];
  intakeQuestions?: InputMaybe<OneToOneInput>;
  isReadyForSignature?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<OneToManyInput>;
  medicalNote?: InputMaybe<Scalars['String']['input']>;
  noteForDxTask?: InputMaybe<Scalars['String']['input']>;
  objective?: InputMaybe<Scalars['JSON']['input']>;
  objectiveText?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<OneToManyInput>;
  planNote?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  smartCareSummary?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  subjective?: InputMaybe<Scalars['String']['input']>;
  surgicalReport?: InputMaybe<Scalars['String']['input']>;
  vitals?: InputMaybe<OneToOneInput>;
};

export type ClinicalRecordOrder = {
  created?: InputMaybe<Ordering>;
  modified?: InputMaybe<Ordering>;
};

export type ClinicalRecordTemplateFilter = {
  AND?: InputMaybe<ClinicalRecordTemplateFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ClinicalRecordTemplateFilter>;
  OR?: InputMaybe<ClinicalRecordTemplateFilter>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalRecordTemplateType = {
  __typename?: 'ClinicalRecordTemplateType';
  body: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  relevantSection: Maybe<MedicalClinicalRecordTemplateRelevantSectionEnum>;
};

export type ClinicalRecordType = {
  __typename?: 'ClinicalRecordType';
  anestheticNote: Maybe<Scalars['String']['output']>;
  appointment: Maybe<AppointmentType>;
  assessment: Maybe<Scalars['String']['output']>;
  attachments: Array<AttachmentType>;
  audioToTextTiming: Maybe<Scalars['Int']['output']>;
  bodyMap: Maybe<DjangoImageType>;
  bodyMapNote: Maybe<Scalars['String']['output']>;
  careSummary: Maybe<Scalars['String']['output']>;
  chiefComplaint: Maybe<Scalars['String']['output']>;
  clientCommunication: Maybe<Scalars['String']['output']>;
  communication: Maybe<ClientCommunicationType>;
  created: Scalars['DateTime']['output'];
  dental: Maybe<Scalars['String']['output']>;
  dispenses: Array<DispenseType>;
  estimates: Array<EstimateType>;
  expectedDiagnosticReporting: Maybe<MedicalClinicalRecordExpectedDiagnosticReportingEnum>;
  generatedAssessment: Maybe<Scalars['String']['output']>;
  generatedObjective: Maybe<Scalars['String']['output']>;
  generatedSubjective: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intakeQuestions: Maybe<IntakeQuestionsType>;
  integratedDiagnostics: Array<IntegratedDiagnosticType>;
  invoice: Maybe<InvoiceType>;
  isBlank: Scalars['Boolean']['output'];
  isReadyForSignature: Scalars['Boolean']['output'];
  location: LocationType;
  medicalNote: Maybe<Scalars['String']['output']>;
  modified: Scalars['DateTime']['output'];
  nonIntegratedDiagnostics: Array<NonIntegratedDiagnosticType>;
  noteForDxTask: Maybe<Scalars['String']['output']>;
  objective: Maybe<Scalars['JSON']['output']>;
  objectiveText: Maybe<Scalars['String']['output']>;
  patient: PatientType;
  plan: Maybe<Scalars['String']['output']>;
  planNote: Maybe<Scalars['String']['output']>;
  prescriptions: Array<PrescriptionType>;
  signedAt: Maybe<Scalars['DateTime']['output']>;
  smartCareSummary: Maybe<Scalars['String']['output']>;
  smartCareSummaryGeneratedAt: Maybe<Scalars['DateTime']['output']>;
  smartCareSummaryGenerationTime: Maybe<Scalars['Float']['output']>;
  smartCareSummaryOriginal: Maybe<Scalars['String']['output']>;
  staff: Maybe<StaffType>;
  starRatings: Array<StarRatingsType>;
  subjective: Maybe<Scalars['String']['output']>;
  surgicalReport: Maybe<Scalars['String']['output']>;
  transcriptionAudio: Maybe<DjangoFileType>;
  transcriptionModel: Maybe<MedicalClinicalRecordTranscriptionModelEnum>;
  transcriptionText: Maybe<Scalars['String']['output']>;
  vaccines: Array<VaccineType>;
  visitDetails: Scalars['String']['output'];
  vitals: Maybe<VitalsType>;
};


export type ClinicalRecordTypeAttachmentsArgs = {
  filters: InputMaybe<AttachmentFilter>;
};


export type ClinicalRecordTypeDispensesArgs = {
  filters: InputMaybe<DispenseFilter>;
  order: InputMaybe<DispenseOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type ClinicalRecordTypeEstimatesArgs = {
  filters: InputMaybe<EstimateFilter>;
  order: InputMaybe<EstimateOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type ClinicalRecordTypeIntegratedDiagnosticsArgs = {
  filters: InputMaybe<IntegratedDiagnosticFilter>;
  order: InputMaybe<IntegratedDiagnosticOrder>;
};


export type ClinicalRecordTypeNonIntegratedDiagnosticsArgs = {
  filters: InputMaybe<NonIntegratedDiagnosticFilter>;
  order: InputMaybe<NonIntegratedDiagnosticOrder>;
};


export type ClinicalRecordTypePlanArgs = {
  format?: Scalars['String']['input'];
};


export type ClinicalRecordTypePrescriptionsArgs = {
  filters: InputMaybe<PrescriptionFilter>;
  order: InputMaybe<PrescriptionOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type ClinicalRecordTypeStarRatingsArgs = {
  filters: InputMaybe<StarRatingsFilter>;
};


export type ClinicalRecordTypeVaccinesArgs = {
  filters: InputMaybe<VaccineFilter>;
  order: InputMaybe<VaccineOrder>;
};

export type ColorFilter = {
  AND?: InputMaybe<ColorFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ColorFilter>;
  OR?: InputMaybe<ColorFilter>;
  species?: InputMaybe<CustomerColorSpeciesEnum>;
};

export type ColorType = {
  __typename?: 'ColorType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum CommunicationChatCtaRouteEnum {
  /** BookAppointment */
  BookAppointment = 'BookAppointment',
  /** BookProcedureOverview */
  BookProcedureOverview = 'BookProcedureOverview',
  /** BookUrgentCare */
  BookUrgentCare = 'BookUrgentCare',
  /** ManageAutoshipTab */
  ManageAutoshipTab = 'ManageAutoshipTab',
  /** PrescriptionRefill */
  PrescriptionRefill = 'PrescriptionRefill',
  /** VirtualScreen */
  VirtualScreen = 'VirtualScreen'
}

export enum CommunicationCommunicationTemplateCategoryEnum {
  /** ACCOUNT */
  Account = 'ACCOUNT',
  /** PROMOTIONS */
  Promotions = 'PROMOTIONS',
  /** REMINDERS */
  Reminders = 'REMINDERS'
}

export enum CommunicationCommunicationTemplateNotifCategoryEnum {
  /** ACCOUNT */
  Account = 'ACCOUNT',
  /** APPOINTMENTS */
  Appointments = 'APPOINTMENTS',
  /** AUTOSHIP */
  Autoship = 'AUTOSHIP',
  /** BILLING */
  Billing = 'BILLING',
  /** CARE_PLAN */
  CarePlan = 'CARE_PLAN',
  /** CHAT */
  Chat = 'CHAT',
  /** PRESCRIPTIONS */
  Prescriptions = 'PRESCRIPTIONS',
  /** RECORDS */
  Records = 'RECORDS',
  /** VIRTUAL_CARE */
  VirtualCare = 'VIRTUAL_CARE',
  /** WELCOME */
  Welcome = 'WELCOME'
}

export enum CommunicationCommunicationTemplateNotifCtaRouteEnum {
  /** AddAdditionalRecordScreen */
  AddAdditionalRecordScreen = 'AddAdditionalRecordScreen',
  /** ApptDetail */
  ApptDetail = 'ApptDetail',
  /** BookAppointment */
  BookAppointment = 'BookAppointment',
  /** BookProcedureOverviewScreen */
  BookProcedureOverviewScreen = 'BookProcedureOverviewScreen',
  /** CarePlanListScreen */
  CarePlanListScreen = 'CarePlanListScreen',
  /** CareSummariesListScreen */
  CareSummariesListScreen = 'CareSummariesListScreen',
  /** ChatScreen */
  ChatScreen = 'ChatScreen',
  /** CheckoutScreen */
  CheckoutScreen = 'CheckoutScreen',
  /** DeliveryMethodAndAutoshipScreen */
  DeliveryMethodAndAutoshipScreen = 'DeliveryMethodAndAutoshipScreen',
  /** DiagnosticSummariesListScreen */
  DiagnosticSummariesListScreen = 'DiagnosticSummariesListScreen',
  /** DiagnosticSummaryScreen */
  DiagnosticSummaryScreen = 'DiagnosticSummaryScreen',
  /** EstimateDetailScreen */
  EstimateDetailScreen = 'EstimateDetailScreen',
  /** FollowUpScreen */
  FollowUpScreen = 'FollowUpScreen',
  /** InvoiceDetailScreen */
  InvoiceDetailScreen = 'InvoiceDetailScreen',
  /** ManageAutoshipScreen */
  ManageAutoshipScreen = 'ManageAutoshipScreen',
  /** OrderConfirmationScreen */
  OrderConfirmationScreen = 'OrderConfirmationScreen',
  /** PDFScreen */
  PdfScreen = 'PDFScreen',
  /** PaywallSelectPlanScreen */
  PaywallSelectPlanScreen = 'PaywallSelectPlanScreen',
  /** PetProfileScreen */
  PetProfileScreen = 'PetProfileScreen',
  /** PharmacyHubScreen */
  PharmacyHubScreen = 'PharmacyHubScreen',
  /** PrescriptionListScreen */
  PrescriptionListScreen = 'PrescriptionListScreen',
  /** VirtualScreen */
  VirtualScreen = 'VirtualScreen',
  /** WhatToExpectScreen */
  WhatToExpectScreen = 'WhatToExpectScreen'
}

export enum CommunicationCommunicationTemplateNotifStatusEnum {
  /** FAILURE */
  Failure = 'FAILURE',
  /** INFO */
  Info = 'INFO',
  /** SUCCESS */
  Success = 'SUCCESS',
  /** WARNING */
  Warning = 'WARNING'
}

export enum CommunicationConversationAssignedRoleEnum {
  /** CLINIC_SUCCESS */
  ClinicSuccess = 'CLINIC_SUCCESS',
  /** CUSTOMER_SERVICE */
  CustomerService = 'CUSTOMER_SERVICE',
  /** MEDICAL_TEAM */
  MedicalTeam = 'MEDICAL_TEAM',
  /** PRESCRIPTIONS_TEAM */
  PrescriptionsTeam = 'PRESCRIPTIONS_TEAM'
}

export enum CommunicationInteractionAssignedRoleEnum {
  /** CLINIC_SUCCESS */
  ClinicSuccess = 'CLINIC_SUCCESS',
  /** CUSTOMER_SERVICE */
  CustomerService = 'CUSTOMER_SERVICE',
  /** MEDICAL_TEAM */
  MedicalTeam = 'MEDICAL_TEAM',
  /** PRESCRIPTIONS_TEAM */
  PrescriptionsTeam = 'PRESCRIPTIONS_TEAM'
}

export enum CommunicationInteractionInteractionTypeEnum {
  /** CHAT */
  Chat = 'CHAT',
  /** EMAIL */
  Email = 'EMAIL',
  /** INBOUND_CALL */
  InboundCall = 'INBOUND_CALL',
  /** NOTIFICATION */
  Notification = 'NOTIFICATION',
  /** ONDEMAND_VIDEO */
  OndemandVideo = 'ONDEMAND_VIDEO',
  /** OUTBOUND_CALL */
  OutboundCall = 'OUTBOUND_CALL',
  /** SCHEDULED_VIDEO */
  ScheduledVideo = 'SCHEDULED_VIDEO',
  /** SMS */
  Sms = 'SMS'
}

export type CommunicationTemplateFilter = {
  AND?: InputMaybe<CommunicationTemplateFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<CommunicationTemplateFilter>;
  OR?: InputMaybe<CommunicationTemplateFilter>;
  triggerKey?: InputMaybe<StrFilterLookup>;
};

export type CommunicationTemplateType = {
  __typename?: 'CommunicationTemplateType';
  category: CommunicationCommunicationTemplateCategoryEnum;
  chatBody: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  implementationNotes: Maybe<Scalars['String']['output']>;
  modified: Scalars['DateTime']['output'];
  notifBody: Maybe<Scalars['String']['output']>;
  notifCategory: Maybe<CommunicationCommunicationTemplateNotifCategoryEnum>;
  notifCtaRoute: Maybe<CommunicationCommunicationTemplateNotifCtaRouteEnum>;
  notifCtaTitle: Maybe<Scalars['String']['output']>;
  notifStatus: Maybe<CommunicationCommunicationTemplateNotifStatusEnum>;
  /** @deprecated Forwardfill the notif_cta_route field for newer versions of the app */
  overrideNotifCtaRoute: Maybe<Scalars['String']['output']>;
  ruleFilterInactive: Scalars['Boolean']['output'];
  sendgridDynamicTemplate: Maybe<Scalars['String']['output']>;
  smsBody: Maybe<Scalars['String']['output']>;
  triggerKey: Scalars['String']['output'];
};

export type ConditionResolutionInput = {
  conditionName: Scalars['String']['input'];
  patient: OneToManyInput;
  staff: OneToManyInput;
  status: MedicalConditionResolutionStatusEnum;
};

export type ConditionResolutionType = {
  __typename?: 'ConditionResolutionType';
  conditionName: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  patient: DjangoModelType;
  staff: DjangoModelType;
  status: MedicalConditionResolutionStatusEnum;
};

export type ConfirmationType = {
  __typename?: 'ConfirmationType';
  ok: Scalars['Boolean']['output'];
};

export type ConversationFilter = {
  AND?: InputMaybe<ConversationFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ConversationFilter>;
  OR?: InputMaybe<ConversationFilter>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  household?: InputMaybe<HouseholdFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  messages?: InputMaybe<MessageFilter>;
  patient?: InputMaybe<PatientFilter>;
};

export type ConversationInput = {
  appointment?: InputMaybe<OneToOneInput>;
  assignedRole?: InputMaybe<CommunicationConversationAssignedRoleEnum>;
  household?: InputMaybe<OneToManyInput>;
  patient: OneToManyInput;
  reasonForConversation: Scalars['String']['input'];
};

export type ConversationOrder = {
  created?: InputMaybe<Ordering>;
};

export type ConversationPredictionType = {
  __typename?: 'ConversationPredictionType';
  classification: Scalars['String']['output'];
  generationTiming: Maybe<Scalars['Int']['output']>;
  model: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  prediction: Scalars['String']['output'];
  useMessageEmbeddings: Scalars['Boolean']['output'];
};

export type ConversationType = {
  __typename?: 'ConversationType';
  appointment: Maybe<AppointmentType>;
  assignedRole: CommunicationConversationAssignedRoleEnum;
  created: Scalars['DateTime']['output'];
  /** @deprecated Use patient instead */
  household: HouseholdType;
  id: Scalars['ID']['output'];
  interactionSet: Array<InteractionType>;
  /** @deprecated Use nested graphql query instead */
  lastMessage: Maybe<MessageType>;
  /** @deprecated Use nested graphql query instead */
  lastMessageIndex: Scalars['Int']['output'];
  messages: Array<MessageType>;
  modified: Scalars['DateTime']['output'];
  patient: PatientType;
  reasonForConversation: Scalars['String']['output'];
};


export type ConversationTypeInteractionSetArgs = {
  filters: InputMaybe<InteractionFilter>;
  order: InputMaybe<InteractionOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type ConversationTypeMessagesArgs = {
  filters: InputMaybe<MessageFilter>;
  order: InputMaybe<MessageOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};

export type CreditCardFilter = {
  AND?: InputMaybe<CreditCardFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<CreditCardFilter>;
  OR?: InputMaybe<CreditCardFilter>;
  household?: InputMaybe<HouseholdFilter>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreditCardInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingApartment?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZipcode?: InputMaybe<Scalars['String']['input']>;
  creditCardNumber?: InputMaybe<Scalars['String']['input']>;
  cvv?: InputMaybe<Scalars['String']['input']>;
  expirationDate: Scalars['Date']['input'];
  household: OneToManyInput;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CreditCardInputPartial = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingApartment?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZipcode?: InputMaybe<Scalars['String']['input']>;
  creditCardNumber?: InputMaybe<Scalars['String']['input']>;
  cvv?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  household?: InputMaybe<OneToManyInput>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CreditCardType = {
  __typename?: 'CreditCardType';
  additionalInfo: Maybe<Scalars['String']['output']>;
  billingAddress: Maybe<Scalars['String']['output']>;
  billingApartment: Maybe<Scalars['String']['output']>;
  billingCity: Maybe<Scalars['String']['output']>;
  billingState: Maybe<Scalars['String']['output']>;
  billingZipcode: Maybe<Scalars['String']['output']>;
  binInfoProduct: Maybe<BillingCreditCardBinInfoProductEnum>;
  created: Scalars['DateTime']['output'];
  creditCardNumber: Maybe<Scalars['String']['output']>;
  cvv: Maybe<Scalars['String']['output']>;
  expirationDate: Scalars['Date']['output'];
  household: DjangoModelType;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  issuer: Maybe<Scalars['String']['output']>;
  lastFour: Maybe<Scalars['String']['output']>;
  modified: Scalars['DateTime']['output'];
  primary: Scalars['Boolean']['output'];
  token: Maybe<Scalars['String']['output']>;
};

export enum CustomerAutoshipSourceEnum {
  /** APP */
  App = 'APP',
  /** CLAUDE */
  Claude = 'CLAUDE',
  /** RENEWAL */
  Renewal = 'RENEWAL'
}

export enum CustomerAutoshipStatusEnum {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** CANCELED */
  Canceled = 'CANCELED',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** PAUSED */
  Paused = 'PAUSED',
  /** SKIPPED */
  Skipped = 'SKIPPED'
}

export type CustomerAutoshipStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<CustomerAutoshipStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<CustomerAutoshipStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<CustomerAutoshipStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<CustomerAutoshipStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<CustomerAutoshipStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<CustomerAutoshipStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<CustomerAutoshipStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<CustomerAutoshipStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<CustomerAutoshipStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<CustomerAutoshipStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<CustomerAutoshipStatusEnum>;
};

export enum CustomerBreedSpeciesEnum {
  /** Cat */
  Cat = 'Cat',
  /** Dog */
  Dog = 'Dog'
}

export enum CustomerColorSpeciesEnum {
  /** Cat */
  Cat = 'Cat',
  /** Dog */
  Dog = 'Dog'
}

export enum CustomerInboundMedicalRecordRequestStatusEnum {
  /** AWAITING_CLINIC */
  AwaitingClinic = 'AWAITING_CLINIC',
  /** AWAITING_MEMBERSHIP */
  AwaitingMembership = 'AWAITING_MEMBERSHIP',
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** COMPLETED_DELAYED */
  CompletedDelayed = 'COMPLETED_DELAYED',
  /** DUPLICATE */
  Duplicate = 'DUPLICATE',
  /** PENDING_AGENT */
  PendingAgent = 'PENDING_AGENT',
  /** UNRESPONSIVE */
  Unresponsive = 'UNRESPONSIVE'
}

export enum CustomerMembershipNextDesiredTierEnum {
  /** ALL_ACCESS */
  AllAccess = 'ALL_ACCESS',
  /** ESSENTIAL */
  Essential = 'ESSENTIAL',
  /** PAY_AS_YOU_GO */
  PayAsYouGo = 'PAY_AS_YOU_GO'
}

export enum CustomerMembershipReasonForChangeEnum {
  /** Deceased */
  Deceased = 'Deceased',
  /** Inconvenient location */
  InconvenientLocation = 'Inconvenient_location',
  /** Moving out of the area */
  MovingOutOfTheArea = 'Moving_out_of_the_area',
  /** No longer have pet */
  NoLongerHavePet = 'No_longer_have_pet',
  /** Not satisfied with services */
  NotSatisfiedWithServices = 'Not_satisfied_with_services',
  /** Other */
  Other = 'Other',
  /** Payment Failure */
  PaymentFailure = 'Payment_Failure',
  /** Prefer another plan */
  PreferAnotherPlan = 'Prefer_another_plan',
  /** Too expensive */
  TooExpensive = 'Too_expensive'
}

export enum CustomerMembershipTierEnum {
  /** ALL_ACCESS */
  AllAccess = 'ALL_ACCESS',
  /** ESSENTIAL */
  Essential = 'ESSENTIAL',
  /** PAY_AS_YOU_GO */
  PayAsYouGo = 'PAY_AS_YOU_GO'
}

export type CustomerMembershipTierEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<CustomerMembershipTierEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<CustomerMembershipTierEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<CustomerMembershipTierEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<CustomerMembershipTierEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<CustomerMembershipTierEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<CustomerMembershipTierEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<CustomerMembershipTierEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<CustomerMembershipTierEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<CustomerMembershipTierEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<CustomerMembershipTierEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<CustomerMembershipTierEnum>;
};

export enum CustomerMergeLogKindEnum {
  MergeHousehold = 'MERGE_HOUSEHOLD',
  MergePatient = 'MERGE_PATIENT',
  MovePatient = 'MOVE_PATIENT',
  UnmergeClient = 'UNMERGE_CLIENT'
}

export enum CustomerPatientCancellationReasonEnum {
  /** Deceased */
  Deceased = 'Deceased',
  /** Inconvenient location */
  InconvenientLocation = 'Inconvenient_location',
  /** Moving out of the area */
  MovingOutOfTheArea = 'Moving_out_of_the_area',
  /** No longer have pet */
  NoLongerHavePet = 'No_longer_have_pet',
  /** Not satisfied with services */
  NotSatisfiedWithServices = 'Not_satisfied_with_services',
  /** Other, */
  Other = 'Other_',
  /** Payment Failure */
  PaymentFailure = 'Payment_Failure',
  /** Prefer to pay as I go */
  PreferToPayAsIGo = 'Prefer_to_pay_as_I_go',
  /** Too expensive */
  TooExpensive = 'Too_expensive'
}

export enum CustomerPatientRecordsAvailabilityEnum {
  /** NO_RECORDS */
  NoRecords = 'NO_RECORDS',
  /** PENDING_CLIENT */
  PendingClient = 'PENDING_CLIENT',
  /** RECORDS_FINALIZED */
  RecordsFinalized = 'RECORDS_FINALIZED',
  /** RECORDS_NEEDED */
  RecordsNeeded = 'RECORDS_NEEDED'
}

export enum CustomerPatientSexEnum {
  /** Female */
  F = 'F',
  /** Male */
  M = 'M'
}

export enum CustomerPatientSpeciesEnum {
  /** Cat */
  Cat = 'Cat',
  /** Dog */
  Dog = 'Dog'
}

export enum CustomerTouchSourceEnum {
  /** APP */
  App = 'APP',
  /** CLAUDE */
  Claude = 'CLAUDE',
  /** NEWSLETTER */
  Newsletter = 'NEWSLETTER',
  /** SCHEDULER */
  Scheduler = 'SCHEDULER',
  /** TEST_PANEL */
  TestPanel = 'TEST_PANEL',
  /** WAITLIST */
  Waitlist = 'WAITLIST',
  /** WEBSITE */
  Website = 'WEBSITE'
}

export type DateDateFilterLookup = {
  day?: InputMaybe<IntComparisonFilterLookup>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than. Filter will be skipped on `null` value */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than or equal to. Filter will be skipped on `null` value */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isoWeekDay?: InputMaybe<IntComparisonFilterLookup>;
  isoYear?: InputMaybe<IntComparisonFilterLookup>;
  /** Less than. Filter will be skipped on `null` value */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** Less than or equal to. Filter will be skipped on `null` value */
  lte?: InputMaybe<Scalars['Date']['input']>;
  month?: InputMaybe<IntComparisonFilterLookup>;
  quarter?: InputMaybe<IntComparisonFilterLookup>;
  /** Inclusive range test (between) */
  range?: InputMaybe<DateRangeLookup>;
  week?: InputMaybe<IntComparisonFilterLookup>;
  weekDay?: InputMaybe<IntComparisonFilterLookup>;
  year?: InputMaybe<IntComparisonFilterLookup>;
};

export type DateRangeLookup = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type DatetimeDatetimeFilterLookup = {
  date?: InputMaybe<IntComparisonFilterLookup>;
  day?: InputMaybe<IntComparisonFilterLookup>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['DateTime']['input']>;
  /** Greater than. Filter will be skipped on `null` value */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Greater than or equal to. Filter will be skipped on `null` value */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  hour?: InputMaybe<IntComparisonFilterLookup>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isoWeekDay?: InputMaybe<IntComparisonFilterLookup>;
  isoYear?: InputMaybe<IntComparisonFilterLookup>;
  /** Less than. Filter will be skipped on `null` value */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Less than or equal to. Filter will be skipped on `null` value */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  minute?: InputMaybe<IntComparisonFilterLookup>;
  month?: InputMaybe<IntComparisonFilterLookup>;
  quarter?: InputMaybe<IntComparisonFilterLookup>;
  /** Inclusive range test (between) */
  range?: InputMaybe<DatetimeRangeLookup>;
  second?: InputMaybe<IntComparisonFilterLookup>;
  time?: InputMaybe<IntComparisonFilterLookup>;
  week?: InputMaybe<IntComparisonFilterLookup>;
  weekDay?: InputMaybe<IntComparisonFilterLookup>;
  year?: InputMaybe<IntComparisonFilterLookup>;
};

export type DatetimeRangeLookup = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DiagnosticTestResultFilter = {
  AND?: InputMaybe<DiagnosticTestResultFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<DiagnosticTestResultFilter>;
  OR?: InputMaybe<DiagnosticTestResultFilter>;
  clinicalRecord?: InputMaybe<ClinicalRecordFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  integratedDiagnostic?: InputMaybe<IntegratedDiagnosticFilter>;
  nonIntegratedDiagnostic?: InputMaybe<NonIntegratedDiagnosticFilter>;
  status?: InputMaybe<MedicalDiagnosticTestResultStatusEnumFilterLookup>;
};

export type DiagnosticTestResultInput = {
  addOnStatus?: InputMaybe<MedicalDiagnosticTestResultAddOnStatusEnum>;
  clinicalRecord: OneToManyInput;
  integratedDiagnostic?: InputMaybe<OneToManyInput>;
  internalInterpretation?: InputMaybe<Scalars['String']['input']>;
  interpretationSummary?: InputMaybe<Scalars['String']['input']>;
  interpreter?: InputMaybe<OneToManyInput>;
  invoice?: InputMaybe<OneToManyInput>;
  nonIntegratedDiagnostic?: InputMaybe<OneToManyInput>;
  partialInternalInterpretation?: InputMaybe<Scalars['String']['input']>;
  partialInterpretationSummary?: InputMaybe<Scalars['String']['input']>;
  partialInterpreter?: InputMaybe<OneToManyInput>;
  partialReviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  partialSmartInterpretationSummary?: InputMaybe<Scalars['String']['input']>;
  reviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  smartInterpretationSummary?: InputMaybe<Scalars['String']['input']>;
  staff: OneToManyInput;
  status?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  tests?: InputMaybe<ManyToManyInput>;
};

export type DiagnosticTestResultInputPartial = {
  addOnIsRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  addOnStatus?: InputMaybe<MedicalDiagnosticTestResultAddOnStatusEnum>;
  clinicalRecord?: InputMaybe<OneToManyInput>;
  declinedTests?: InputMaybe<ManyToManyInput>;
  id: Scalars['ID']['input'];
  integratedDiagnostic?: InputMaybe<OneToManyInput>;
  internalInterpretation?: InputMaybe<Scalars['String']['input']>;
  interpretationSummary?: InputMaybe<Scalars['String']['input']>;
  interpreter?: InputMaybe<OneToManyInput>;
  invoice?: InputMaybe<OneToManyInput>;
  isNewInterpretation?: InputMaybe<Scalars['Boolean']['input']>;
  nonIntegratedDiagnostic?: InputMaybe<OneToManyInput>;
  partialInternalInterpretation?: InputMaybe<Scalars['String']['input']>;
  partialInterpretationSummary?: InputMaybe<Scalars['String']['input']>;
  partialInterpreter?: InputMaybe<OneToManyInput>;
  partialReviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  partialSmartInterpretationSummary?: InputMaybe<Scalars['String']['input']>;
  reviewedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rxIsRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSendInterpretation?: InputMaybe<Scalars['Boolean']['input']>;
  smartInterpretationSummary?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  status?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  tests?: InputMaybe<ManyToManyInput>;
};

export type DiagnosticTestResultOrder = {
  created?: InputMaybe<Ordering>;
};

export type DiagnosticTestResultType = {
  __typename?: 'DiagnosticTestResultType';
  accessionId: Maybe<Scalars['String']['output']>;
  addOnStatus: Maybe<MedicalDiagnosticTestResultAddOnStatusEnum>;
  clinicalRecord: Maybe<ClinicalRecordType>;
  created: Scalars['DateTime']['output'];
  declinedTests: Array<ProductType>;
  history: Array<HistoricalDiagnosticTestResultType>;
  id: Scalars['ID']['output'];
  integratedDiagnostic: Maybe<IntegratedDiagnosticType>;
  internalInterpretation: Maybe<Scalars['String']['output']>;
  interpretationChangedSinceLastSent: Scalars['Boolean']['output'];
  interpretationSummary: Maybe<Scalars['String']['output']>;
  interpreter: Maybe<StaffType>;
  invoice: Maybe<InvoiceType>;
  isInhouseIntegratedDiagnostic: Scalars['Boolean']['output'];
  isInhouseNonIntegratedDiagnostic: Scalars['Boolean']['output'];
  isReferenceIntegratedDiagnostic: Scalars['Boolean']['output'];
  isReferenceNonIntegratedDiagnostic: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  nonIntegratedDiagnostic: Maybe<NonIntegratedDiagnosticType>;
  partialInternalInterpretation: Maybe<Scalars['String']['output']>;
  partialInterpretationChangedSinceLastSent: Scalars['Boolean']['output'];
  partialInterpretationSummary: Maybe<Scalars['String']['output']>;
  partialInterpreter: Maybe<StaffType>;
  partialReviewedAt: Maybe<Scalars['DateTime']['output']>;
  partialSmartInternalInterpretation: Maybe<Scalars['String']['output']>;
  partialSmartInternalInterpretationFull: Maybe<Scalars['String']['output']>;
  partialSmartInterpretationSummary: Maybe<Scalars['String']['output']>;
  pdfDownloadedAt: Maybe<Scalars['DateTime']['output']>;
  pdfUrl: Maybe<Scalars['String']['output']>;
  prescriptions: Array<PrescriptionType>;
  resultId: Maybe<Scalars['String']['output']>;
  resultPdf: Maybe<DjangoFileType>;
  resultUrl: Maybe<Scalars['String']['output']>;
  reviewedAt: Maybe<Scalars['DateTime']['output']>;
  smartInternalInterpretation: Maybe<Scalars['String']['output']>;
  smartInternalInterpretationFull: Maybe<Scalars['String']['output']>;
  smartInterpretationSummary: Maybe<Scalars['String']['output']>;
  staff: StaffType;
  status: Maybe<MedicalDiagnosticTestResultStatusEnum>;
  tests: Array<ProductType>;
  uiUrl: Maybe<Scalars['String']['output']>;
};


export type DiagnosticTestResultTypeDeclinedTestsArgs = {
  filters: InputMaybe<ProductFilter>;
  order: InputMaybe<ProductOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type DiagnosticTestResultTypeHistoryArgs = {
  filters: InputMaybe<HistoricalDiagnosticTestResultFilter>;
  order: InputMaybe<HistoricalDiagnosticTestResultOrder>;
};


export type DiagnosticTestResultTypePrescriptionsArgs = {
  filters: InputMaybe<PrescriptionFilter>;
  order: InputMaybe<PrescriptionOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type DiagnosticTestResultTypeTestsArgs = {
  filters: InputMaybe<ProductFilter>;
  order: InputMaybe<ProductOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};

export type DifferentialFilter = {
  AND?: InputMaybe<DifferentialFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<DifferentialFilter>;
  OR?: InputMaybe<DifferentialFilter>;
  patient?: InputMaybe<PatientFilter>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<MedicalDifferentialStatusEnumFilterLookup>;
};

export type DifferentialInputPartial = {
  clinicalRecord?: InputMaybe<OneToManyInput>;
  diagnosisDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<OneToManyInput>;
  status?: InputMaybe<MedicalDifferentialStatusEnum>;
};

export type DifferentialOrder = {
  created?: InputMaybe<Ordering>;
};

export type DifferentialType = {
  __typename?: 'DifferentialType';
  clinicalRecord: Maybe<ClinicalRecordType>;
  created: Scalars['DateTime']['output'];
  diagnosisDate: Maybe<Scalars['DateTime']['output']>;
  doctorName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  note: Maybe<Scalars['String']['output']>;
  patient: DjangoModelType;
  problem: ProblemType;
  status: MedicalDifferentialStatusEnum;
};

export type DispenseFilter = {
  AND?: InputMaybe<DispenseFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<DispenseFilter>;
  OR?: InputMaybe<DispenseFilter>;
  clinicalRecord?: InputMaybe<ClinicalRecordFilter>;
  dispenseDate?: InputMaybe<DateDateFilterLookup>;
  fulfillmentPreference?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnumFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
  invoiceItem?: InputMaybe<InvoiceItemFilter>;
  isAutoship?: InputMaybe<Scalars['Boolean']['input']>;
  prescription?: InputMaybe<PrescriptionFilter>;
  product?: InputMaybe<ProductFilter>;
  status?: InputMaybe<MedicalDispenseStatusEnumFilterLookup>;
  vetsourceId?: InputMaybe<StrFilterLookup>;
};

export type DispenseInput = {
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<MedicalDispenseCancellationReasonEnum>;
  clinicalRecord?: InputMaybe<OneToManyInput>;
  creditCardId?: InputMaybe<Scalars['String']['input']>;
  dispenseDate?: InputMaybe<Scalars['Date']['input']>;
  fulfillmentPreference?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  invoiceItem?: InputMaybe<OneToManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<OneToManyInput>;
  prescription: OneToManyInput;
  product: OneToManyInput;
  quantity?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  shippingApartment?: InputMaybe<Scalars['String']['input']>;
  shippingCity?: InputMaybe<Scalars['String']['input']>;
  shippingState?: InputMaybe<Scalars['String']['input']>;
  shippingZipcode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MedicalDispenseSourceEnum>;
  status?: InputMaybe<MedicalDispenseStatusEnum>;
  trackingCarrier?: InputMaybe<Scalars['String']['input']>;
  trackingLink?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DispenseInputPartial = {
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<MedicalDispenseCancellationReasonEnum>;
  clinicalRecord?: InputMaybe<OneToManyInput>;
  creditCardId?: InputMaybe<Scalars['String']['input']>;
  dispenseDate?: InputMaybe<Scalars['Date']['input']>;
  fulfillmentPreference?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  id: Scalars['ID']['input'];
  invoiceItem?: InputMaybe<OneToManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<OneToManyInput>;
  prescription?: InputMaybe<OneToManyInput>;
  product?: InputMaybe<OneToManyInput>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  shippingApartment?: InputMaybe<Scalars['String']['input']>;
  shippingCity?: InputMaybe<Scalars['String']['input']>;
  shippingState?: InputMaybe<Scalars['String']['input']>;
  shippingZipcode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MedicalDispenseSourceEnum>;
  status?: InputMaybe<MedicalDispenseStatusEnum>;
  trackingCarrier?: InputMaybe<Scalars['String']['input']>;
  trackingLink?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DispenseInputWithCreditCard = {
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<MedicalDispenseCancellationReasonEnum>;
  clinicalRecord?: InputMaybe<OneToManyInput>;
  creditCardId?: InputMaybe<Scalars['String']['input']>;
  dispenseDate?: InputMaybe<Scalars['Date']['input']>;
  fulfillmentPreference?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  invoiceItem?: InputMaybe<OneToManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<OneToManyInput>;
  prescription: OneToManyInput;
  product: OneToManyInput;
  quantity?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  shippingApartment?: InputMaybe<Scalars['String']['input']>;
  shippingCity?: InputMaybe<Scalars['String']['input']>;
  shippingState?: InputMaybe<Scalars['String']['input']>;
  shippingZipcode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MedicalDispenseSourceEnum>;
  status?: InputMaybe<MedicalDispenseStatusEnum>;
  trackingCarrier?: InputMaybe<Scalars['String']['input']>;
  trackingLink?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DispenseOrder = {
  dispenseDate?: InputMaybe<Ordering>;
  dispenseDatetime?: InputMaybe<Ordering>;
};

export type DispenseStatusHistoryType = {
  __typename?: 'DispenseStatusHistoryType';
  status: Scalars['String']['output'];
  statusDate: Scalars['DateTime']['output'];
};

export type DispenseType = {
  __typename?: 'DispenseType';
  cancellationNote: Maybe<Scalars['String']['output']>;
  cancellationReason: Maybe<MedicalDispenseCancellationReasonEnum>;
  clinicalRecord: Maybe<DjangoModelType>;
  created: Scalars['DateTime']['output'];
  dispenseDate: Scalars['Date']['output'];
  fulfillmentPreference: MedicalDispenseFulfillmentPreferenceEnum;
  id: Scalars['ID']['output'];
  invoiceItem: Maybe<InvoiceItemType>;
  isAutoship: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  note: Maybe<Scalars['String']['output']>;
  pickupLocation: Maybe<LocationType>;
  prescription: PrescriptionType;
  product: ProductType;
  quantity: Scalars['Decimal']['output'];
  shippingAddress: Maybe<Scalars['String']['output']>;
  shippingApartment: Maybe<Scalars['String']['output']>;
  shippingCity: Maybe<Scalars['String']['output']>;
  shippingState: Maybe<Scalars['String']['output']>;
  shippingZipcode: Maybe<Scalars['String']['output']>;
  source: MedicalDispenseSourceEnum;
  status: MedicalDispenseStatusEnum;
  statusHistory: Array<DispenseStatusHistoryType>;
  statusLastModified: Maybe<Scalars['DateTime']['output']>;
  trackingCarrier: Maybe<Scalars['String']['output']>;
  trackingLink: Maybe<Scalars['String']['output']>;
  trackingNumber: Maybe<Scalars['String']['output']>;
  vetsourceId: Maybe<Scalars['String']['output']>;
  vetsourcePrescriptionId: Maybe<Scalars['String']['output']>;
};

export type DispenseWithoutPrescriptionInput = {
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<MedicalDispenseCancellationReasonEnum>;
  clinicalRecord?: InputMaybe<OneToManyInput>;
  creditCardId?: InputMaybe<Scalars['String']['input']>;
  dispenseDate?: InputMaybe<Scalars['Date']['input']>;
  fulfillmentPreference?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  invoiceItem?: InputMaybe<OneToManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  pickupLocation?: InputMaybe<OneToManyInput>;
  prescription?: InputMaybe<Scalars['Void']['input']>;
  product: OneToManyInput;
  quantity?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  shippingApartment?: InputMaybe<Scalars['String']['input']>;
  shippingCity?: InputMaybe<Scalars['String']['input']>;
  shippingState?: InputMaybe<Scalars['String']['input']>;
  shippingZipcode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MedicalDispenseSourceEnum>;
  status?: InputMaybe<MedicalDispenseStatusEnum>;
  trackingCarrier?: InputMaybe<Scalars['String']['input']>;
  trackingLink?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DjangoFileType = {
  __typename?: 'DjangoFileType';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type DjangoImageType = {
  __typename?: 'DjangoImageType';
  height: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type DjangoModelType = {
  __typename?: 'DjangoModelType';
  pk: Scalars['ID']['output'];
};

export type EstimateFilter = {
  AND?: InputMaybe<EstimateFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<EstimateFilter>;
  OR?: InputMaybe<EstimateFilter>;
  clinicalRecord?: InputMaybe<ClinicalRecordFilter>;
  enableSend?: InputMaybe<Scalars['Boolean']['input']>;
  enableSendProcedureRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  household?: InputMaybe<HouseholdFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  patient?: InputMaybe<PatientFilter>;
  status?: InputMaybe<BillingEstimateStatusEnumFilterLookup>;
  tier?: InputMaybe<BillingEstimateTierEnumFilterLookup>;
  title?: InputMaybe<StrFilterLookup>;
};

export type EstimateGroupFilter = {
  AND?: InputMaybe<EstimateGroupFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<EstimateGroupFilter>;
  OR?: InputMaybe<EstimateGroupFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  position?: InputMaybe<IntComparisonFilterLookup>;
};

export type EstimateGroupOrder = {
  created?: InputMaybe<Ordering>;
  position?: InputMaybe<Ordering>;
};

export type EstimateGroupType = {
  __typename?: 'EstimateGroupType';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  majorGroup: Maybe<DjangoModelType>;
  minorGroups: Array<EstimateGroupType>;
  modified: Scalars['DateTime']['output'];
  position: Scalars['Int']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type EstimateGroupTypeMinorGroupsArgs = {
  filters: InputMaybe<EstimateGroupFilter>;
  order: InputMaybe<EstimateGroupOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};

export type EstimateInput = {
  clinicalRecord?: InputMaybe<OneToManyInput>;
  creditAmountApplied?: InputMaybe<Scalars['String']['input']>;
  discountFlat?: InputMaybe<Scalars['String']['input']>;
  discountPercentage?: InputMaybe<Scalars['String']['input']>;
  discountReason?: InputMaybe<BillingEstimateDiscountReasonEnum>;
  enableSend?: InputMaybe<Scalars['Boolean']['input']>;
  enableSendProcedureRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  isRecommendationAutomated?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<EstimateItemInput>>;
  location?: InputMaybe<OneToManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  patient: OneToManyInput;
  promo?: InputMaybe<OneToManyInput>;
  status?: InputMaybe<BillingEstimateStatusEnum>;
  tier?: InputMaybe<BillingEstimateTierEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EstimateInputPartial = {
  clinicalRecord?: InputMaybe<OneToManyInput>;
  creditAmountApplied?: InputMaybe<Scalars['String']['input']>;
  discountFlat?: InputMaybe<Scalars['String']['input']>;
  discountPercentage?: InputMaybe<Scalars['String']['input']>;
  discountReason?: InputMaybe<BillingEstimateDiscountReasonEnum>;
  enableSend?: InputMaybe<Scalars['Boolean']['input']>;
  enableSendProcedureRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isRecommendationAutomated?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<EstimateItemInput>>;
  location?: InputMaybe<OneToManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<OneToManyInput>;
  promo?: InputMaybe<OneToManyInput>;
  status?: InputMaybe<BillingEstimateStatusEnum>;
  tier?: InputMaybe<BillingEstimateTierEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EstimateItemFilter = {
  AND?: InputMaybe<EstimateItemFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<EstimateItemFilter>;
  OR?: InputMaybe<EstimateItemFilter>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
};

export type EstimateItemInput = {
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  declinedBy?: InputMaybe<BillingEstimateItemDeclinedByEnum>;
  estimate?: InputMaybe<OneToManyInput>;
  highQuantity?: InputMaybe<Scalars['String']['input']>;
  lowQuantity?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<OneToManyInput>;
  productPackage?: InputMaybe<OneToManyInput>;
  productPackageItem?: InputMaybe<OneToManyInput>;
};

export type EstimateItemInputPartial = {
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  declinedBy?: InputMaybe<BillingEstimateItemDeclinedByEnum>;
  estimate?: InputMaybe<OneToManyInput>;
  highQuantity?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lowQuantity?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<OneToManyInput>;
  productPackage?: InputMaybe<OneToManyInput>;
  productPackageItem?: InputMaybe<OneToManyInput>;
};

export type EstimateItemOrder = {
  id?: InputMaybe<Ordering>;
};

export type EstimateItemType = {
  __typename?: 'EstimateItemType';
  created: Scalars['DateTime']['output'];
  declined: Scalars['Boolean']['output'];
  declinedBy: Maybe<BillingEstimateItemDeclinedByEnum>;
  dispenseFee: Scalars['Decimal']['output'];
  estimate: DjangoModelType;
  highDiscountSnapshot: Scalars['Decimal']['output'];
  highQuantity: Scalars['Decimal']['output'];
  highSubtotalSnapshot: Scalars['Decimal']['output'];
  highTaxSnapshot: Scalars['Decimal']['output'];
  historicalProduct: Maybe<DjangoModelType>;
  historicalProductPackage: Maybe<DjangoModelType>;
  historicalProductPackageItem: Maybe<DjangoModelType>;
  id: Scalars['ID']['output'];
  inPackage: Scalars['Boolean']['output'];
  isPackage: Scalars['Boolean']['output'];
  lowDiscountSnapshot: Scalars['Decimal']['output'];
  lowQuantity: Scalars['Decimal']['output'];
  lowSubtotalSnapshot: Scalars['Decimal']['output'];
  lowTaxSnapshot: Scalars['Decimal']['output'];
  modified: Scalars['DateTime']['output'];
  name: Maybe<Scalars['String']['output']>;
  percentDiscounted: Scalars['Decimal']['output'];
  product: Maybe<ProductType>;
  productPackage: Maybe<ProductPackageType>;
  productPackageItem: Maybe<ProductPackageItemType>;
};

export type EstimateOrder = {
  created?: InputMaybe<Ordering>;
};

export type EstimateType = {
  __typename?: 'EstimateType';
  canDelete: Scalars['Boolean']['output'];
  clinicalRecord: Maybe<ClinicalRecordType>;
  created: Scalars['DateTime']['output'];
  creditAmountApplied: Scalars['Decimal']['output'];
  /** @deprecated Temporal resolver to be removed in November 2024. */
  datetime: Scalars['DateTime']['output'];
  discountFlat: Scalars['Decimal']['output'];
  discountPercentage: Scalars['Decimal']['output'];
  discountReason: Maybe<BillingEstimateDiscountReasonEnum>;
  discountType: Maybe<BillingEstimateDiscountTypeEnum>;
  enableSend: Scalars['Boolean']['output'];
  enableSendProcedureRecommendation: Scalars['Boolean']['output'];
  hasUpcomingProcedure: Scalars['Boolean']['output'];
  highDiscount: Scalars['Decimal']['output'];
  highSubtotal: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  invoiceItemRecommendations: Array<InvoiceItemType>;
  isRecommendationAutomated: Scalars['Boolean']['output'];
  items: Array<EstimateItemType>;
  location: LocationType;
  lowDiscount: Scalars['Decimal']['output'];
  lowSubtotal: Scalars['Decimal']['output'];
  modified: Scalars['DateTime']['output'];
  note: Maybe<Scalars['String']['output']>;
  patient: PatientType;
  postDiscountHighTotal: Scalars['Decimal']['output'];
  postDiscountLowTotal: Scalars['Decimal']['output'];
  promo: Maybe<PromoType>;
  referringProvider: Maybe<StaffType>;
  status: BillingEstimateStatusEnum;
  tagSelectors: Array<TagSelectorType>;
  tier: Maybe<BillingEstimateTierEnum>;
  timeSent: Maybe<Scalars['DateTime']['output']>;
  title: Maybe<Scalars['String']['output']>;
};


export type EstimateTypeInvoiceItemRecommendationsArgs = {
  filters: InputMaybe<InvoiceItemFilter>;
  order: InputMaybe<InvoiceItemOrder>;
};


export type EstimateTypeItemsArgs = {
  filters: InputMaybe<EstimateItemFilter>;
  order: InputMaybe<EstimateItemOrder>;
};

export type ExternalClinicFilter = {
  AND?: InputMaybe<ExternalClinicFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ExternalClinicFilter>;
  OR?: InputMaybe<ExternalClinicFilter>;
  googlePlacesId?: InputMaybe<StrFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
};

export type ExternalClinicInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  googlePlacesId: Scalars['String']['input'];
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalClinicType = {
  __typename?: 'ExternalClinicType';
  address: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  googlePlacesId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalNotes: Maybe<Scalars['String']['output']>;
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
};

export type ExtractMedicalHistoryInput = {
  fileLink: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
};

export type FcmDeviceFilter = {
  AND?: InputMaybe<FcmDeviceFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<FcmDeviceFilter>;
  OR?: InputMaybe<FcmDeviceFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  registrationId?: InputMaybe<StrFilterLookup>;
};

export type FcmDeviceInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  registrationId: Scalars['String']['input'];
  type: FcmDjangoFcmDeviceTypeEnum;
  user?: InputMaybe<OneToManyInput>;
};

export type FcmDeviceInputPartial = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  registrationId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FcmDjangoFcmDeviceTypeEnum>;
  user?: InputMaybe<OneToManyInput>;
};

export type FcmDeviceType = {
  __typename?: 'FCMDeviceType';
  active: Scalars['Boolean']['output'];
  dateCreated: Maybe<Scalars['DateTime']['output']>;
  deviceId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  registrationId: Scalars['String']['output'];
  type: FcmDjangoFcmDeviceTypeEnum;
  user: Maybe<DjangoModelType>;
};

export enum FcmDjangoFcmDeviceTypeEnum {
  /** android */
  Android = 'android',
  /** ios */
  Ios = 'ios',
  /** web */
  Web = 'web'
}

export type FlaggedTestResultFilter = {
  AND?: InputMaybe<FlaggedTestResultFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<FlaggedTestResultFilter>;
  OR?: InputMaybe<FlaggedTestResultFilter>;
  name?: InputMaybe<StrFilterLookup>;
  species?: InputMaybe<MedicalFlaggedTestResultSpeciesEnumFilterLookup>;
};

export type FlaggedTestResultType = {
  __typename?: 'FlaggedTestResultType';
  comparisonOperator: MedicalFlaggedTestResultComparisonOperatorEnum;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  needsUrgentInterpretation: Scalars['Boolean']['output'];
  result: Scalars['String']['output'];
  species: Maybe<MedicalFlaggedTestResultSpeciesEnum>;
};

export type FloatComparisonFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than. Filter will be skipped on `null` value */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal to. Filter will be skipped on `null` value */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than. Filter will be skipped on `null` value */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal to. Filter will be skipped on `null` value */
  lte?: InputMaybe<Scalars['Float']['input']>;
  /** Inclusive range test (between) */
  range?: InputMaybe<FloatRangeLookup>;
};

export type FloatRangeLookup = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export type GenerateSmartCommunicationSummaryInput = {
  communication: SmartCommunicationSummaryClientCommunicationInput;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
  staffId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateSmartCommunicationSummaryResponseType = {
  __typename?: 'GenerateSmartCommunicationSummaryResponseType';
  ok: Scalars['Boolean']['output'];
};

export type GetMonographsResponseType = {
  __typename?: 'GetMonographsResponseType';
  monographList: Array<MonographFileType>;
};

export type HandleAiTriageRouting = {
  __typename?: 'HandleAiTriageRouting';
  appRoutingDestination: AiTriageRoutingDestinationEnum;
  booking: TriageRoutingBookingData;
  category: AiTriageRoutingCategoryEnum;
  chat: TriageRoutingChatData;
  form: Maybe<TriageFormType>;
  reasonForConversation: Scalars['String']['output'];
  triageSupportType: AiTriageSupportTypeEnum;
};

export type HistoricalDiagnosticTestResultFilter = {
  AND?: InputMaybe<HistoricalDiagnosticTestResultFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<HistoricalDiagnosticTestResultFilter>;
  OR?: InputMaybe<HistoricalDiagnosticTestResultFilter>;
  status?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnumFilterLookup>;
};

export type HistoricalDiagnosticTestResultOrder = {
  historyDate?: InputMaybe<Ordering>;
};

export type HistoricalDiagnosticTestResultType = {
  __typename?: 'HistoricalDiagnosticTestResultType';
  historyDate: Scalars['DateTime']['output'];
  status: Maybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
};

export type HistoricalTaskFilter = {
  AND?: InputMaybe<HistoricalTaskFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<HistoricalTaskFilter>;
  OR?: InputMaybe<HistoricalTaskFilter>;
  note?: InputMaybe<StrFilterLookup>;
};

export type HistoricalTaskOrder = {
  historyDate?: InputMaybe<Ordering>;
};

export type HistoricalTaskType = {
  __typename?: 'HistoricalTaskType';
  historyDate: Scalars['DateTime']['output'];
  historyUser: Maybe<ClientType>;
};

export type HouseholdFilter = {
  AND?: InputMaybe<HouseholdFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<HouseholdFilter>;
  OR?: InputMaybe<HouseholdFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  pk?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type HouseholdInputPartial = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type HouseholdType = {
  __typename?: 'HouseholdType';
  conversations: Array<ConversationType>;
  created: Scalars['DateTime']['output'];
  creditcardSet: Array<CreditCardType>;
  derivedLocation: LocationType;
  householdHash: Maybe<Scalars['String']['output']>;
  householdMembers: Array<ClientType>;
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  notes: Maybe<Scalars['String']['output']>;
  notesModified: Maybe<Scalars['DateTime']['output']>;
  notesModifiedBy: Maybe<Scalars['String']['output']>;
  owner: ClientType;
  patients: Array<PatientType>;
  referringHousehold: Maybe<DjangoModelType>;
  totalActiveCreditAmount: Scalars['Decimal']['output'];
};


export type HouseholdTypeConversationsArgs = {
  filters: InputMaybe<ConversationFilter>;
  order: InputMaybe<ConversationOrder>;
};


export type HouseholdTypeCreditcardSetArgs = {
  filters: InputMaybe<CreditCardFilter>;
};


export type HouseholdTypeHouseholdMembersArgs = {
  filters: InputMaybe<ClientFilter>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type HouseholdTypePatientsArgs = {
  filters: InputMaybe<PatientFilter>;
  order: InputMaybe<PatientOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};

export type IdBaseFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['ID']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InboundMedicalRecordRequestInput = {
  clinicAddress?: InputMaybe<Scalars['String']['input']>;
  clinicName?: InputMaybe<Scalars['String']['input']>;
  clinicPhone?: InputMaybe<Scalars['String']['input']>;
  externalClinic?: InputMaybe<OneToManyInput>;
  patient: OneToManyInput;
  status?: InputMaybe<CustomerInboundMedicalRecordRequestStatusEnum>;
};

export type InboundMedicalRecordRequestType = {
  __typename?: 'InboundMedicalRecordRequestType';
  clinicAddress: Maybe<Scalars['String']['output']>;
  clinicName: Maybe<Scalars['String']['output']>;
  clinicPhone: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  externalClinic: Maybe<DjangoModelType>;
  id: Scalars['ID']['output'];
  lastSent: Maybe<Scalars['DateTime']['output']>;
  modified: Scalars['DateTime']['output'];
  notes: Maybe<Scalars['String']['output']>;
  patient: DjangoModelType;
  status: CustomerInboundMedicalRecordRequestStatusEnum;
};

export type InsuranceType = {
  __typename?: 'InsuranceType';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type IntComparisonFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than. Filter will be skipped on `null` value */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to. Filter will be skipped on `null` value */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than. Filter will be skipped on `null` value */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to. Filter will be skipped on `null` value */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** Inclusive range test (between) */
  range?: InputMaybe<IntRangeLookup>;
};

export type IntRangeLookup = {
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type IntakeQuestionsInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  clinicalRecord: OneToOneInput;
  cprVerification?: InputMaybe<Scalars['String']['input']>;
  healthChanges?: InputMaybe<Scalars['String']['input']>;
  lastFood?: InputMaybe<Scalars['DateTime']['input']>;
  lastWater?: InputMaybe<Scalars['DateTime']['input']>;
  otherConcerns?: InputMaybe<Scalars['String']['input']>;
  personalItems?: InputMaybe<Scalars['String']['input']>;
};

export type IntakeQuestionsInputPartial = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  clinicalRecord?: InputMaybe<OneToOneInput>;
  cprVerification?: InputMaybe<Scalars['String']['input']>;
  healthChanges?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastFood?: InputMaybe<Scalars['DateTime']['input']>;
  lastWater?: InputMaybe<Scalars['DateTime']['input']>;
  otherConcerns?: InputMaybe<Scalars['String']['input']>;
  personalItems?: InputMaybe<Scalars['String']['input']>;
};

export type IntakeQuestionsType = {
  __typename?: 'IntakeQuestionsType';
  additionalNotes: Maybe<Scalars['String']['output']>;
  clinicalRecord: DjangoModelType;
  cprVerification: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  healthChanges: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastFood: Maybe<Scalars['DateTime']['output']>;
  lastWater: Maybe<Scalars['DateTime']['output']>;
  modified: Scalars['DateTime']['output'];
  otherConcerns: Maybe<Scalars['String']['output']>;
  personalItems: Maybe<Scalars['String']['output']>;
};

export type IntegratedDiagnosticFilter = {
  AND?: InputMaybe<IntegratedDiagnosticFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<IntegratedDiagnosticFilter>;
  OR?: InputMaybe<IntegratedDiagnosticFilter>;
  clinicalRecord?: InputMaybe<ClinicalRecordFilter>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
  status?: InputMaybe<MedicalIntegratedDiagnosticStatusEnumFilterLookup>;
};

export type IntegratedDiagnosticHistoryType = {
  __typename?: 'IntegratedDiagnosticHistoryType';
  dateModified: Scalars['DateTime']['output'];
  statusModified: Scalars['String']['output'];
};

export type IntegratedDiagnosticInput = {
  clinicalRecord: OneToManyInput;
  kind: MedicalIntegratedDiagnosticKindEnum;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  reasonForOrdering?: InputMaybe<MedicalIntegratedDiagnosticReasonForOrderingEnum>;
  recommendedRxStatus?: InputMaybe<MedicalIntegratedDiagnosticRecommendedRxStatusEnum>;
  staff: OneToManyInput;
  tests?: InputMaybe<ManyToManyInput>;
};

export type IntegratedDiagnosticInputPartial = {
  clinicalRecord?: InputMaybe<OneToManyInput>;
  id: Scalars['ID']['input'];
  kind?: InputMaybe<MedicalIntegratedDiagnosticKindEnum>;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  reasonForOrdering?: InputMaybe<MedicalIntegratedDiagnosticReasonForOrderingEnum>;
  recommendedRxStatus?: InputMaybe<MedicalIntegratedDiagnosticRecommendedRxStatusEnum>;
  staff?: InputMaybe<OneToManyInput>;
  tests?: InputMaybe<ManyToManyInput>;
};

export type IntegratedDiagnosticOrder = {
  created?: InputMaybe<Ordering>;
};

export type IntegratedDiagnosticType = {
  __typename?: 'IntegratedDiagnosticType';
  clinicalRecord: ClinicalRecordType;
  created: Scalars['DateTime']['output'];
  /** @deprecated Use TestResult */
  history: Array<IntegratedDiagnosticHistoryType>;
  id: Scalars['ID']['output'];
  /** @deprecated Use TestResult */
  internalInterpretation: Maybe<Scalars['String']['output']>;
  interpretationChangedSinceLastSent: Scalars['Boolean']['output'];
  /** @deprecated Use TestResult */
  interpretationSummary: Maybe<Scalars['String']['output']>;
  /** @deprecated Use TestResult */
  interpreter: Maybe<StaffType>;
  isInhouseDiagnostic: Scalars['Boolean']['output'];
  isReferenceDiagnostic: Scalars['Boolean']['output'];
  kind: MedicalIntegratedDiagnosticKindEnum;
  modified: Scalars['DateTime']['output'];
  /** @deprecated Use TestResult */
  partialInternalInterpretation: Maybe<Scalars['String']['output']>;
  partialInterpretationChangedSinceLastSent: Scalars['Boolean']['output'];
  /** @deprecated Use TestResult */
  partialInterpretationSummary: Maybe<Scalars['String']['output']>;
  /** @deprecated Use TestResult */
  partialInterpreter: Maybe<StaffType>;
  /** @deprecated Use TestResult */
  partialReviewedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use TestResult */
  partialSmartInternalInterpretation: Maybe<Scalars['String']['output']>;
  /** @deprecated Use TestResult */
  partialSmartInterpretationSummary: Maybe<Scalars['String']['output']>;
  /** @deprecated Use TestResult */
  pdfDownloadedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use TestResult */
  pdfUrl: Maybe<Scalars['String']['output']>;
  prescriptions: Array<PrescriptionType>;
  reasonDescription: Maybe<Scalars['String']['output']>;
  reasonForOrdering: Maybe<MedicalIntegratedDiagnosticReasonForOrderingEnum>;
  requisitionId: Scalars['String']['output'];
  /** @deprecated Use TestResult */
  results: Maybe<DjangoFileType>;
  /** @deprecated Use TestResult */
  resultsUrl: Maybe<Scalars['String']['output']>;
  /** @deprecated Use TestResult */
  reviewedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use TestResult */
  smartInternalInterpretation: Maybe<Scalars['String']['output']>;
  /** @deprecated Use TestResult */
  smartInterpretationSummary: Maybe<Scalars['String']['output']>;
  /** @deprecated Use TestResult */
  staff: Maybe<StaffType>;
  /** @deprecated Use TestResult */
  status: MedicalIntegratedDiagnosticStatusEnum;
  testResults: Array<DiagnosticTestResultType>;
  /** @deprecated Use TestResult */
  tests: Array<ProductType>;
  /** @deprecated Use TestResult */
  uiUrl: Maybe<Scalars['String']['output']>;
};


export type IntegratedDiagnosticTypePrescriptionsArgs = {
  filters: InputMaybe<PrescriptionFilter>;
  order: InputMaybe<PrescriptionOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type IntegratedDiagnosticTypeTestResultsArgs = {
  filters: InputMaybe<DiagnosticTestResultFilter>;
  order: InputMaybe<DiagnosticTestResultOrder>;
};

export type InteractionFilter = {
  AND?: InputMaybe<InteractionFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<InteractionFilter>;
  OR?: InputMaybe<InteractionFilter>;
  conversation?: InputMaybe<ConversationFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type InteractionInput = {
  agentNetworkAverage?: InputMaybe<Scalars['Float']['input']>;
  agentNetworkDisruption?: InputMaybe<Scalars['Float']['input']>;
  assignedRole?: InputMaybe<CommunicationInteractionAssignedRoleEnum>;
  callerNetworkAverage?: InputMaybe<Scalars['Float']['input']>;
  callerNetworkDisruption?: InputMaybe<Scalars['Float']['input']>;
  claimedBy?: InputMaybe<OneToManyInput>;
  client?: InputMaybe<OneToManyInput>;
  conversation?: InputMaybe<OneToManyInput>;
  ended?: InputMaybe<Scalars['DateTime']['input']>;
  idleExpiration?: InputMaybe<Scalars['DateTime']['input']>;
  interactionType: CommunicationInteractionInteractionTypeEnum;
  isClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  isDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<OneToManyInput>;
  patient?: InputMaybe<OneToManyInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  reasonForCall?: InputMaybe<Scalars['String']['input']>;
  reasonForDisconnect?: InputMaybe<Scalars['String']['input']>;
  roomSid?: InputMaybe<Scalars['String']['input']>;
  roundRobinAssigned?: InputMaybe<OneToManyInput>;
  roundRobinLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InteractionInputPartial = {
  agentNetworkAverage?: InputMaybe<Scalars['Float']['input']>;
  agentNetworkDisruption?: InputMaybe<Scalars['Float']['input']>;
  assignedRole?: InputMaybe<CommunicationInteractionAssignedRoleEnum>;
  callerNetworkAverage?: InputMaybe<Scalars['Float']['input']>;
  callerNetworkDisruption?: InputMaybe<Scalars['Float']['input']>;
  claimedBy?: InputMaybe<OneToManyInput>;
  client?: InputMaybe<OneToManyInput>;
  conversation?: InputMaybe<OneToManyInput>;
  ended?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  idleExpiration?: InputMaybe<Scalars['DateTime']['input']>;
  interactionType?: InputMaybe<CommunicationInteractionInteractionTypeEnum>;
  isClaimed?: InputMaybe<Scalars['Boolean']['input']>;
  isDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<OneToManyInput>;
  patient?: InputMaybe<OneToManyInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  reasonForCall?: InputMaybe<Scalars['String']['input']>;
  reasonForDisconnect?: InputMaybe<Scalars['String']['input']>;
  roomSid?: InputMaybe<Scalars['String']['input']>;
  roundRobinAssigned?: InputMaybe<OneToManyInput>;
  roundRobinLastUpdate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InteractionOrder = {
  created?: InputMaybe<Ordering>;
};

export type InteractionType = {
  __typename?: 'InteractionType';
  accepted: Maybe<Scalars['DateTime']['output']>;
  agentNetworkAverage: Maybe<Scalars['Float']['output']>;
  agentNetworkDisruption: Maybe<Scalars['Float']['output']>;
  assignedRole: Maybe<CommunicationInteractionAssignedRoleEnum>;
  callerNetworkAverage: Maybe<Scalars['Float']['output']>;
  callerNetworkDisruption: Maybe<Scalars['Float']['output']>;
  claimedBy: Maybe<StaffType>;
  client: Maybe<ClientType>;
  conversation: Maybe<ConversationType>;
  created: Scalars['DateTime']['output'];
  duration: Maybe<Scalars['String']['output']>;
  enabledAfterSla: Scalars['Boolean']['output'];
  ended: Maybe<Scalars['DateTime']['output']>;
  expired: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  idleExpiration: Maybe<Scalars['DateTime']['output']>;
  interactionType: CommunicationInteractionInteractionTypeEnum;
  ipAddress: Maybe<Scalars['String']['output']>;
  isClaimed: Scalars['Boolean']['output'];
  isDeclined: Scalars['Boolean']['output'];
  isUrgent: Scalars['Boolean']['output'];
  lastClientMessage: Maybe<MessageType>;
  lastStaffMessage: Maybe<MessageType>;
  location: Maybe<LocationType>;
  modified: Scalars['DateTime']['output'];
  patient: Maybe<PatientType>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  preview: Maybe<Scalars['String']['output']>;
  reasonForCall: Maybe<Scalars['String']['output']>;
  reasonForDisconnect: Maybe<Scalars['String']['output']>;
  roomSid: Maybe<Scalars['String']['output']>;
  roundRobinAssigned: Maybe<StaffType>;
  roundRobinIdleCountdownTime: Scalars['Int']['output'];
  roundRobinIntervalDuration: Scalars['Int']['output'];
  roundRobinLastUpdate: Maybe<Scalars['DateTime']['output']>;
  sla: Maybe<Scalars['Int']['output']>;
};

export type InvoiceFilter = {
  AND?: InputMaybe<InvoiceFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<InvoiceFilter>;
  OR?: InputMaybe<InvoiceFilter>;
  clinicalRecord?: InputMaybe<ClinicalRecordFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  items?: InputMaybe<InvoiceItemFilter>;
  patient?: InputMaybe<PatientFilter>;
  status?: InputMaybe<BillingInvoiceStatusEnumFilterLookup>;
};

export type InvoiceInput = {
  clinicalRecord: OneToOneInput;
  creditAmountApplied?: InputMaybe<Scalars['String']['input']>;
  discountFlat?: InputMaybe<Scalars['String']['input']>;
  discountPercentage?: InputMaybe<Scalars['String']['input']>;
  discountReason?: InputMaybe<BillingInvoiceDiscountReasonEnum>;
  isCreditRedemptionAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patient: OneToManyInput;
  promo?: InputMaybe<OneToManyInput>;
  status?: InputMaybe<BillingInvoiceStatusEnum>;
  tier?: InputMaybe<BillingInvoiceTierEnum>;
  totalPaid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceInputPartial = {
  clinicalRecord?: InputMaybe<OneToOneInput>;
  creditAmountApplied?: InputMaybe<Scalars['String']['input']>;
  discountFlat?: InputMaybe<Scalars['String']['input']>;
  discountPercentage?: InputMaybe<Scalars['String']['input']>;
  discountReason?: InputMaybe<BillingInvoiceDiscountReasonEnum>;
  id: Scalars['ID']['input'];
  isCreditRedemptionAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<OneToManyInput>;
  promo?: InputMaybe<OneToManyInput>;
  status?: InputMaybe<BillingInvoiceStatusEnum>;
  tier?: InputMaybe<BillingInvoiceTierEnum>;
  totalPaid?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceItemFilter = {
  AND?: InputMaybe<InvoiceItemFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<InvoiceItemFilter>;
  OR?: InputMaybe<InvoiceItemFilter>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  invoice?: InputMaybe<InvoiceFilter>;
  modified?: InputMaybe<DatetimeDatetimeFilterLookup>;
  product?: InputMaybe<ProductFilter>;
  reasonForPostpone?: InputMaybe<BillingInvoiceItemReasonForPostponeEnumFilterLookup>;
};

export type InvoiceItemInput = {
  completedBy?: InputMaybe<OneToManyInput>;
  datetimeCompleted?: InputMaybe<Scalars['DateTime']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  declinedBy?: InputMaybe<BillingInvoiceItemDeclinedByEnum>;
  estimate?: InputMaybe<OneToManyInput>;
  invoice: OneToManyInput;
  note?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<OneToManyInput>;
  productPackage?: InputMaybe<OneToManyInput>;
  productPackageItem?: InputMaybe<OneToManyInput>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  reasonForPostpone?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
};

export type InvoiceItemInputPartial = {
  completedBy?: InputMaybe<OneToManyInput>;
  datetimeCompleted?: InputMaybe<Scalars['DateTime']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  declinedBy?: InputMaybe<BillingInvoiceItemDeclinedByEnum>;
  estimate?: InputMaybe<OneToManyInput>;
  id: Scalars['ID']['input'];
  invoice?: InputMaybe<OneToManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<OneToManyInput>;
  productPackage?: InputMaybe<OneToManyInput>;
  productPackageItem?: InputMaybe<OneToManyInput>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  reasonForPostpone?: InputMaybe<BillingInvoiceItemReasonForPostponeEnum>;
};

export type InvoiceItemOrder = {
  created?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
};

export type InvoiceItemType = {
  __typename?: 'InvoiceItemType';
  completedBy: Maybe<StaffType>;
  created: Scalars['DateTime']['output'];
  datetimeCompleted: Maybe<Scalars['DateTime']['output']>;
  declined: Scalars['Boolean']['output'];
  declinedBy: Maybe<BillingInvoiceItemDeclinedByEnum>;
  discountSnapshot: Scalars['Decimal']['output'];
  discountedSubtotal: Maybe<Scalars['Decimal']['output']>;
  dispenses: Array<DispenseType>;
  estimate: Maybe<EstimateType>;
  historicalProduct: Maybe<DjangoModelType>;
  historicalProductPackage: Maybe<DjangoModelType>;
  historicalProductPackageItem: Maybe<DjangoModelType>;
  id: Scalars['ID']['output'];
  inPackage: Scalars['Boolean']['output'];
  invoice: InvoiceType;
  isChecked: Scalars['Boolean']['output'];
  isPackage: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  name: Maybe<Scalars['String']['output']>;
  note: Maybe<Scalars['String']['output']>;
  product: Maybe<ProductType>;
  productPackage: Maybe<ProductPackageType>;
  productPackageItem: Maybe<ProductPackageItemType>;
  quantity: Scalars['Decimal']['output'];
  reasonForPostpone: Maybe<BillingInvoiceItemReasonForPostponeEnum>;
  subtotalSnapshot: Scalars['Decimal']['output'];
  taxSnapshot: Scalars['Decimal']['output'];
};


export type InvoiceItemTypeDispensesArgs = {
  filters: InputMaybe<DispenseFilter>;
  order: InputMaybe<DispenseOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};

export type InvoiceOrder = {
  created?: InputMaybe<Ordering>;
};

export type InvoiceType = {
  __typename?: 'InvoiceType';
  clinicalRecord: ClinicalRecordType;
  created: Scalars['DateTime']['output'];
  creditAmountApplied: Scalars['Decimal']['output'];
  /** @deprecated Temporal resolver to be removed in November 2024. */
  datetime: Scalars['DateTime']['output'];
  discount: Scalars['Decimal']['output'];
  discountFlat: Scalars['Decimal']['output'];
  discountPercentage: Scalars['Decimal']['output'];
  discountReason: Maybe<BillingInvoiceDiscountReasonEnum>;
  discountType: Maybe<BillingInvoiceDiscountTypeEnum>;
  id: Scalars['ID']['output'];
  isCreditRedemptionAllowed: Scalars['Boolean']['output'];
  items: Array<InvoiceItemType>;
  modified: Scalars['DateTime']['output'];
  note: Maybe<Scalars['String']['output']>;
  patient: PatientType;
  postTaxTotal: Scalars['Decimal']['output'];
  promo: Maybe<PromoType>;
  salesTax: Scalars['Decimal']['output'];
  status: BillingInvoiceStatusEnum;
  subtotal: Scalars['Decimal']['output'];
  tier: Maybe<BillingInvoiceTierEnum>;
  totalPaid: Scalars['Decimal']['output'];
  totalRefundAmount: Scalars['Decimal']['output'];
  transactions: Array<TransactionType>;
};


export type InvoiceTypeItemsArgs = {
  filters: InputMaybe<InvoiceItemFilter>;
  order: InputMaybe<InvoiceItemOrder>;
};


export type InvoiceTypeTransactionsArgs = {
  filters: InputMaybe<TransactionFilter>;
};

export type LicenseType = {
  __typename?: 'LicenseType';
  created: Scalars['DateTime']['output'];
  expirationDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  number: Scalars['String']['output'];
  staff: DjangoModelType;
  state: Scalars['String']['output'];
};

export type LocationFilter = {
  AND?: InputMaybe<LocationFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<LocationFilter>;
  OR?: InputMaybe<LocationFilter>;
  actualOpenDate?: InputMaybe<DateDateFilterLookup>;
  appointmentChatFollowUpDays?: InputMaybe<IntComparisonFilterLookup>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  triageUrgentAvailabilityFlag?: InputMaybe<BoolBaseFilterLookup>;
};

export type LocationOrder = {
  name?: InputMaybe<Ordering>;
};

export type LocationType = {
  __typename?: 'LocationType';
  address: Scalars['String']['output'];
  apartment: Maybe<Scalars['String']['output']>;
  appointmentChatFollowUpDays: Maybe<Scalars['Int']['output']>;
  city: Scalars['String']['output'];
  comingSoon: Scalars['Boolean']['output'];
  google: Maybe<Scalars['String']['output']>;
  hasVetconnectAccount: Scalars['Boolean']['output'];
  hoursOfOperation: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: DjangoImageType;
  isActive: Scalars['Boolean']['output'];
  latitude: Scalars['String']['output'];
  location: Maybe<Scalars['Point']['output']>;
  longitude: Scalars['String']['output'];
  name: Scalars['String']['output'];
  openingDate: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  region: RegionType;
  salesTaxPercentage: Scalars['Float']['output'];
  scratchpayCode: Maybe<Scalars['String']['output']>;
  shorthand: Scalars['String']['output'];
  state: Scalars['String']['output'];
  triageUrgentAvailabilityFlag: Scalars['Boolean']['output'];
  visitorInformation: Maybe<Scalars['String']['output']>;
  webBookingShowCreditCardStep: Scalars['Boolean']['output'];
  yelp: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type ManufacturerType = {
  __typename?: 'ManufacturerType';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type ManyToManyInput = {
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  set?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ManyToOneInput = {
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  set?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum MedicalAttachmentCategoryEnum {
  /** Dental Focus */
  DentalFocus = 'Dental_Focus',
  /** Diagnostics */
  Diagnostics = 'Diagnostics',
  /** Emergency Records */
  EmergencyRecords = 'Emergency_Records',
  /** Imaging */
  Imaging = 'Imaging',
  /** Other */
  Other = 'Other',
  /** Pictures */
  Pictures = 'Pictures',
  /** Prescriptions */
  Prescriptions = 'Prescriptions',
  /** Prior DVM Records */
  PriorDvmRecords = 'Prior_DVM_Records',
  /** Scout */
  Scout = 'Scout',
  /** Smartflow */
  Smartflow = 'Smartflow',
  /** Specialist Records */
  SpecialistRecords = 'Specialist_Records',
  /** Travel Documents */
  TravelDocuments = 'Travel_Documents',
  /** Videos */
  Videos = 'Videos'
}

export type MedicalAttachmentCategoryEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalAttachmentCategoryEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalAttachmentCategoryEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalAttachmentCategoryEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalAttachmentCategoryEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalAttachmentCategoryEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalAttachmentCategoryEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalAttachmentCategoryEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalAttachmentCategoryEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalAttachmentCategoryEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalAttachmentCategoryEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalAttachmentCategoryEnum>;
};

export enum MedicalCarePlanGuidanceKindEnum {
  /** EXAM */
  Exam = 'EXAM',
  /** LAB */
  Lab = 'LAB',
  /** PREVENTATIVE */
  Preventative = 'PREVENTATIVE',
  /** VACCINE */
  Vaccine = 'VACCINE'
}

export enum MedicalCarePlanGuidanceSpeciesEnum {
  /** CANINE */
  Canine = 'CANINE',
  /** FELINE */
  Feline = 'FELINE'
}

export type MedicalCarePlanGuidanceSpeciesEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalCarePlanGuidanceSpeciesEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalCarePlanGuidanceSpeciesEnum>;
};

export enum MedicalCarePlanItemStatusEnum {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** DECLINED */
  Declined = 'DECLINED',
  /** DUE */
  Due = 'DUE',
  /** NOT_NEEDED */
  NotNeeded = 'NOT_NEEDED',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

export type MedicalCarePlanItemStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalCarePlanItemStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalCarePlanItemStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalCarePlanItemStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalCarePlanItemStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalCarePlanItemStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalCarePlanItemStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalCarePlanItemStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalCarePlanItemStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalCarePlanItemStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalCarePlanItemStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalCarePlanItemStatusEnum>;
};

export enum MedicalClientCommunicationCommunicationTypeEnum {
  Chat = 'CHAT',
  Email = 'EMAIL',
  InPerson = 'IN_PERSON',
  PhoneCall = 'PHONE_CALL',
  VideoCall = 'VIDEO_CALL'
}

export enum MedicalClientCommunicationDocumentationPurposeEnum {
  CustomerService = 'CUSTOMER_SERVICE',
  Medication = 'MEDICATION',
  Other = 'OTHER',
  Recommendation = 'RECOMMENDATION',
  Symptom = 'SYMPTOM'
}

export enum MedicalClientFriendlyVaccineDefaultSiteOfInjectionEnum {
  /** BUTTOCKS */
  Buttocks = 'BUTTOCKS',
  /** INTERSCAPULAR */
  Interscapular = 'INTERSCAPULAR',
  /** INTRANASAL */
  Intranasal = 'INTRANASAL',
  /** LEFT_FRONT_LEG */
  LeftFrontLeg = 'LEFT_FRONT_LEG',
  /** LEFT_REAR_LEG */
  LeftRearLeg = 'LEFT_REAR_LEG',
  /** MIDLINE */
  Midline = 'MIDLINE',
  /** ORAL */
  Oral = 'ORAL',
  /** RIGHT_FRONT_LEG */
  RightFrontLeg = 'RIGHT_FRONT_LEG',
  /** RIGHT_REAR_LEG */
  RightRearLeg = 'RIGHT_REAR_LEG'
}

export enum MedicalClinicalRecordExpectedDiagnosticReportingEnum {
  /** ORDERING_DVM_INTERPRET */
  OrderingDvmInterpret = 'ORDERING_DVM_INTERPRET',
  /** VC_DA_REVIEW */
  VcDaReview = 'VC_DA_REVIEW',
  /** VC_DVM_INTERPRET */
  VcDvmInterpret = 'VC_DVM_INTERPRET'
}

export enum MedicalClinicalRecordTemplateRelevantSectionEnum {
  /** ANESTHETIC_PLAN */
  AnestheticPlan = 'ANESTHETIC_PLAN',
  /** ASSESSMENT */
  Assessment = 'ASSESSMENT',
  /** ATTACHMENTS */
  Attachments = 'ATTACHMENTS',
  /** BODY_MAP */
  BodyMap = 'BODY_MAP',
  /** CARE_SUMMARY */
  CareSummary = 'CARE_SUMMARY',
  /** CHIEF_COMPLAINT */
  ChiefComplaint = 'CHIEF_COMPLAINT',
  /** CLIENT_COMMUNICATION */
  ClientCommunication = 'CLIENT_COMMUNICATION',
  /** CLIENT_FRIENDLY_DIAGNOSTICS */
  ClientFriendlyDiagnostics = 'CLIENT_FRIENDLY_DIAGNOSTICS',
  /** DENTAL */
  Dental = 'DENTAL',
  /** FOLLOW_UPS */
  FollowUps = 'FOLLOW_UPS',
  /** INTAKE_QUESTIONS */
  IntakeQuestions = 'INTAKE_QUESTIONS',
  /** INTEGRATED_DIAGNOSTICS */
  IntegratedDiagnostics = 'INTEGRATED_DIAGNOSTICS',
  /** MEDICAL_NOTE */
  MedicalNote = 'MEDICAL_NOTE',
  /** NON_INTEGRATED_DIAGNOSTICS */
  NonIntegratedDiagnostics = 'NON_INTEGRATED_DIAGNOSTICS',
  /** OBJECTIVE */
  Objective = 'OBJECTIVE',
  /** PLAN */
  Plan = 'PLAN',
  /** PLAN_NOTE */
  PlanNote = 'PLAN_NOTE',
  /** PRESCRIPTIONS */
  Prescriptions = 'PRESCRIPTIONS',
  /** QUEUE */
  Queue = 'QUEUE',
  /** SUBJECTIVE */
  Subjective = 'SUBJECTIVE',
  /** SURGICAL_REPORT */
  SurgicalReport = 'SURGICAL_REPORT',
  /** VACCINES */
  Vaccines = 'VACCINES',
  /** VITALS */
  Vitals = 'VITALS'
}

export enum MedicalClinicalRecordTranscriptionModelEnum {
  /** AWS_TRANSCRIBE */
  AwsTranscribe = 'AWS_TRANSCRIBE',
  /** OPENAI_WHISPER */
  OpenaiWhisper = 'OPENAI_WHISPER'
}

export enum MedicalConditionResolutionStatusEnum {
  /** CONFIRMED */
  Confirmed = 'CONFIRMED',
  /** RESOLVED */
  Resolved = 'RESOLVED',
  /** RULED_OUT */
  RuledOut = 'RULED_OUT',
  /** TENTATIVE */
  Tentative = 'TENTATIVE'
}

export enum MedicalDiagnosticTestResultAddOnStatusEnum {
  /** EXPIRED */
  Expired = 'EXPIRED',
  /** MEMBER_PAID */
  MemberPaid = 'MEMBER_PAID',
  /** ORDERED */
  Ordered = 'ORDERED',
  /** RECOMMENDATION_SENT_TO_MEMBER */
  RecommendationSentToMember = 'RECOMMENDATION_SENT_TO_MEMBER',
  /** RECOMMENDED */
  Recommended = 'RECOMMENDED'
}

export enum MedicalDiagnosticTestResultStatusEnum {
  /** ATLAB */
  Atlab = 'ATLAB',
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** COMPLETE */
  Complete = 'COMPLETE',
  /** CREATED */
  Created = 'CREATED',
  /** PARTIAL */
  Partial = 'PARTIAL',
  /** REVIEWED */
  Reviewed = 'REVIEWED',
  /** SUBMITTED */
  Submitted = 'SUBMITTED'
}

export type MedicalDiagnosticTestResultStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalDiagnosticTestResultStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalDiagnosticTestResultStatusEnum>;
};

export enum MedicalDifferentialStatusEnum {
  /** CONFIRMED */
  Confirmed = 'CONFIRMED',
  /** RESOLVED */
  Resolved = 'RESOLVED',
  /** RULED_OUT */
  RuledOut = 'RULED_OUT',
  /** TENTATIVE */
  Tentative = 'TENTATIVE'
}

export type MedicalDifferentialStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalDifferentialStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalDifferentialStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalDifferentialStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalDifferentialStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalDifferentialStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalDifferentialStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalDifferentialStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalDifferentialStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalDifferentialStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalDifferentialStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalDifferentialStatusEnum>;
};

export enum MedicalDispenseCancellationReasonEnum {
  /** DAMAGED_ITEM */
  DamagedItem = 'DAMAGED_ITEM',
  /** DID_NOT_RECEIVE_ORDER */
  DidNotReceiveOrder = 'DID_NOT_RECEIVE_ORDER',
  /** INCORRECT_ITEM */
  IncorrectItem = 'INCORRECT_ITEM',
  /** NO_LONGER_NEEDED */
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  /** OTHER */
  Other = 'OTHER',
  /** PRICE_CONCERN */
  PriceConcern = 'PRICE_CONCERN',
  /** VOIDED_PRESCRIPTION */
  VoidedPrescription = 'VOIDED_PRESCRIPTION',
  /** WRONG_SHIPPING_ADDRESS */
  WrongShippingAddress = 'WRONG_SHIPPING_ADDRESS'
}

export enum MedicalDispenseFulfillmentPreferenceEnum {
  /** COMPOUNDING_PHARMACY */
  CompoundingPharmacy = 'COMPOUNDING_PHARMACY',
  /** EXTERNAL */
  External = 'EXTERNAL',
  /** IN_CLINIC */
  InClinic = 'IN_CLINIC',
  /** PICKUP */
  Pickup = 'PICKUP',
  /** SHIP */
  Ship = 'SHIP'
}

export type MedicalDispenseFulfillmentPreferenceEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalDispenseFulfillmentPreferenceEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalDispenseFulfillmentPreferenceEnum>;
};

export enum MedicalDispenseSourceEnum {
  /** APP */
  App = 'APP',
  /** CLAUDE */
  Claude = 'CLAUDE'
}

export enum MedicalDispenseStatusEnum {
  /** CANCELED */
  Canceled = 'CANCELED',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** DENIED */
  Denied = 'DENIED',
  /** IN_FULFILLMENT */
  InFulfillment = 'IN_FULFILLMENT',
  /** PENDING */
  Pending = 'PENDING',
  /** READY_FOR_PICKUP */
  ReadyForPickup = 'READY_FOR_PICKUP'
}

export type MedicalDispenseStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalDispenseStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalDispenseStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalDispenseStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalDispenseStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalDispenseStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalDispenseStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalDispenseStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalDispenseStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalDispenseStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalDispenseStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalDispenseStatusEnum>;
};

export enum MedicalFlaggedTestResultComparisonOperatorEnum {
  /** CONTAINS */
  Contains = 'CONTAINS',
  /** EQUAL_TO */
  EqualTo = 'EQUAL_TO',
  /** GREATER_THAN */
  GreaterThan = 'GREATER_THAN',
  /** LESS_THAN */
  LessThan = 'LESS_THAN',
  /** NOT_CONTAINS */
  NotContains = 'NOT_CONTAINS',
  /** NOT_EQUAL_TO */
  NotEqualTo = 'NOT_EQUAL_TO'
}

export enum MedicalFlaggedTestResultSpeciesEnum {
  /** CANINE */
  Canine = 'CANINE',
  /** FELINE */
  Feline = 'FELINE'
}

export type MedicalFlaggedTestResultSpeciesEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalFlaggedTestResultSpeciesEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalFlaggedTestResultSpeciesEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalFlaggedTestResultSpeciesEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalFlaggedTestResultSpeciesEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalFlaggedTestResultSpeciesEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalFlaggedTestResultSpeciesEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalFlaggedTestResultSpeciesEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalFlaggedTestResultSpeciesEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalFlaggedTestResultSpeciesEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalFlaggedTestResultSpeciesEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalFlaggedTestResultSpeciesEnum>;
};

export enum MedicalHistoricalDiagnosticTestResultStatusEnum {
  /** ATLAB */
  Atlab = 'ATLAB',
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** COMPLETE */
  Complete = 'COMPLETE',
  /** CREATED */
  Created = 'CREATED',
  /** PARTIAL */
  Partial = 'PARTIAL',
  /** REVIEWED */
  Reviewed = 'REVIEWED',
  /** SUBMITTED */
  Submitted = 'SUBMITTED'
}

export type MedicalHistoricalDiagnosticTestResultStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalHistoricalDiagnosticTestResultStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalHistoricalDiagnosticTestResultStatusEnum>;
};

export enum MedicalIntegratedDiagnosticKindEnum {
  /** IN_HOUSE */
  InHouse = 'IN_HOUSE',
  /** REFERENCE */
  Reference = 'REFERENCE'
}

export enum MedicalIntegratedDiagnosticReasonForOrderingEnum {
  /** ACUTE_ILLNESS */
  AcuteIllness = 'ACUTE_ILLNESS',
  /** CHRONIC_MEDICATION_/_CHRONIC_DISEASE_MONITORING */
  ChronicMedicationChronicDiseaseMonitoring = 'CHRONIC_MEDICATION___CHRONIC_DISEASE_MONITORING',
  /** OTHER */
  Other = 'OTHER',
  /** PRE-ANESTHETIC */
  PreAnesthetic = 'PRE_ANESTHETIC',
  /** RECHECK */
  Recheck = 'RECHECK',
  /** ROUTINE_SCREENING */
  RoutineScreening = 'ROUTINE_SCREENING',
  /** SPECIFIC_ILLNESS_SUSPECTED */
  SpecificIllnessSuspected = 'SPECIFIC_ILLNESS_SUSPECTED'
}

export enum MedicalIntegratedDiagnosticRecommendedRxStatusEnum {
  /** EXPIRED */
  Expired = 'EXPIRED',
  /** MEMBER_PAID */
  MemberPaid = 'MEMBER_PAID',
  /** ORDERED */
  Ordered = 'ORDERED',
  /** RECOMMENDATION_SENT_TO_MEMBER */
  RecommendationSentToMember = 'RECOMMENDATION_SENT_TO_MEMBER',
  /** RECOMMENDED */
  Recommended = 'RECOMMENDED'
}

export enum MedicalIntegratedDiagnosticStatusEnum {
  /** ATLAB */
  Atlab = 'ATLAB',
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** COMPLETE */
  Complete = 'COMPLETE',
  /** CREATED */
  Created = 'CREATED',
  /** PARTIAL */
  Partial = 'PARTIAL',
  /** REVIEWED */
  Reviewed = 'REVIEWED',
  /** SUBMITTED */
  Submitted = 'SUBMITTED'
}

export type MedicalIntegratedDiagnosticStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalIntegratedDiagnosticStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalIntegratedDiagnosticStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalIntegratedDiagnosticStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalIntegratedDiagnosticStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalIntegratedDiagnosticStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalIntegratedDiagnosticStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalIntegratedDiagnosticStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalIntegratedDiagnosticStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalIntegratedDiagnosticStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalIntegratedDiagnosticStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalIntegratedDiagnosticStatusEnum>;
};

export enum MedicalPrescriptionApprovalStatusEnum {
  /** APPROVED */
  Approved = 'APPROVED',
  /** APPROVED_WITH_CHANGES */
  ApprovedWithChanges = 'APPROVED_WITH_CHANGES',
  /** DENIED */
  Denied = 'DENIED',
  /** PENDING_APPROVAL */
  PendingApproval = 'PENDING_APPROVAL'
}

export type MedicalPrescriptionApprovalStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<MedicalPrescriptionApprovalStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
};

export enum MedicalPrescriptionMedicationStatusEnum {
  /** COMPLETE */
  Complete = 'COMPLETE',
  /** DISCONTINUED */
  Discontinued = 'DISCONTINUED',
  /** TAKING */
  Taking = 'TAKING'
}

export enum MedicalPrescriptionReasonForDenialEnum {
  /** NEEDS_BLOOD_PRESSURE */
  NeedsBloodPressure = 'NEEDS_BLOOD_PRESSURE',
  /** NEEDS_BLOOD_WORK */
  NeedsBloodWork = 'NEEDS_BLOOD_WORK',
  /** NEEDS_DOCTOR_APPOINTMENT */
  NeedsDoctorAppointment = 'NEEDS_DOCTOR_APPOINTMENT',
  /** NOT_MEDICALLY_APPROPRIATE */
  NotMedicallyAppropriate = 'NOT_MEDICALLY_APPROPRIATE'
}

export enum MedicalPrescriptionStartInstructionEnum {
  /** AS NEEDED */
  AsNeeded = 'AS_NEEDED',
  /** TODAY */
  Today = 'TODAY',
  /** TOMORROW */
  Tomorrow = 'TOMORROW',
  /** TONIGHT */
  Tonight = 'TONIGHT'
}

export enum MedicalVaccineImmunizationTypeEnum {
  /** BOOSTER */
  Booster = 'BOOSTER',
  /** INITIAL */
  Initial = 'INITIAL'
}

export enum MedicalVaccineRouteEnum {
  /** DROPS */
  Drops = 'DROPS',
  /** INTRAMUSCULAR */
  Intramuscular = 'INTRAMUSCULAR',
  /** INTRAVENOUSLY */
  Intravenously = 'INTRAVENOUSLY',
  /** OINTMENT */
  Ointment = 'OINTMENT',
  /** ORAL */
  Oral = 'ORAL',
  /** SUBCUTANEOUS */
  Subcutaneous = 'SUBCUTANEOUS',
  /** TOPICAL */
  Topical = 'TOPICAL'
}

export enum MedicalVitalsCrtEnum {
  /** <1 */
  BelowNormal = 'BELOW_NORMAL',
  /** 1-2 (normal) */
  Normal = 'NORMAL',
  /** Prolonged */
  Prolonged = 'PROLONGED'
}

export enum MedicalVitalsHydrationEnum {
  /** Euhydrated (normal) */
  Euhydrated = 'EUHYDRATED',
  /** Mild (5-7%) */
  Mild = 'MILD',
  /** Moderate (7-10%) */
  Moderate = 'MODERATE',
  /** Overhydrated */
  Overhydrated = 'OVERHYDRATED',
  /** Severe (>10%) */
  Severe = 'SEVERE'
}

export enum MedicalVitalsMentationEnum {
  /** Anesthetized */
  Anesthetized = 'ANESTHETIZED',
  /** Bright Alert and Responsive (BAR) */
  Bar = 'BAR',
  /** Depressed */
  Depressed = 'DEPRESSED',
  /** Dull */
  Dull = 'DULL',
  /** Quite Alert and Responsive (QAR) */
  Qar = 'QAR',
  /** Sedated */
  Sedated = 'SEDATED'
}

export enum MedicalVitalsMucousMembraneEnum {
  /** Brick Red */
  BrickRed = 'BRICK_RED',
  /** Brown */
  Brown = 'BROWN',
  /** Cyanotic */
  Cyanotic = 'CYANOTIC',
  /** Icteric */
  Icteric = 'ICTERIC',
  /** Pale Pink */
  PalePink = 'PALE_PINK',
  /** Pink */
  Pink = 'PINK',
  /** White */
  White = 'WHITE'
}

export type MedicationFilter = {
  AND?: InputMaybe<MedicationFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<MedicationFilter>;
  OR?: InputMaybe<MedicationFilter>;
  forCanine?: InputMaybe<Scalars['Boolean']['input']>;
  forFeline?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum MedicationFulfillmentMethodEnum {
  CompoundingPharmacy = 'COMPOUNDING_PHARMACY',
  External = 'EXTERNAL',
  InClinic = 'IN_CLINIC',
  Pickup = 'PICKUP',
  Ship = 'SHIP',
  Unknown = 'UNKNOWN'
}

export type MedicationType = {
  __typename?: 'MedicationType';
  created: Scalars['DateTime']['output'];
  defaultRefillQuantity: Scalars['Int']['output'];
  defaultSig: Maybe<Scalars['String']['output']>;
  forCanine: Scalars['Boolean']['output'];
  forFeline: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isOtc: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  prescriptionProductDetails: Array<PrescriptionProductDetailsType>;
  strengths: Array<Maybe<Scalars['String']['output']>>;
};


export type MedicationTypePrescriptionProductDetailsArgs = {
  forCanine?: InputMaybe<Scalars['Boolean']['input']>;
  forFeline?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MedicationTypeStrengthsArgs = {
  forCanine?: InputMaybe<Scalars['Boolean']['input']>;
  forFeline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MembershipFilter = {
  AND?: InputMaybe<MembershipFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<MembershipFilter>;
  OR?: InputMaybe<MembershipFilter>;
  endDate?: InputMaybe<DatetimeDatetimeFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
  patient?: InputMaybe<PatientFilter>;
  startDate?: InputMaybe<DatetimeDatetimeFilterLookup>;
  tier?: InputMaybe<CustomerMembershipTierEnumFilterLookup>;
};

export type MembershipInput = {
  changeNote?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  nextDesiredTier?: InputMaybe<CustomerMembershipNextDesiredTierEnum>;
  patient: OneToManyInput;
  reasonForChange?: InputMaybe<CustomerMembershipReasonForChangeEnum>;
  tier: CustomerMembershipTierEnum;
};

export type MembershipInputPartial = {
  changeNote?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  nextDesiredTier?: InputMaybe<CustomerMembershipNextDesiredTierEnum>;
  patient?: InputMaybe<OneToManyInput>;
  reasonForChange?: InputMaybe<CustomerMembershipReasonForChangeEnum>;
  tier?: InputMaybe<CustomerMembershipTierEnum>;
};

export type MembershipOrder = {
  created?: InputMaybe<Ordering>;
  endDate?: InputMaybe<Ordering>;
  startDate?: InputMaybe<Ordering>;
};

export type MembershipType = {
  __typename?: 'MembershipType';
  changeNote: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  endDate: Maybe<Scalars['DateTime']['output']>;
  expirationDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isSetForMembershipRenewal: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  nextDesiredTier: Maybe<CustomerMembershipNextDesiredTierEnum>;
  patient: PatientType;
  reasonForChange: Maybe<CustomerMembershipReasonForChangeEnum>;
  startDate: Scalars['DateTime']['output'];
  tier: CustomerMembershipTierEnum;
};

export type MessageAttachmentType = {
  __typename?: 'MessageAttachmentType';
  contentType: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type MessageFilter = {
  AND?: InputMaybe<MessageFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<MessageFilter>;
  OR?: InputMaybe<MessageFilter>;
  client?: InputMaybe<ClientFilter>;
  conversation?: InputMaybe<ConversationFilter>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isSierraAiSummary?: InputMaybe<Scalars['Boolean']['input']>;
  isTriageResponse?: InputMaybe<BoolBaseFilterLookup>;
  readAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
  staff?: InputMaybe<StaffFilter>;
};

export type MessageInput = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<OneToManyInput>;
  conversation: OneToManyInput;
  cta?: InputMaybe<OneToManyInput>;
  ctaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  isTriageResponse?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  smartChatApiTiming?: InputMaybe<Scalars['Int']['input']>;
  smartChatClassification?: InputMaybe<Scalars['String']['input']>;
  smartChatGenerationTiming?: InputMaybe<Scalars['Int']['input']>;
  smartChatIsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  smartChatSuggestionBody?: InputMaybe<Scalars['String']['input']>;
  smartChatSuggestionModel?: InputMaybe<Scalars['String']['input']>;
  smartChatTiming?: InputMaybe<Scalars['Int']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  useMessageEmbeddings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageInputPartial = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<OneToManyInput>;
  conversation?: InputMaybe<OneToManyInput>;
  cta?: InputMaybe<OneToManyInput>;
  ctaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isTriageResponse?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
  smartChatApiTiming?: InputMaybe<Scalars['Int']['input']>;
  smartChatClassification?: InputMaybe<Scalars['String']['input']>;
  smartChatGenerationTiming?: InputMaybe<Scalars['Int']['input']>;
  smartChatIsUsed?: InputMaybe<Scalars['Boolean']['input']>;
  smartChatSuggestionBody?: InputMaybe<Scalars['String']['input']>;
  smartChatSuggestionModel?: InputMaybe<Scalars['String']['input']>;
  smartChatTiming?: InputMaybe<Scalars['Int']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  useMessageEmbeddings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageOrder = {
  created?: InputMaybe<Ordering>;
  index?: InputMaybe<Ordering>;
};

export type MessageType = {
  __typename?: 'MessageType';
  attachment: Maybe<MessageAttachmentType>;
  body: Maybe<Scalars['String']['output']>;
  client: Maybe<ClientType>;
  conversation: ConversationType;
  created: Scalars['DateTime']['output'];
  cta: Maybe<ChatCtaType>;
  ctaEnabled: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  isSierraAiSummary: Scalars['Boolean']['output'];
  isTriageResponse: Scalars['Boolean']['output'];
  isUrgent: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  readAt: Maybe<Scalars['DateTime']['output']>;
  smartChatApiTiming: Maybe<Scalars['Int']['output']>;
  smartChatClassification: Maybe<Scalars['String']['output']>;
  smartChatGenerationTiming: Maybe<Scalars['Int']['output']>;
  smartChatImageCaption: Maybe<Scalars['String']['output']>;
  smartChatIsUsed: Scalars['Boolean']['output'];
  smartChatSuggestionBody: Maybe<Scalars['String']['output']>;
  smartChatTiming: Maybe<Scalars['Int']['output']>;
  staff: Maybe<StaffType>;
  useMessageEmbeddings: Scalars['Boolean']['output'];
};

export type MonographFileType = {
  __typename?: 'MonographFileType';
  fileBytesBase64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  approvePayment: DispenseType;
  authorizePhone: AuthorizePhone;
  createAccountCredit: AccountCreditType;
  createAppointment: AppointmentType;
  createAppointments: Array<AppointmentType>;
  createAttachment: AttachmentType;
  createAutoship: AutoshipType;
  createClient: ClientType;
  createClientCommunication: ClientCommunicationType;
  createClientProcedureBooking: ClientProcedureBookingType;
  createClinicalNote: ClinicalNoteType;
  createClinicalRecord: ClinicalRecordType;
  createConditionResolution: ConditionResolutionType;
  createConversation: ConversationType;
  createCreditCard: CreditCardType;
  createDiagnosticTestResult: DiagnosticTestResultType;
  createDispense: DispenseType;
  createEstimate: EstimateType;
  createEstimateItems: Array<EstimateItemType>;
  createExternalClinic: ExternalClinicType;
  createFcmDevice: FcmDeviceType;
  createInboundMedicalRecordRequest: InboundMedicalRecordRequestType;
  createIntakeQuestions: IntakeQuestionsType;
  createIntegratedDiagnostic: IntegratedDiagnosticType;
  createInteraction: InteractionType;
  createInvoice: InvoiceType;
  createInvoiceItems: Array<InvoiceItemType>;
  createMembership: MembershipType;
  createMessage: MessageType;
  createNonIntegratedDiagnostic: NonIntegratedDiagnosticType;
  createPatient: PatientType;
  createPrescription: PrescriptionType;
  createSlot: SlotType;
  createSlots: Array<SlotType>;
  createStarRating: StarRatingsType;
  createTask: TaskType;
  createTaskAttachment: TaskAttachmentType;
  createTaskAttachments: Array<TaskAttachmentType>;
  createTouch: TouchType;
  createTransaction: TransactionType;
  createVaccine: VaccineType;
  createVitals: VitalsType;
  createWaitlist: WaitlistType;
  deleteAppointments: Array<AppointmentType>;
  deleteAttachment: AttachmentType;
  deleteClientCommunication: ClientCommunicationType;
  deleteClinicalNote: ClinicalNoteType;
  deleteDiagnosticTestResult: DiagnosticTestResultType;
  deleteEstimate: EstimateType;
  deleteEstimateItem: EstimateItemType;
  deleteEstimateItems: Array<EstimateItemType>;
  deleteIntakeQuestions: IntakeQuestionsType;
  deleteIntegratedDiagnostic: IntegratedDiagnosticType;
  deleteInvoice: InvoiceType;
  deleteInvoiceItem: InvoiceItemType;
  deleteInvoiceItems: Array<InvoiceItemType>;
  deleteNonIntegratedDiagnostic: NonIntegratedDiagnosticType;
  deleteSlots: Array<SlotType>;
  deleteVaccine: VaccineType;
  deleteVitals: VitalsType;
  generateSmartCommunicationSummary: GenerateSmartCommunicationSummaryResponseType;
  merge: ConfirmationType;
  orderDispense: DispenseType;
  orderDispenseNew: DispenseType;
  patchAccountCredit: AccountCreditType;
  patchAppointment: AppointmentType;
  patchAppointments: Array<AppointmentType>;
  patchAutoship: AutoshipType;
  patchAutoships: Array<AutoshipType>;
  patchCarePlanItem: CarePlanItemType;
  patchClient: ClientType;
  patchClientCommunication: ClientCommunicationType;
  patchClinicalRecord: ClinicalRecordType;
  patchCreditCard: CreditCardType;
  patchDiagnosticTestResult: DiagnosticTestResultType;
  patchDifferential: DifferentialType;
  patchDispense: DispenseType;
  patchEstimate: EstimateType;
  patchEstimateItems: Array<EstimateItemType>;
  patchFcmDevice: FcmDeviceType;
  patchHousehold: HouseholdType;
  patchIntakeQuestions: IntakeQuestionsType;
  patchIntegratedDiagnostic: IntegratedDiagnosticType;
  patchInteraction: InteractionType;
  patchInvoice: InvoiceType;
  patchInvoiceItems: Array<InvoiceItemType>;
  patchMembership: MembershipType;
  patchMessages: Array<MessageType>;
  patchNotifications: Array<NotificationType>;
  patchPatient: PatientType;
  patchPrescription: PrescriptionType;
  patchSlot: SlotType;
  patchSlots: Array<SlotType>;
  patchStaff: StaffType;
  patchTask: TaskType;
  patchVaccine: VaccineType;
  patchVitals: VitalsType;
  requestPrescription: DispenseType;
  rescheduleAppointment: RescheduleAppointmentType;
  sendSms: SendSmsType;
  skipNpsSurvey: NpsSurveyResponseType;
};


export type MutationApprovePaymentArgs = {
  creditCardId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  shippingApartment?: InputMaybe<Scalars['String']['input']>;
  shippingCity?: InputMaybe<Scalars['String']['input']>;
  shippingState?: InputMaybe<Scalars['String']['input']>;
  shippingZipcode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAuthorizePhoneArgs = {
  alwaysSendSms?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAccountCreditArgs = {
  data: AccountCreditInput;
};


export type MutationCreateAppointmentArgs = {
  data: AppointmentInput;
};


export type MutationCreateAppointmentsArgs = {
  data: Array<AppointmentInput>;
  filters: InputMaybe<AppointmentFilter>;
};


export type MutationCreateAttachmentArgs = {
  data: AttachmentInput;
};


export type MutationCreateAutoshipArgs = {
  data: AutoshipInput;
};


export type MutationCreateClientArgs = {
  data: ClientInput;
};


export type MutationCreateClientCommunicationArgs = {
  data: ClientCommunicationInput;
};


export type MutationCreateClientProcedureBookingArgs = {
  data: ClientProcedureBookingInput;
};


export type MutationCreateClinicalNoteArgs = {
  data: ClinicalNoteInput;
};


export type MutationCreateClinicalRecordArgs = {
  data: ClinicalRecordInput;
};


export type MutationCreateConditionResolutionArgs = {
  data: ConditionResolutionInput;
};


export type MutationCreateConversationArgs = {
  data: ConversationInput;
};


export type MutationCreateCreditCardArgs = {
  data: CreditCardInput;
};


export type MutationCreateDiagnosticTestResultArgs = {
  data: DiagnosticTestResultInput;
};


export type MutationCreateDispenseArgs = {
  data: DispenseInput;
};


export type MutationCreateEstimateArgs = {
  data: EstimateInput;
};


export type MutationCreateEstimateItemsArgs = {
  data: Array<EstimateItemInput>;
  filters: InputMaybe<EstimateItemFilter>;
};


export type MutationCreateExternalClinicArgs = {
  data: ExternalClinicInput;
};


export type MutationCreateFcmDeviceArgs = {
  data: FcmDeviceInput;
};


export type MutationCreateInboundMedicalRecordRequestArgs = {
  data: InboundMedicalRecordRequestInput;
};


export type MutationCreateIntakeQuestionsArgs = {
  data: IntakeQuestionsInput;
};


export type MutationCreateIntegratedDiagnosticArgs = {
  data: IntegratedDiagnosticInput;
};


export type MutationCreateInteractionArgs = {
  data: InteractionInput;
};


export type MutationCreateInvoiceArgs = {
  data: InvoiceInput;
};


export type MutationCreateInvoiceItemsArgs = {
  data: Array<InvoiceItemInput>;
  filters: InputMaybe<InvoiceItemFilter>;
};


export type MutationCreateMembershipArgs = {
  data: MembershipInput;
};


export type MutationCreateMessageArgs = {
  data: MessageInput;
};


export type MutationCreateNonIntegratedDiagnosticArgs = {
  data: NonIntegratedDiagnosticInput;
};


export type MutationCreatePatientArgs = {
  data: PatientInput;
};


export type MutationCreatePrescriptionArgs = {
  data: PrescriptionInput;
};


export type MutationCreateSlotArgs = {
  data: SlotInput;
};


export type MutationCreateSlotsArgs = {
  data: Array<SlotInput>;
  filters: InputMaybe<SlotFilter>;
};


export type MutationCreateStarRatingArgs = {
  data: StarRatingInput;
};


export type MutationCreateTaskArgs = {
  data: TaskInput;
};


export type MutationCreateTaskAttachmentArgs = {
  data: TaskAttachmentInput;
};


export type MutationCreateTaskAttachmentsArgs = {
  data: Array<TaskAttachmentInput>;
};


export type MutationCreateTouchArgs = {
  data: TouchInput;
};


export type MutationCreateTransactionArgs = {
  data: TransactionInput;
};


export type MutationCreateVaccineArgs = {
  data: VaccineInput;
};


export type MutationCreateVitalsArgs = {
  data: VitalsInput;
};


export type MutationCreateWaitlistArgs = {
  data: WaitlistInput;
};


export type MutationDeleteAppointmentsArgs = {
  filters: InputMaybe<AppointmentFilter>;
};


export type MutationDeleteAttachmentArgs = {
  data: AttachmentInputPartial;
};


export type MutationDeleteClientCommunicationArgs = {
  data: ClientCommunicationInputPartial;
};


export type MutationDeleteClinicalNoteArgs = {
  data: ClinicalNoteInputPartial;
};


export type MutationDeleteDiagnosticTestResultArgs = {
  data: DiagnosticTestResultInputPartial;
};


export type MutationDeleteEstimateArgs = {
  data: EstimateInputPartial;
};


export type MutationDeleteEstimateItemArgs = {
  data: EstimateItemInputPartial;
};


export type MutationDeleteEstimateItemsArgs = {
  filters: InputMaybe<EstimateItemFilter>;
};


export type MutationDeleteIntakeQuestionsArgs = {
  data: IntakeQuestionsInputPartial;
};


export type MutationDeleteIntegratedDiagnosticArgs = {
  data: IntegratedDiagnosticInputPartial;
};


export type MutationDeleteInvoiceArgs = {
  data: InvoiceInputPartial;
};


export type MutationDeleteInvoiceItemArgs = {
  data: InvoiceItemInputPartial;
};


export type MutationDeleteInvoiceItemsArgs = {
  filters: InputMaybe<InvoiceItemFilter>;
};


export type MutationDeleteNonIntegratedDiagnosticArgs = {
  data: NonIntegratedDiagnosticInputPartial;
};


export type MutationDeleteSlotsArgs = {
  filters: InputMaybe<SlotFilter>;
};


export type MutationDeleteVaccineArgs = {
  data: VaccineInputPartial;
};


export type MutationDeleteVitalsArgs = {
  data: VitalsInputPartial;
};


export type MutationGenerateSmartCommunicationSummaryArgs = {
  data: GenerateSmartCommunicationSummaryInput;
};


export type MutationMergeArgs = {
  mergeKind: CustomerMergeLogKindEnum;
  primaryId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  secondaryId: Scalars['String']['input'];
};


export type MutationOrderDispenseArgs = {
  data: DispenseInput;
};


export type MutationOrderDispenseNewArgs = {
  data: DispenseInputWithCreditCard;
};


export type MutationPatchAccountCreditArgs = {
  data: AccountCreditInputPartial;
};


export type MutationPatchAppointmentArgs = {
  data: AppointmentInputPartial;
};


export type MutationPatchAppointmentsArgs = {
  data: Array<AppointmentInputPartial>;
  filters: InputMaybe<AppointmentFilter>;
};


export type MutationPatchAutoshipArgs = {
  data: AutoshipInputPartial;
};


export type MutationPatchAutoshipsArgs = {
  data: Array<AutoshipInputPartial>;
  filters: InputMaybe<AutoshipFilter>;
};


export type MutationPatchCarePlanItemArgs = {
  data: CarePlanItemInputPartial;
};


export type MutationPatchClientArgs = {
  data: ClientInputPartial;
};


export type MutationPatchClientCommunicationArgs = {
  data: ClientCommunicationInputPartial;
};


export type MutationPatchClinicalRecordArgs = {
  data: ClinicalRecordInputPartial;
};


export type MutationPatchCreditCardArgs = {
  data: CreditCardInputPartial;
};


export type MutationPatchDiagnosticTestResultArgs = {
  data: DiagnosticTestResultInputPartial;
};


export type MutationPatchDifferentialArgs = {
  data: DifferentialInputPartial;
};


export type MutationPatchDispenseArgs = {
  data: DispenseInputPartial;
};


export type MutationPatchEstimateArgs = {
  data: EstimateInputPartial;
};


export type MutationPatchEstimateItemsArgs = {
  data: Array<EstimateItemInputPartial>;
  filters: InputMaybe<EstimateItemFilter>;
};


export type MutationPatchFcmDeviceArgs = {
  data: FcmDeviceInputPartial;
};


export type MutationPatchHouseholdArgs = {
  data: HouseholdInputPartial;
};


export type MutationPatchIntakeQuestionsArgs = {
  data: IntakeQuestionsInputPartial;
};


export type MutationPatchIntegratedDiagnosticArgs = {
  data: IntegratedDiagnosticInputPartial;
};


export type MutationPatchInteractionArgs = {
  data: InteractionInputPartial;
};


export type MutationPatchInvoiceArgs = {
  data: InvoiceInputPartial;
};


export type MutationPatchInvoiceItemsArgs = {
  data: Array<InvoiceItemInputPartial>;
  filters: InputMaybe<InvoiceItemFilter>;
};


export type MutationPatchMembershipArgs = {
  data: MembershipInputPartial;
};


export type MutationPatchMessagesArgs = {
  data: Array<MessageInputPartial>;
  filters: InputMaybe<MessageFilter>;
};


export type MutationPatchNotificationsArgs = {
  data: Array<NotificationInputPartial>;
  filters: InputMaybe<NotificationFilter>;
};


export type MutationPatchPatientArgs = {
  data: PatientInputPartial;
};


export type MutationPatchPrescriptionArgs = {
  data: PrescriptionInputPartial;
};


export type MutationPatchSlotArgs = {
  data: SlotInputPartial;
};


export type MutationPatchSlotsArgs = {
  data: Array<SlotInputPartial>;
  filters: InputMaybe<SlotFilter>;
};


export type MutationPatchStaffArgs = {
  data: StaffInputPartial;
};


export type MutationPatchTaskArgs = {
  data: TaskInputPartial;
};


export type MutationPatchVaccineArgs = {
  data: VaccineInputPartial;
};


export type MutationPatchVitalsArgs = {
  data: VitalsInputPartial;
};


export type MutationRequestPrescriptionArgs = {
  data: RequestPrescriptionInput;
};


export type MutationRescheduleAppointmentArgs = {
  newAppointmentInput: AppointmentInput;
  oldAppointmentId: Scalars['ID']['input'];
};


export type MutationSendSmsArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationSkipNpsSurveyArgs = {
  clientId: Scalars['Int']['input'];
  householdId: Scalars['Int']['input'];
};

export type NpsSurveyResponseType = {
  __typename?: 'NPSSurveyResponseType';
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

export type NonIntegratedDiagnosticFilter = {
  AND?: InputMaybe<NonIntegratedDiagnosticFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<NonIntegratedDiagnosticFilter>;
  OR?: InputMaybe<NonIntegratedDiagnosticFilter>;
  clinicalRecord?: InputMaybe<ClinicalRecordFilter>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
};

export type NonIntegratedDiagnosticInput = {
  clinicalRecord: OneToManyInput;
};

export type NonIntegratedDiagnosticInputPartial = {
  clinicalRecord?: InputMaybe<OneToManyInput>;
  id: Scalars['ID']['input'];
};

export type NonIntegratedDiagnosticOrder = {
  created?: InputMaybe<Ordering>;
};

export type NonIntegratedDiagnosticType = {
  __typename?: 'NonIntegratedDiagnosticType';
  clinicalRecord: ClinicalRecordType;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use TestResult */
  internalInterpretation: Maybe<Scalars['String']['output']>;
  /** @deprecated Use TestResult */
  interpretationChangedSinceLastSent: Scalars['Boolean']['output'];
  /** @deprecated Use TestResult */
  interpretationSummary: Maybe<Scalars['String']['output']>;
  /** @deprecated Use TestResult */
  interpreter: Maybe<StaffType>;
  isInhouseDiagnostic: Scalars['Boolean']['output'];
  isReferenceDiagnostic: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  /** @deprecated Use TestResult */
  partialInternalInterpretation: Maybe<Scalars['Void']['output']>;
  /** @deprecated Use TestResult */
  partialReviewedAt: Maybe<Scalars['Void']['output']>;
  prescriptions: Array<PrescriptionType>;
  /** @deprecated Use TestResult */
  reviewedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use TestResult */
  smartInterpretationSummary: Maybe<Scalars['String']['output']>;
  /** @deprecated Use TestResult */
  staff: Maybe<StaffType>;
  testResults: Array<DiagnosticTestResultType>;
  /** @deprecated Use TestResult */
  tests: Array<ProductType>;
};


export type NonIntegratedDiagnosticTypePrescriptionsArgs = {
  filters: InputMaybe<PrescriptionFilter>;
  order: InputMaybe<PrescriptionOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type NonIntegratedDiagnosticTypeTestResultsArgs = {
  filters: InputMaybe<DiagnosticTestResultFilter>;
  order: InputMaybe<DiagnosticTestResultOrder>;
};

export type NotificationFilter = {
  AND?: InputMaybe<NotificationFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<NotificationFilter>;
  OR?: InputMaybe<NotificationFilter>;
  household?: InputMaybe<HouseholdFilter>;
  readAt?: InputMaybe<DatetimeDatetimeFilterLookup>;
};

export type NotificationInputPartial = {
  id: Scalars['ID']['input'];
  readAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationOrder = {
  created?: InputMaybe<Ordering>;
};

export type NotificationType = {
  __typename?: 'NotificationType';
  appointment: Maybe<AppointmentType>;
  body: Maybe<Scalars['String']['output']>;
  clinicalRecord: Maybe<ClinicalRecordType>;
  created: Scalars['DateTime']['output'];
  diagnosticTestResult: Maybe<DiagnosticTestResultType>;
  dispense: Maybe<DispenseType>;
  estimate: Maybe<EstimateType>;
  household: HouseholdType;
  id: Scalars['ID']['output'];
  invoice: Maybe<InvoiceType>;
  modified: Scalars['DateTime']['output'];
  patient: Maybe<PatientType>;
  prescription: Maybe<PrescriptionType>;
  readAt: Maybe<Scalars['DateTime']['output']>;
  sourceTemplate: CommunicationTemplateType;
  title: Scalars['String']['output'];
};

export type OffsetPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
};

export type OneToManyInput = {
  set?: InputMaybe<Scalars['ID']['input']>;
};

export type OneToOneInput = {
  set?: InputMaybe<Scalars['ID']['input']>;
};

export type OperationalUnitFilter = {
  AND?: InputMaybe<OperationalUnitFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<OperationalUnitFilter>;
  OR?: InputMaybe<OperationalUnitFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  location?: InputMaybe<LocationFilter>;
};

export type OperationalUnitType = {
  __typename?: 'OperationalUnitType';
  companyName: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  deputyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: DjangoModelType;
  modified: Scalars['DateTime']['output'];
  operationalUnitName: Scalars['String']['output'];
  shouldNotReceiveTasks: Scalars['Boolean']['output'];
};

export enum Ordering {
  Asc = 'ASC',
  AscNullsFirst = 'ASC_NULLS_FIRST',
  AscNullsLast = 'ASC_NULLS_LAST',
  Desc = 'DESC',
  DescNullsFirst = 'DESC_NULLS_FIRST',
  DescNullsLast = 'DESC_NULLS_LAST'
}

export type PatientFilter = {
  AND?: InputMaybe<PatientFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<PatientFilter>;
  OR?: InputMaybe<PatientFilter>;
  deceasedDate?: InputMaybe<DatetimeDatetimeFilterLookup>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isActiveMember?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PatientInput = {
  alerts?: InputMaybe<Array<Scalars['String']['input']>>;
  birthdate: Scalars['Date']['input'];
  breedLookup: OneToManyInput;
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<CustomerPatientCancellationReasonEnum>;
  colorLookup: OneToManyInput;
  deceasedDate?: InputMaybe<Scalars['DateTime']['input']>;
  fearFreeNotes?: InputMaybe<Scalars['String']['input']>;
  goalWeight?: InputMaybe<Scalars['Float']['input']>;
  hasDeclaredNoPreviousRecords?: InputMaybe<Scalars['Boolean']['input']>;
  household: OneToManyInput;
  image?: InputMaybe<Scalars['Upload']['input']>;
  insuranceLookup?: InputMaybe<OneToManyInput>;
  isMixed?: InputMaybe<Scalars['Boolean']['input']>;
  isScanned?: InputMaybe<Scalars['Boolean']['input']>;
  isSetForMembershipRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  microchipDate?: InputMaybe<Scalars['Date']['input']>;
  microchipRegisteredViaPetlink?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  needsRecords?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  otherNames?: InputMaybe<Scalars['String']['input']>;
  recordsAvailability?: InputMaybe<CustomerPatientRecordsAvailabilityEnum>;
  sex?: InputMaybe<CustomerPatientSexEnum>;
  spayedOrNeutered?: InputMaybe<Scalars['Boolean']['input']>;
  species: CustomerPatientSpeciesEnum;
  vcprDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PatientInputPartial = {
  alerts?: InputMaybe<Array<Scalars['String']['input']>>;
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  breedLookup?: InputMaybe<OneToManyInput>;
  cancellationNote?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<CustomerPatientCancellationReasonEnum>;
  colorLookup?: InputMaybe<OneToManyInput>;
  deceasedDate?: InputMaybe<Scalars['DateTime']['input']>;
  fearFreeNotes?: InputMaybe<Scalars['String']['input']>;
  goalWeight?: InputMaybe<Scalars['Float']['input']>;
  hasDeclaredNoPreviousRecords?: InputMaybe<Scalars['Boolean']['input']>;
  household?: InputMaybe<OneToManyInput>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  insuranceLookup?: InputMaybe<OneToManyInput>;
  isMixed?: InputMaybe<Scalars['Boolean']['input']>;
  isScanned?: InputMaybe<Scalars['Boolean']['input']>;
  isSetForMembershipRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  microchip?: InputMaybe<Scalars['String']['input']>;
  microchipDate?: InputMaybe<Scalars['Date']['input']>;
  microchipRegisteredViaPetlink?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsRecords?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  otherNames?: InputMaybe<Scalars['String']['input']>;
  recordsAvailability?: InputMaybe<CustomerPatientRecordsAvailabilityEnum>;
  sex?: InputMaybe<CustomerPatientSexEnum>;
  spayedOrNeutered?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<CustomerPatientSpeciesEnum>;
  vcprDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PatientOrder = {
  created?: InputMaybe<Ordering>;
};

export type PatientOverviewHistoryType = {
  __typename?: 'PatientOverviewHistoryType';
  lastSeenBy: Scalars['String']['output'];
  yourHistory: Scalars['String']['output'];
};

export type PatientType = {
  __typename?: 'PatientType';
  age: Scalars['Float']['output'];
  alerts: Array<Scalars['String']['output']>;
  appointments: Array<AppointmentType>;
  attachments: Maybe<Array<AttachmentType>>;
  birthdate: Scalars['Date']['output'];
  breedLookup: BreedType;
  cancellationNote: Maybe<Scalars['String']['output']>;
  cancellationReason: Scalars['String']['output'];
  carePlanItems: Array<CarePlanItemType>;
  clinicalRecords: Array<ClinicalRecordType>;
  colorLookup: ColorType;
  conversations: Array<ConversationType>;
  cprConsent: Maybe<Scalars['Boolean']['output']>;
  created: Scalars['DateTime']['output'];
  deceasedDate: Maybe<Scalars['DateTime']['output']>;
  estimates: Array<EstimateType>;
  fearFreeNotes: Maybe<Scalars['String']['output']>;
  fearFreeNotesModified: Maybe<Scalars['DateTime']['output']>;
  fearFreeNotesModifiedBy: Maybe<Scalars['String']['output']>;
  goalWeight: Maybe<Scalars['Float']['output']>;
  hasDeclaredNoPreviousRecords: Scalars['Boolean']['output'];
  household: HouseholdType;
  id: Scalars['ID']['output'];
  image: Maybe<DjangoImageType>;
  insuranceLookup: Maybe<InsuranceType>;
  invoices: Array<InvoiceType>;
  isActiveMember: Scalars['Boolean']['output'];
  isMixed: Scalars['Boolean']['output'];
  isScanned: Scalars['Boolean']['output'];
  isSetForMembershipRenewal: Scalars['Boolean']['output'];
  /** @deprecated Query using filter & order client-side in Common & then remove this field */
  lastActiveMembership: Maybe<MembershipType>;
  lastFasScore: Maybe<Scalars['Int']['output']>;
  latestBcs: Maybe<Scalars['Int']['output']>;
  latestBcsDate: Maybe<Scalars['DateTime']['output']>;
  latestFasScore: Maybe<Scalars['Int']['output']>;
  latestFasScoreDate: Maybe<Scalars['DateTime']['output']>;
  latestWeight: Maybe<Scalars['Float']['output']>;
  latestWeightDate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use current_membership.expiration_date */
  membershipRenewalDate: Maybe<Scalars['Date']['output']>;
  memberships: Array<MembershipType>;
  microchip: Maybe<Scalars['String']['output']>;
  microchipDate: Maybe<Scalars['Date']['output']>;
  microchipPhone: Scalars['String']['output'];
  microchipRegisteredViaPetlink: Scalars['Boolean']['output'];
  microchipUrl: Scalars['String']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  needsRecords: Scalars['Boolean']['output'];
  notes: Maybe<Scalars['String']['output']>;
  notesModified: Maybe<Scalars['DateTime']['output']>;
  notesModifiedBy: Maybe<Scalars['String']['output']>;
  otherNames: Maybe<Scalars['String']['output']>;
  overview: Maybe<Scalars['String']['output']>;
  overviewGenerationDate: Maybe<Scalars['DateTime']['output']>;
  ownerLastName: Scalars['String']['output'];
  prescriptions: Array<PrescriptionType>;
  recordsAvailability: CustomerPatientRecordsAvailabilityEnum;
  sex: Maybe<CustomerPatientSexEnum>;
  spayedOrNeutered: Maybe<Scalars['Boolean']['output']>;
  species: CustomerPatientSpeciesEnum;
  speciesCorrected: Scalars['String']['output'];
  tasks: Array<TaskType>;
  tempConditionsGeneratedFromAi: Maybe<Scalars['Boolean']['output']>;
  tier: Scalars['String']['output'];
  vcprDate: Maybe<Scalars['DateTime']['output']>;
  vcprExpired: Scalars['Boolean']['output'];
  vcprStatus: Maybe<Scalars['Int']['output']>;
};


export type PatientTypeAppointmentsArgs = {
  filters: InputMaybe<AppointmentFilter>;
  order: InputMaybe<AppointmentOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type PatientTypeAttachmentsArgs = {
  filters: InputMaybe<AttachmentFilter>;
};


export type PatientTypeCarePlanItemsArgs = {
  filters: InputMaybe<CarePlanItemFilter>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type PatientTypeClinicalRecordsArgs = {
  filters: InputMaybe<ClinicalRecordFilter>;
  order: InputMaybe<ClinicalRecordOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type PatientTypeConversationsArgs = {
  filters: InputMaybe<ConversationFilter>;
  order: InputMaybe<ConversationOrder>;
};


export type PatientTypeEstimatesArgs = {
  filters: InputMaybe<EstimateFilter>;
  order: InputMaybe<EstimateOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type PatientTypeInvoicesArgs = {
  filters: InputMaybe<InvoiceFilter>;
  order: InputMaybe<InvoiceOrder>;
};


export type PatientTypeMembershipsArgs = {
  filters: InputMaybe<MembershipFilter>;
  order: InputMaybe<MembershipOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type PatientTypePrescriptionsArgs = {
  filters: InputMaybe<PrescriptionFilter>;
  order: InputMaybe<PrescriptionOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type PatientTypeTasksArgs = {
  filters: InputMaybe<TaskFilter>;
  order: InputMaybe<TaskOrder>;
};

export type PrescriptionFilter = {
  AND?: InputMaybe<PrescriptionFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<PrescriptionFilter>;
  OR?: InputMaybe<PrescriptionFilter>;
  approvalStatus?: InputMaybe<MedicalPrescriptionApprovalStatusEnumFilterLookup>;
  autoships?: InputMaybe<AutoshipFilter>;
  clinicalRecord?: InputMaybe<ClinicalRecordFilter>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  expirationDate?: InputMaybe<DateDateFilterLookup>;
  historical?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isEligibleForAutoship?: InputMaybe<Scalars['Boolean']['input']>;
  medication?: InputMaybe<MedicationFilter>;
  patient?: InputMaybe<PatientFilter>;
  prescribeDate?: InputMaybe<DateDateFilterLookup>;
  strength?: InputMaybe<StrFilterLookup>;
  unassociatedName?: InputMaybe<StrFilterLookup>;
};

export type PrescriptionInput = {
  approvalStatus?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  clinicalRecord?: InputMaybe<OneToManyInput>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  dispense?: InputMaybe<DispenseInputPartial>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  historical?: InputMaybe<Scalars['Boolean']['input']>;
  integratedDiagnostic?: InputMaybe<OneToManyInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  medication?: InputMaybe<OneToManyInput>;
  medicationStatus?: InputMaybe<MedicalPrescriptionMedicationStatusEnum>;
  nonIntegratedDiagnostic?: InputMaybe<OneToManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteToMember?: InputMaybe<Scalars['String']['input']>;
  patient: OneToManyInput;
  prescribeDate?: InputMaybe<Scalars['Date']['input']>;
  prescriber?: InputMaybe<OneToManyInput>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  reasonForDenial?: InputMaybe<MedicalPrescriptionReasonForDenialEnum>;
  refills: Scalars['Int']['input'];
  sig?: InputMaybe<Scalars['String']['input']>;
  startInstruction?: InputMaybe<MedicalPrescriptionStartInstructionEnum>;
  strength?: InputMaybe<Scalars['String']['input']>;
  unassociatedName?: InputMaybe<Scalars['String']['input']>;
};

export type PrescriptionInputPartial = {
  approvalStatus?: InputMaybe<MedicalPrescriptionApprovalStatusEnum>;
  clinicalRecord?: InputMaybe<OneToManyInput>;
  completionDate?: InputMaybe<Scalars['Date']['input']>;
  dispense?: InputMaybe<DispenseInputPartial>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  historical?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  integratedDiagnostic?: InputMaybe<OneToManyInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  medication?: InputMaybe<OneToManyInput>;
  medicationStatus?: InputMaybe<MedicalPrescriptionMedicationStatusEnum>;
  nonIntegratedDiagnostic?: InputMaybe<OneToManyInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  noteToMember?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<OneToManyInput>;
  prescribeDate?: InputMaybe<Scalars['Date']['input']>;
  prescriber?: InputMaybe<OneToManyInput>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  reasonForDenial?: InputMaybe<MedicalPrescriptionReasonForDenialEnum>;
  refills?: InputMaybe<Scalars['Int']['input']>;
  sig?: InputMaybe<Scalars['String']['input']>;
  startInstruction?: InputMaybe<MedicalPrescriptionStartInstructionEnum>;
  strength?: InputMaybe<Scalars['String']['input']>;
  unassociatedName?: InputMaybe<Scalars['String']['input']>;
};

export type PrescriptionMedicalHistoryType = {
  __typename?: 'PrescriptionMedicalHistoryType';
  expirationDate: Scalars['Date']['output'];
  medicationStatus: MedicalPrescriptionMedicationStatusEnum;
  prescribeDate: Scalars['Date']['output'];
  refills: Scalars['Int']['output'];
  sig: Maybe<Scalars['String']['output']>;
  unassociatedName: Maybe<Scalars['String']['output']>;
};

export type PrescriptionOrder = {
  created?: InputMaybe<Ordering>;
  prescribeDate?: InputMaybe<Ordering>;
  prescribeDatetime?: InputMaybe<Ordering>;
};

export type PrescriptionProductDetailsType = {
  __typename?: 'PrescriptionProductDetailsType';
  count: Scalars['Decimal']['output'];
  strength: Maybe<Scalars['String']['output']>;
  units: Maybe<Scalars['String']['output']>;
};

export type PrescriptionType = {
  __typename?: 'PrescriptionType';
  approvalStatus: MedicalPrescriptionApprovalStatusEnum;
  autoships: Array<AutoshipType>;
  clinicalRecord: Maybe<ClinicalRecordType>;
  completionDate: Maybe<Scalars['Date']['output']>;
  created: Scalars['DateTime']['output'];
  dispenses: Array<DispenseType>;
  expirationDate: Scalars['Date']['output'];
  fillsRemaining: Scalars['Int']['output'];
  historical: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integratedDiagnostic: Maybe<IntegratedDiagnosticType>;
  isActive: Scalars['Boolean']['output'];
  isEligibleForAutoship: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  isPrn: Scalars['Boolean']['output'];
  lastDispense: Maybe<DispenseType>;
  license: Maybe<LicenseType>;
  medication: Maybe<MedicationType>;
  medicationStatus: MedicalPrescriptionMedicationStatusEnum;
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  nonIntegratedDiagnostic: Maybe<NonIntegratedDiagnosticType>;
  note: Maybe<Scalars['String']['output']>;
  noteToMember: Maybe<Scalars['String']['output']>;
  patient: PatientType;
  prescribeDate: Scalars['Date']['output'];
  prescriber: Maybe<StaffType>;
  quantity: Scalars['Decimal']['output'];
  reasonForDenial: Maybe<MedicalPrescriptionReasonForDenialEnum>;
  refills: Scalars['Int']['output'];
  sig: Maybe<Scalars['String']['output']>;
  startInstruction: Maybe<MedicalPrescriptionStartInstructionEnum>;
  strength: Maybe<Scalars['String']['output']>;
  taskSet: Array<TaskType>;
  timesAdministered: Scalars['Int']['output'];
  unassociatedName: Maybe<Scalars['String']['output']>;
};


export type PrescriptionTypeAutoshipsArgs = {
  filters: InputMaybe<AutoshipFilter>;
  order: InputMaybe<AutoshipOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type PrescriptionTypeDispensesArgs = {
  filters: InputMaybe<DispenseFilter>;
  order: InputMaybe<DispenseOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type PrescriptionTypeTaskSetArgs = {
  filters: InputMaybe<TaskFilter>;
  order: InputMaybe<TaskOrder>;
};

export type PreviousMedicalHistoryType = {
  __typename?: 'PreviousMedicalHistoryType';
  carePlanDiagnostics: Array<CarePlanDiagnosticsType>;
  prescriptions: Array<PrescriptionMedicalHistoryType>;
  vaccines: Array<BaseVaccineType>;
};

export type ProblemType = {
  __typename?: 'ProblemType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProductFilter = {
  AND?: InputMaybe<ProductFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ProductFilter>;
  OR?: InputMaybe<ProductFilter>;
  administeredInHouse?: InputMaybe<Scalars['Boolean']['input']>;
  carePlans?: InputMaybe<CarePlanGuidanceFilter>;
  count?: InputMaybe<Scalars['Decimal']['input']>;
  diagnosticType?: InputMaybe<CatalogProductDiagnosticTypeEnumFilterLookup>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  forCanine?: InputMaybe<Scalars['Boolean']['input']>;
  forFeline?: InputMaybe<Scalars['Boolean']['input']>;
  forProceduresOnly?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isAddOn?: InputMaybe<Scalars['Boolean']['input']>;
  isInternalUseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isShipOnly?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<LocationFilter>;
  medication?: InputMaybe<MedicationFilter>;
  name?: InputMaybe<StrFilterLookup>;
  productGrouping?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<ProductTypeFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  strength?: InputMaybe<StrFilterLookup>;
  units?: InputMaybe<CatalogProductUnitsEnumFilterLookup>;
  vetsourceId?: InputMaybe<StrFilterLookup>;
};

export type ProductGroupType = {
  __typename?: 'ProductGroupType';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isAService: Scalars['Boolean']['output'];
  isTaxed: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type ProductImageOrder = {
  position?: InputMaybe<Ordering>;
};

export type ProductImageType = {
  __typename?: 'ProductImageType';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image: DjangoImageType;
  modified: Scalars['DateTime']['output'];
  position: Scalars['Int']['output'];
  product: ProductType;
};

export type ProductOrder = {
  name?: InputMaybe<Ordering>;
};

export type ProductPackageFilter = {
  AND?: InputMaybe<ProductPackageFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ProductPackageFilter>;
  OR?: InputMaybe<ProductPackageFilter>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  forCanine?: InputMaybe<Scalars['Boolean']['input']>;
  forFeline?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  maxWeightInKg?: InputMaybe<FloatComparisonFilterLookup>;
  minWeightInKg?: InputMaybe<FloatComparisonFilterLookup>;
  name?: InputMaybe<StrFilterLookup>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ProductPackageItemFilter = {
  AND?: InputMaybe<ProductPackageItemFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ProductPackageItemFilter>;
  OR?: InputMaybe<ProductPackageItemFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productPackage?: InputMaybe<ProductPackageFilter>;
};

export type ProductPackageItemType = {
  __typename?: 'ProductPackageItemType';
  created: Scalars['DateTime']['output'];
  estimateGroup: Maybe<EstimateGroupType>;
  highQuantity: Scalars['Decimal']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isIncluded: Scalars['Boolean']['output'];
  isRequiredOnPicklist: Scalars['Boolean']['output'];
  lowQuantity: Scalars['Decimal']['output'];
  modified: Scalars['DateTime']['output'];
  position: Scalars['Int']['output'];
  product: ProductType;
  productPackage: ProductPackageType;
};

export type ProductPackageOrder = {
  name?: InputMaybe<Ordering>;
};

export type ProductPackageType = {
  __typename?: 'ProductPackageType';
  basePrice: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  discountedSubtotal: Maybe<Scalars['Decimal']['output']>;
  forCanine: Scalars['Boolean']['output'];
  forFeline: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isPicklist: Scalars['Boolean']['output'];
  items: Array<ProductPackageItemType>;
  maxWeightInKg: Maybe<Scalars['Float']['output']>;
  minWeightInKg: Maybe<Scalars['Float']['output']>;
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  subtotal: Scalars['Decimal']['output'];
};


export type ProductPackageTypeDiscountedSubtotalArgs = {
  locationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  quantity?: Scalars['String']['input'];
};


export type ProductPackageTypeItemsArgs = {
  filters: InputMaybe<ProductPackageItemFilter>;
};


export type ProductPackageTypeSubtotalArgs = {
  locationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  quantity?: Scalars['String']['input'];
};

export type ProductType = {
  __typename?: 'ProductType';
  administeredInHouse: Maybe<Scalars['Boolean']['output']>;
  allowsAddOns: Scalars['Boolean']['output'];
  automatedInterpretation: Maybe<DjangoModelType>;
  carePlans: Array<CarePlanGuidanceType>;
  code: Maybe<Scalars['String']['output']>;
  count: Scalars['Decimal']['output'];
  created: Scalars['DateTime']['output'];
  defaultFrequencyInDays: Maybe<Scalars['Int']['output']>;
  defaultRefillQuantity: Maybe<Scalars['Decimal']['output']>;
  defaultSig: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  diagnosticCode: Maybe<Scalars['String']['output']>;
  diagnosticNote: Maybe<Scalars['String']['output']>;
  diagnosticType: Maybe<CatalogProductDiagnosticTypeEnum>;
  disabled: Scalars['Boolean']['output'];
  discountedSubtotal: Maybe<Scalars['Decimal']['output']>;
  dispenseFee: Maybe<Scalars['Decimal']['output']>;
  estimateOnly: Scalars['Boolean']['output'];
  fixed: Scalars['Boolean']['output'];
  forCanine: Scalars['Boolean']['output'];
  forFeline: Scalars['Boolean']['output'];
  forProceduresOnly: Maybe<Scalars['Boolean']['output']>;
  friendlyVaccine: Maybe<ClientFriendlyVaccineType>;
  fulfillmentPreferences: Maybe<Array<MedicationFulfillmentMethodEnum>>;
  id: Scalars['ID']['output'];
  ignoreAllAccessDiscount: Scalars['Boolean']['output'];
  ignoreRegionMarkup: Scalars['Boolean']['output'];
  images: Array<ProductImageType>;
  isAddOn: Scalars['Boolean']['output'];
  isControlled: Scalars['Boolean']['output'];
  isEligibleForAutoship: Scalars['Boolean']['output'];
  isEuthanasia: Scalars['Boolean']['output'];
  isExemptFromTaskDoctorAssignment: Scalars['Boolean']['output'];
  isFreeForStaff: Scalars['Boolean']['output'];
  isInhouseIntegratedDiagnostic: Scalars['Boolean']['output'];
  /** @deprecated Use is_inhouse_integrated_diagnostic */
  isInhouseLab: Scalars['Boolean']['output'];
  isInhouseNonIntegratedDiagnostic: Scalars['Boolean']['output'];
  isInternalUseOnly: Scalars['Boolean']['output'];
  isNeuter: Scalars['Boolean']['output'];
  isOtc: Scalars['Boolean']['output'];
  isPrescription: Scalars['Boolean']['output'];
  isPreventative: Scalars['Boolean']['output'];
  isReferenceIntegratedDiagnostic: Scalars['Boolean']['output'];
  /** @deprecated Use is_reference_integrated_diagnostic */
  isReferenceLab: Scalars['Boolean']['output'];
  isReferenceNonIntegratedDiagnostic: Scalars['Boolean']['output'];
  isShipOnly: Scalars['Boolean']['output'];
  isVaccine: Scalars['Boolean']['output'];
  maxWeight: Maybe<Scalars['Float']['output']>;
  medication: Maybe<MedicationType>;
  memberFriendlyDescription: Maybe<Scalars['String']['output']>;
  memberFriendlyName: Maybe<Scalars['String']['output']>;
  minWeight: Maybe<Scalars['Float']['output']>;
  minimumPrice: Maybe<Scalars['Decimal']['output']>;
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  patient: PatientType;
  productType: ProductGroupType;
  salePrice: Scalars['Decimal']['output'];
  salesTax: Scalars['Decimal']['output'];
  strength: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Decimal']['output'];
  tagselector: Maybe<TagSelectorType>;
  template: Maybe<DjangoModelType>;
  total: Scalars['Decimal']['output'];
  unitDurationDays: Maybe<Scalars['Int']['output']>;
  unitFixedPrice: Maybe<Scalars['Decimal']['output']>;
  units: Maybe<CatalogProductUnitsEnum>;
  url: Maybe<Scalars['String']['output']>;
  useDefault: Scalars['Boolean']['output'];
  vetsourceId: Maybe<Scalars['String']['output']>;
};


export type ProductTypeCarePlansArgs = {
  filters: InputMaybe<CarePlanGuidanceFilter>;
  order: InputMaybe<CarePlanGuidanceOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type ProductTypeDiscountedSubtotalArgs = {
  fulfillmentPreference?: InputMaybe<Scalars['String']['input']>;
  ignoreFirstAutoshipOrderCheck?: Scalars['Boolean']['input'];
  isAutoship?: Scalars['Boolean']['input'];
  isInvoiceInAccessTier?: Scalars['Boolean']['input'];
  locationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
};


export type ProductTypeImagesArgs = {
  order: InputMaybe<ProductImageOrder>;
};


export type ProductTypeSalePriceArgs = {
  isStaff?: Scalars['Boolean']['input'];
  locationId: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
};


export type ProductTypeSalesTaxArgs = {
  fulfillmentPreference?: InputMaybe<Scalars['String']['input']>;
  ignoreFirstAutoshipOrderCheck?: Scalars['Boolean']['input'];
  isAutoship?: Scalars['Boolean']['input'];
  locationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
};


export type ProductTypeSubtotalArgs = {
  fulfillmentPreference?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  patientId: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['String']['input'];
};


export type ProductTypeTotalArgs = {
  fulfillmentPreference?: InputMaybe<Scalars['String']['input']>;
  ignoreFirstAutoshipOrderCheck?: Scalars['Boolean']['input'];
  isAutoship?: Scalars['Boolean']['input'];
  locationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
};

export type ProductTypeFilter = {
  AND?: InputMaybe<ProductTypeFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ProductTypeFilter>;
  OR?: InputMaybe<ProductTypeFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
};

export type PromoFilter = {
  AND?: InputMaybe<PromoFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<PromoFilter>;
  OR?: InputMaybe<PromoFilter>;
  code?: InputMaybe<StrFilterLookup>;
};

export type PromoType = {
  __typename?: 'PromoType';
  amountOff: Maybe<Scalars['Decimal']['output']>;
  bookingEnd: Maybe<Scalars['DateTime']['output']>;
  bookingStart: Maybe<Scalars['DateTime']['output']>;
  code: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isValid: Scalars['Boolean']['output'];
  maxRedemptionsPerCode: Maybe<Scalars['Int']['output']>;
  maxRedemptionsPerHousehold: Maybe<Scalars['Int']['output']>;
  modified: Scalars['DateTime']['output'];
  percentOff: Maybe<Scalars['Decimal']['output']>;
};


export type PromoTypeIsValidArgs = {
  householdId?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  accountCredits: Array<AccountCreditType>;
  aiCareSummary: Scalars['String']['output'];
  aiConditions: Array<DifferentialType>;
  aiTriageRoutingV2: HandleAiTriageRouting;
  appointments: Array<AppointmentType>;
  attachments: Array<AttachmentType>;
  autoships: Array<AutoshipType>;
  availability: Array<AvailabilityType>;
  breeds: Array<BreedType>;
  carePlanGuidances: Array<CarePlanGuidanceType>;
  carePlanItems: Array<CarePlanItemType>;
  chatCtas: Array<ChatCtaType>;
  clients: Array<ClientType>;
  clinicalNotes: Array<ClinicalNoteType>;
  clinicalRecordTemplates: Array<ClinicalRecordTemplateType>;
  clinicalRecords: Array<ClinicalRecordType>;
  colors: Array<ColorType>;
  communicationTemplates: Array<CommunicationTemplateType>;
  conversationPrediction: ConversationPredictionType;
  conversations: Array<ConversationType>;
  creditCards: Array<CreditCardType>;
  diagnosticTestResults: Array<DiagnosticTestResultType>;
  differentials: Array<DifferentialType>;
  dispenseMonographs: GetMonographsResponseType;
  dispenses: Array<DispenseType>;
  estimates: Array<EstimateType>;
  externalClinics: Array<ExternalClinicType>;
  extractCarePlanFromFile: PreviousMedicalHistoryType;
  fcmDevices: Array<FcmDeviceType>;
  flaggedTestResults: Array<FlaggedTestResultType>;
  friendlyVaccines: Array<ClientFriendlyVaccineType>;
  headerSearch: SearchType;
  /** @deprecated Use `households` instead */
  household: Array<HouseholdType>;
  households: Array<HouseholdType>;
  insurances: Array<InsuranceType>;
  integratedDiagnostics: Array<IntegratedDiagnosticType>;
  interactions: Array<InteractionType>;
  invoiceItems: Array<InvoiceItemType>;
  invoices: Array<InvoiceType>;
  locations: Array<LocationType>;
  medications: Array<MedicationType>;
  /** @deprecated Use medications instead - to be removed in January 2026 */
  medicationsNew: Array<MedicationType>;
  messages: Array<MessageType>;
  minimumVersion: Scalars['String']['output'];
  nonIntegratedDiagnostics: Array<NonIntegratedDiagnosticType>;
  notifications: Array<NotificationType>;
  npsSurvey: Maybe<ClinicalRecordType>;
  patientOverviewHistory: PatientOverviewHistoryType;
  patients: Array<PatientType>;
  prescriptions: Array<PrescriptionType>;
  productPackageItems: Array<ProductPackageItemType>;
  productPackages: Array<ProductPackageType>;
  products: Array<ProductType>;
  promos: Array<PromoType>;
  regions: Array<RegionType>;
  shifts: Array<ShiftType>;
  slotUsages: Array<SlotUsageType>;
  slots: Array<SlotType>;
  smartInterpretationSummary: SmartInterpretationSummaryType;
  staffs: Array<StaffType>;
  starRatings: Array<StarRatingsType>;
  tagSelectors: Array<TagSelectorType>;
  taskAutoRoutingDestination: TaskAutoRoutingDestinationType;
  tasks: Array<TaskType>;
  terminals: Array<TerminalType>;
  transactions: Array<TransactionType>;
  twilioAccessToken: TwilioAccessTokenType;
  vaccineLots: Array<VaccineLotType>;
  vaccines: Array<VaccineType>;
  validPromoCodeAndReferringHousehold: Maybe<ReferralPromoCodeType>;
  workflowSlots: Array<WorkflowSlotType>;
  workflows: Array<WorkflowType>;
};


export type QueryAccountCreditsArgs = {
  filters: InputMaybe<AccountCreditFilter>;
  order: InputMaybe<AccountCreditOrder>;
};


export type QueryAiCareSummaryArgs = {
  clinicalRecordId: Scalars['String']['input'];
  isSimpleCareSummary?: Scalars['Boolean']['input'];
};


export type QueryAiConditionsArgs = {
  forceRefresh?: Scalars['Boolean']['input'];
  patientId: Scalars['String']['input'];
};


export type QueryAiTriageRoutingV2Args = {
  messages: Array<TriageMessage>;
  patientIds: Array<Scalars['String']['input']>;
};


export type QueryAppointmentsArgs = {
  filters: InputMaybe<AppointmentFilter>;
  order: InputMaybe<AppointmentOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryAttachmentsArgs = {
  filters: InputMaybe<AttachmentFilter>;
};


export type QueryAutoshipsArgs = {
  filters: InputMaybe<AutoshipFilter>;
  order: InputMaybe<AutoshipOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryAvailabilityArgs = {
  appointmentType: Scalars['String']['input'];
  attendanceType?: InputMaybe<AvailabilityAttendanceTypeEnum>;
  endDate: Scalars['Date']['input'];
  locationIds?: Array<Scalars['String']['input']>;
  procedureLevel?: InputMaybe<Scalars['Int']['input']>;
  procedureWeight?: Scalars['Float']['input'];
  regionId: Scalars['String']['input'];
  staffId?: InputMaybe<Scalars['String']['input']>;
  staffIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['Date']['input'];
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  usdaCertifiedOnly?: Scalars['Boolean']['input'];
};


export type QueryBreedsArgs = {
  filters: InputMaybe<BreedFilter>;
};


export type QueryCarePlanGuidancesArgs = {
  filters: InputMaybe<CarePlanGuidanceFilter>;
  order: InputMaybe<CarePlanGuidanceOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryCarePlanItemsArgs = {
  filters: InputMaybe<CarePlanItemFilter>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryChatCtasArgs = {
  filters: InputMaybe<ChatCtaFilter>;
};


export type QueryClientsArgs = {
  filters: InputMaybe<ClientFilter>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryClinicalNotesArgs = {
  filters: InputMaybe<ClinicalNoteFilter>;
};


export type QueryClinicalRecordTemplatesArgs = {
  filters: InputMaybe<ClinicalRecordTemplateFilter>;
};


export type QueryClinicalRecordsArgs = {
  filters: InputMaybe<ClinicalRecordFilter>;
  order: InputMaybe<ClinicalRecordOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryColorsArgs = {
  filters: InputMaybe<ColorFilter>;
};


export type QueryCommunicationTemplatesArgs = {
  filters: InputMaybe<CommunicationTemplateFilter>;
};


export type QueryConversationPredictionArgs = {
  conversationId: Scalars['ID']['input'];
};


export type QueryConversationsArgs = {
  filters: InputMaybe<ConversationFilter>;
  order: InputMaybe<ConversationOrder>;
};


export type QueryCreditCardsArgs = {
  filters: InputMaybe<CreditCardFilter>;
};


export type QueryDiagnosticTestResultsArgs = {
  filters: InputMaybe<DiagnosticTestResultFilter>;
  order: InputMaybe<DiagnosticTestResultOrder>;
};


export type QueryDifferentialsArgs = {
  filters: InputMaybe<DifferentialFilter>;
  order: InputMaybe<DifferentialOrder>;
};


export type QueryDispenseMonographsArgs = {
  dispenseId: Scalars['ID']['input'];
};


export type QueryDispensesArgs = {
  filters: InputMaybe<DispenseFilter>;
  order: InputMaybe<DispenseOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryEstimatesArgs = {
  filters: InputMaybe<EstimateFilter>;
  order: InputMaybe<EstimateOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryExternalClinicsArgs = {
  filters: InputMaybe<ExternalClinicFilter>;
};


export type QueryExtractCarePlanFromFileArgs = {
  input: ExtractMedicalHistoryInput;
};


export type QueryFcmDevicesArgs = {
  filters: InputMaybe<FcmDeviceFilter>;
};


export type QueryFlaggedTestResultsArgs = {
  filters: InputMaybe<FlaggedTestResultFilter>;
};


export type QueryFriendlyVaccinesArgs = {
  filters: InputMaybe<ClientFriendlyVaccineFilter>;
};


export type QueryHeaderSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryHouseholdArgs = {
  filters: InputMaybe<HouseholdFilter>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryHouseholdsArgs = {
  filters: InputMaybe<HouseholdFilter>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryIntegratedDiagnosticsArgs = {
  filters: InputMaybe<IntegratedDiagnosticFilter>;
  order: InputMaybe<IntegratedDiagnosticOrder>;
};


export type QueryInteractionsArgs = {
  filters: InputMaybe<InteractionFilter>;
  order: InputMaybe<InteractionOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryInvoiceItemsArgs = {
  filters: InputMaybe<InvoiceItemFilter>;
  order: InputMaybe<InvoiceItemOrder>;
};


export type QueryInvoicesArgs = {
  filters: InputMaybe<InvoiceFilter>;
  order: InputMaybe<InvoiceOrder>;
};


export type QueryLocationsArgs = {
  filters: InputMaybe<LocationFilter>;
  order: InputMaybe<LocationOrder>;
};


export type QueryMedicationsArgs = {
  filters: InputMaybe<MedicationFilter>;
};


export type QueryMedicationsNewArgs = {
  filters: InputMaybe<MedicationFilter>;
};


export type QueryMessagesArgs = {
  filters: InputMaybe<MessageFilter>;
  order: InputMaybe<MessageOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryNonIntegratedDiagnosticsArgs = {
  filters: InputMaybe<NonIntegratedDiagnosticFilter>;
  order: InputMaybe<NonIntegratedDiagnosticOrder>;
};


export type QueryNotificationsArgs = {
  filters: InputMaybe<NotificationFilter>;
  order: InputMaybe<NotificationOrder>;
};


export type QueryPatientOverviewHistoryArgs = {
  patientId: Scalars['ID']['input'];
  staffId: Scalars['ID']['input'];
};


export type QueryPatientsArgs = {
  filters: InputMaybe<PatientFilter>;
  order: InputMaybe<PatientOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryPrescriptionsArgs = {
  filters: InputMaybe<PrescriptionFilter>;
  order: InputMaybe<PrescriptionOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryProductPackageItemsArgs = {
  filters: InputMaybe<ProductPackageItemFilter>;
};


export type QueryProductPackagesArgs = {
  filters: InputMaybe<ProductPackageFilter>;
  order: InputMaybe<ProductPackageOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryProductsArgs = {
  filters: InputMaybe<ProductFilter>;
  order: InputMaybe<ProductOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryPromosArgs = {
  filters: InputMaybe<PromoFilter>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryShiftsArgs = {
  filters: InputMaybe<ShiftFilter>;
};


export type QuerySlotUsagesArgs = {
  filters: InputMaybe<SlotUsageFilter>;
};


export type QuerySlotsArgs = {
  filters: InputMaybe<SlotFilter>;
  order: InputMaybe<AppointmentSlotOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QuerySmartInterpretationSummaryArgs = {
  diagnosticId: Scalars['String']['input'];
  internalInterpretation?: InputMaybe<Scalars['String']['input']>;
  isPartial?: Scalars['Boolean']['input'];
};


export type QueryStaffsArgs = {
  filters: InputMaybe<StaffFilter>;
  pagination: InputMaybe<OffsetPaginationInput>;
};


export type QueryStarRatingsArgs = {
  filters: InputMaybe<StarRatingsFilter>;
};


export type QueryTagSelectorsArgs = {
  filters: InputMaybe<TagSelectorFilter>;
};


export type QueryTaskAutoRoutingDestinationArgs = {
  category: Scalars['String']['input'];
  diagnosticTestResultId: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  prescriptionId: InputMaybe<Scalars['String']['input']>;
};


export type QueryTasksArgs = {
  filters: InputMaybe<TaskFilter>;
  order: InputMaybe<TaskOrder>;
};


export type QueryTerminalsArgs = {
  filters: InputMaybe<TerminalFilter>;
};


export type QueryTransactionsArgs = {
  filters: InputMaybe<TransactionFilter>;
};


export type QueryVaccineLotsArgs = {
  filters: InputMaybe<VaccineLotFilter>;
  order: InputMaybe<VaccineLotOrder>;
};


export type QueryVaccinesArgs = {
  filters: InputMaybe<VaccineFilter>;
  order: InputMaybe<VaccineOrder>;
};


export type QueryValidPromoCodeAndReferringHouseholdArgs = {
  promoCode: Scalars['String']['input'];
  referredHouseholdId: Scalars['String']['input'];
};


export type QueryWorkflowSlotsArgs = {
  filters: InputMaybe<WorkflowSlotFilter>;
};


export type QueryWorkflowsArgs = {
  order: InputMaybe<WorkflowOrder>;
};

export type ReferralPromoCodeType = {
  __typename?: 'ReferralPromoCodeType';
  promo: Maybe<PromoType>;
  referringHousehold: Maybe<HouseholdType>;
};

export type RegionType = {
  __typename?: 'RegionType';
  id: Scalars['ID']['output'];
  locationSet: Array<LocationType>;
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};


export type RegionTypeLocationSetArgs = {
  filters: InputMaybe<LocationFilter>;
  order: InputMaybe<LocationOrder>;
};

export type RequestPrescriptionInput = {
  dispense: DispenseWithoutPrescriptionInput;
  prescription: PrescriptionInput;
  task: TaskInput;
  taskAttachments?: InputMaybe<Array<TaskAttachmentInputWithoutTask>>;
};

export type RescheduleAppointmentType = {
  __typename?: 'RescheduleAppointmentType';
  appointment: Maybe<AppointmentType>;
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

export enum ScheduleWorkflowSlotAppointmentTypeEnum {
  /** BLOCKED */
  Blocked = 'BLOCKED',
  /** PROCEDURE */
  Procedure = 'PROCEDURE',
  /** SPECIALIST */
  Specialist = 'SPECIALIST',
  /** STANDARD */
  Standard = 'STANDARD',
  /** TECHNICIAN */
  Technician = 'TECHNICIAN',
  /** URGENT_INPATIENT */
  UrgentInpatient = 'URGENT_INPATIENT',
  /** URGENT_OUTPATIENT */
  UrgentOutpatient = 'URGENT_OUTPATIENT',
  /** VIRTUAL */
  Virtual = 'VIRTUAL'
}

export type SearchType = {
  __typename?: 'SearchType';
  data: Scalars['String']['output'];
};

export type SendSmsType = {
  __typename?: 'SendSMSType';
  body: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type ShiftFilter = {
  AND?: InputMaybe<ShiftFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ShiftFilter>;
  OR?: InputMaybe<ShiftFilter>;
  end?: InputMaybe<DatetimeDatetimeFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
  operationalUnit?: InputMaybe<OperationalUnitFilter>;
  start?: InputMaybe<DatetimeDatetimeFilterLookup>;
};

export type ShiftType = {
  __typename?: 'ShiftType';
  approvalRequired: Scalars['Boolean']['output'];
  comment: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  deputyId: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mealBreakEnd: Maybe<Scalars['DateTime']['output']>;
  mealBreakStart: Maybe<Scalars['DateTime']['output']>;
  modified: Scalars['DateTime']['output'];
  open: Scalars['Boolean']['output'];
  operationalUnit: OperationalUnitType;
  published: Scalars['Boolean']['output'];
  staff: Maybe<StaffType>;
  start: Scalars['DateTime']['output'];
  warning: Maybe<Scalars['String']['output']>;
  warningOverrideComment: Maybe<Scalars['String']['output']>;
};

export type SlotFilter = {
  AND?: InputMaybe<SlotFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<SlotFilter>;
  OR?: InputMaybe<SlotFilter>;
  appointment?: InputMaybe<AppointmentFilter>;
  appointmentType?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnumFilterLookup>;
  end?: InputMaybe<DatetimeDatetimeFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<LocationFilter>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  staff?: InputMaybe<StaffFilter>;
  start?: InputMaybe<DatetimeDatetimeFilterLookup>;
};

export type SlotInput = {
  appointmentType: StaffAppointmentSlotAppointmentTypeEnum;
  context?: InputMaybe<Scalars['String']['input']>;
  dropoffEnd?: InputMaybe<Scalars['Time']['input']>;
  dropoffStart?: InputMaybe<Scalars['Time']['input']>;
  end: Scalars['DateTime']['input'];
  holdPlaced?: InputMaybe<Scalars['DateTime']['input']>;
  isDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  location: OneToManyInput;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  start: Scalars['DateTime']['input'];
  usage?: InputMaybe<OneToManyInput>;
};

export type SlotInputPartial = {
  appointmentType?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
  context?: InputMaybe<Scalars['String']['input']>;
  dropoffEnd?: InputMaybe<Scalars['Time']['input']>;
  dropoffStart?: InputMaybe<Scalars['Time']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  holdPlaced?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  isDropOff?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<OneToManyInput>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  usage?: InputMaybe<OneToManyInput>;
};

export type SlotType = {
  __typename?: 'SlotType';
  appointment: Maybe<AppointmentType>;
  appointmentType: StaffAppointmentSlotAppointmentTypeEnum;
  context: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  dropoffEnd: Maybe<Scalars['Time']['output']>;
  dropoffStart: Maybe<Scalars['Time']['output']>;
  dynamicText: Maybe<AppointmentDynamicTextType>;
  end: Scalars['DateTime']['output'];
  holdPlaced: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isDropOff: Scalars['Boolean']['output'];
  location: LocationType;
  modified: Scalars['DateTime']['output'];
  published: Scalars['Boolean']['output'];
  staff: Maybe<StaffType>;
  start: Scalars['DateTime']['output'];
  timezoneStart: Maybe<Scalars['DateTime']['output']>;
  usage: Maybe<SlotUsageType>;
};

export type SlotUsageFilter = {
  AND?: InputMaybe<SlotUsageFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<SlotUsageFilter>;
  OR?: InputMaybe<SlotUsageFilter>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SlotUsageType = {
  __typename?: 'SlotUsageType';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type SmartCommunicationSummaryClientCommunicationInput = {
  communicationType: Array<MedicalClientCommunicationCommunicationTypeEnum>;
  messageIds: Array<Scalars['String']['input']>;
};

export type SmartInterpretationSummaryType = {
  __typename?: 'SmartInterpretationSummaryType';
  data: Maybe<Scalars['String']['output']>;
};

export enum StaffAppointmentAppointmentTypeEnum {
  /** BLOCKED */
  Blocked = 'BLOCKED',
  /** PROCEDURE */
  Procedure = 'PROCEDURE',
  /** SPECIALIST */
  Specialist = 'SPECIALIST',
  /** STANDARD */
  Standard = 'STANDARD',
  /** TECHNICIAN */
  Technician = 'TECHNICIAN',
  /** URGENT_INPATIENT */
  UrgentInpatient = 'URGENT_INPATIENT',
  /** URGENT_OUTPATIENT */
  UrgentOutpatient = 'URGENT_OUTPATIENT',
  /** VIRTUAL */
  Virtual = 'VIRTUAL'
}

export type StaffAppointmentAppointmentTypeEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<StaffAppointmentAppointmentTypeEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<StaffAppointmentAppointmentTypeEnum>;
};

export enum StaffAppointmentAvailabilityTypeEnum {
  Procedure = 'PROCEDURE',
  Standard = 'STANDARD',
  Technician = 'TECHNICIAN',
  UrgentInpatient = 'URGENT_INPATIENT',
  UrgentOutpatient = 'URGENT_OUTPATIENT',
  Virtual = 'VIRTUAL'
}

export enum StaffAppointmentDynamicTextTypeEnum {
  /** BLOCKED */
  Blocked = 'BLOCKED',
  /** PROCEDURE */
  Procedure = 'PROCEDURE',
  /** SPECIALIST */
  Specialist = 'SPECIALIST',
  /** STANDARD */
  Standard = 'STANDARD',
  /** TECHNICIAN */
  Technician = 'TECHNICIAN',
  /** URGENT_INPATIENT */
  UrgentInpatient = 'URGENT_INPATIENT',
  /** URGENT_OUTPATIENT */
  UrgentOutpatient = 'URGENT_OUTPATIENT',
  /** VIRTUAL */
  Virtual = 'VIRTUAL'
}

export enum StaffAppointmentSlotAppointmentTypeEnum {
  /** BLOCKED */
  Blocked = 'BLOCKED',
  /** PROCEDURE */
  Procedure = 'PROCEDURE',
  /** SPECIALIST */
  Specialist = 'SPECIALIST',
  /** STANDARD */
  Standard = 'STANDARD',
  /** TECHNICIAN */
  Technician = 'TECHNICIAN',
  /** URGENT_INPATIENT */
  UrgentInpatient = 'URGENT_INPATIENT',
  /** URGENT_OUTPATIENT */
  UrgentOutpatient = 'URGENT_OUTPATIENT',
  /** VIRTUAL */
  Virtual = 'VIRTUAL'
}

export type StaffAppointmentSlotAppointmentTypeEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<StaffAppointmentSlotAppointmentTypeEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<StaffAppointmentSlotAppointmentTypeEnum>;
};

export enum StaffAppointmentSourceEnum {
  /** APP */
  App = 'APP',
  /** CLAUDE */
  Claude = 'CLAUDE',
  /** NEWSLETTER */
  Newsletter = 'NEWSLETTER',
  /** SCHEDULER */
  Scheduler = 'SCHEDULER',
  /** TEST_PANEL */
  TestPanel = 'TEST_PANEL',
  /** WAITLIST */
  Waitlist = 'WAITLIST',
  /** WEBSITE */
  Website = 'WEBSITE'
}

export enum StaffAppointmentStatusEnum {
  /** ADMITTED */
  Admitted = 'ADMITTED',
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** CHECKED_IN */
  CheckedIn = 'CHECKED_IN',
  /** CHECKED_OUT */
  CheckedOut = 'CHECKED_OUT',
  /** CHECKING_OUT */
  CheckingOut = 'CHECKING_OUT',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** INPROGRESS */
  Inprogress = 'INPROGRESS',
  /** LATE_CANCELLATION */
  LateCancellation = 'LATE_CANCELLATION',
  /** NOSHOW */
  Noshow = 'NOSHOW',
  /** PLANNED */
  Planned = 'PLANNED',
  /** RESCHEDULED */
  Rescheduled = 'RESCHEDULED',
  /** TOOLATE */
  Toolate = 'TOOLATE'
}

export type StaffAppointmentStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<StaffAppointmentStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<StaffAppointmentStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<StaffAppointmentStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<StaffAppointmentStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<StaffAppointmentStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<StaffAppointmentStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<StaffAppointmentStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<StaffAppointmentStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<StaffAppointmentStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<StaffAppointmentStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<StaffAppointmentStatusEnum>;
};

export type StaffFilter = {
  AND?: InputMaybe<StaffFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<StaffFilter>;
  OR?: InputMaybe<StaffFilter>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isActive?: InputMaybe<BoolBaseFilterLookup>;
  isOnline?: InputMaybe<BoolBaseFilterLookup>;
  isUsdaCertified?: InputMaybe<BoolBaseFilterLookup>;
  location?: InputMaybe<LocationFilter>;
  role?: InputMaybe<StaffStaffRoleEnumFilterLookup>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type StaffInputPartial = {
  id: Scalars['ID']['input'];
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<OneToManyInput>;
};

export enum StaffStaffRoleEnum {
  /** CLINIC_SUCCESS */
  ClinicSuccess = 'CLINIC_SUCCESS',
  /** CUSTOMER_SERVICE */
  CustomerService = 'CUSTOMER_SERVICE',
  /** MEDICAL_TEAM */
  MedicalTeam = 'MEDICAL_TEAM',
  /** OFFICE_TEAM */
  OfficeTeam = 'OFFICE_TEAM',
  /** PRESCRIPTIONS_TEAM */
  PrescriptionsTeam = 'PRESCRIPTIONS_TEAM',
  /** VETERINARIAN */
  Veterinarian = 'VETERINARIAN'
}

export type StaffStaffRoleEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<StaffStaffRoleEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<StaffStaffRoleEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<StaffStaffRoleEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<StaffStaffRoleEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<StaffStaffRoleEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<StaffStaffRoleEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<StaffStaffRoleEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<StaffStaffRoleEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<StaffStaffRoleEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<StaffStaffRoleEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<StaffStaffRoleEnum>;
};

export enum StaffStaffTitleEnum {
  /** Area Clinic Director */
  AreaClinicDirector = 'Area_Clinic_Director',
  /** Area Clinic Manager */
  AreaClinicManager = 'Area_Clinic_Manager',
  /** Area Medical Director */
  AreaMedicalDirector = 'Area_Medical_Director',
  /** Associate Doctor */
  AssociateDoctor = 'Associate_Doctor',
  /** Clinic Manager */
  ClinicManager = 'Clinic_Manager',
  /** Contractor */
  Contractor = 'Contractor',
  /** Host */
  Host = 'Host',
  /** Lead Doctor */
  LeadDoctor = 'Lead_Doctor',
  /** Records Team */
  RecordsTeam = 'Records_Team',
  /** Relief Doctor */
  ReliefDoctor = 'Relief_Doctor',
  /** Senior Clinic Manager */
  SeniorClinicManager = 'Senior_Clinic_Manager',
  /** Senior Veterinary Assistant */
  SeniorVeterinaryAssistant = 'Senior_Veterinary_Assistant',
  /** Senior Veterinary Nurse */
  SeniorVeterinaryNurse = 'Senior_Veterinary_Nurse',
  /** Senior Virtual Care Manager */
  SeniorVirtualCareManager = 'Senior_Virtual_Care_Manager',
  /** Shift Lead */
  ShiftLead = 'Shift_Lead',
  /** Specialist */
  Specialist = 'Specialist',
  /** Support Office */
  SupportOffice = 'Support_Office',
  /** Veterinary Assistant */
  VeterinaryAssistant = 'Veterinary_Assistant',
  /** Veterinary Extern */
  VeterinaryExtern = 'Veterinary_Extern',
  /** Veterinary Nurse */
  VeterinaryNurse = 'Veterinary_Nurse',
  /** Virtual Care Manager */
  VirtualCareManager = 'Virtual_Care_Manager'
}

export enum StaffTaskAutoAssignSelectionEnum {
  /** Last prescribing IC DVM */
  LastPrescribingIcDvm = 'Last_prescribing_IC_DVM',
  /** Last seen IC DVM */
  LastSeenIcDvm = 'Last_seen_IC_DVM',
  /** Ordering IC DVM (Diagnostics) */
  OrderingIcDvmDiagnostics = 'Ordering_IC_DVM__Diagnostics_',
  /** VC: Customer success */
  VcCustomerSuccess = 'VC__Customer_success',
  /** VC: DVM (Diagnostics) */
  VcDvmDiagnostics = 'VC__DVM__Diagnostics_',
  /** VC: Medical team (non-prescriptions) */
  VcMedicalTeamNonPrescriptions = 'VC__Medical_team__non_prescriptions_',
  /** VC: Prescriptions */
  VcPrescriptions = 'VC__Prescriptions'
}

export enum StaffTaskCategoryEnum {
  /** ADDON_LAB_WORK */
  AddonLabWork = 'ADDON_LAB_WORK',
  /** CALLBACK */
  Callback = 'CALLBACK',
  /** DIAGNOSTIC_RESULTS */
  DiagnosticResults = 'DIAGNOSTIC_RESULTS',
  /** DOCTOR_QUESTION */
  DoctorQuestion = 'DOCTOR_QUESTION',
  /** ESTIMATES */
  Estimates = 'ESTIMATES',
  /** EXTERNAL_PRESCRIPTION_REQUEST */
  ExternalPrescriptionRequest = 'EXTERNAL_PRESCRIPTION_REQUEST',
  /** FOLLOWUP */
  Followup = 'FOLLOWUP',
  /** INSURANCE */
  Insurance = 'INSURANCE',
  /** MEMBERSHIP */
  Membership = 'MEMBERSHIP',
  /** OTHER */
  Other = 'OTHER',
  /** PRESCRIPTIONS */
  Prescriptions = 'PRESCRIPTIONS',
  /** PRESCRIPTION_REQUEST */
  PrescriptionRequest = 'PRESCRIPTION_REQUEST',
  /** RECORDS */
  Records = 'RECORDS',
  /** SCHEDULE */
  Schedule = 'SCHEDULE',
  /** SYMPATHY */
  Sympathy = 'SYMPATHY',
  /** TRAVEL */
  Travel = 'TRAVEL'
}

export enum StaffTaskRoleEnum {
  /** CLINIC_SUCCESS */
  ClinicSuccess = 'CLINIC_SUCCESS',
  /** CUSTOMER_SERVICE */
  CustomerService = 'CUSTOMER_SERVICE',
  /** MEDICAL_TEAM */
  MedicalTeam = 'MEDICAL_TEAM',
  /** PRESCRIPTIONS_TEAM */
  PrescriptionsTeam = 'PRESCRIPTIONS_TEAM',
  /** VETERINARIAN */
  Veterinarian = 'VETERINARIAN'
}

export enum StaffTaskStatusEnum {
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** PENDING */
  Pending = 'PENDING',
  /** WAITING */
  Waiting = 'WAITING'
}

export type StaffTaskStatusEnumFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<StaffTaskStatusEnum>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<StaffTaskStatusEnum>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<StaffTaskStatusEnum>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<StaffTaskStatusEnum>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<StaffTaskStatusEnum>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<StaffTaskStatusEnum>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<StaffTaskStatusEnum>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<StaffTaskStatusEnum>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<StaffTaskStatusEnum>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<StaffTaskStatusEnum>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<StaffTaskStatusEnum>;
};

export type StaffType = {
  __typename?: 'StaffType';
  areasOfExpertise: Maybe<Scalars['String']['output']>;
  areasOfInterest: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  deaNumber: Maybe<Scalars['String']['output']>;
  designations: Maybe<Scalars['String']['output']>;
  education: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<DjangoImageType>;
  isActive: Scalars['Boolean']['output'];
  isOnline: Scalars['Boolean']['output'];
  isUsdaCertified: Scalars['Boolean']['output'];
  isVeterinarian: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  location: LocationType;
  name: Scalars['String']['output'];
  proceduralCapabilities: Array<TagSelectorType>;
  proceduralCapacity: Scalars['Float']['output'];
  role: StaffStaffRoleEnum;
  shifts: Array<ShiftType>;
  shortBio: Maybe<Scalars['String']['output']>;
  signature: Maybe<DjangoImageType>;
  title: Maybe<StaffStaffTitleEnum>;
  veterinarianLevel: Scalars['Int']['output'];
};


export type StaffTypeProceduralCapabilitiesArgs = {
  filters: InputMaybe<TagSelectorFilter>;
};


export type StaffTypeShiftsArgs = {
  filters: InputMaybe<ShiftFilter>;
};

export type StarRatingInput = {
  bubbles?: InputMaybe<Scalars['String']['input']>;
  clinicalRecord: OneToManyInput;
  comment?: InputMaybe<Scalars['String']['input']>;
  confidenceRating?: InputMaybe<Scalars['Int']['input']>;
  stars: Scalars['Int']['input'];
};

export type StarRatingsFilter = {
  AND?: InputMaybe<StarRatingsFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<StarRatingsFilter>;
  OR?: InputMaybe<StarRatingsFilter>;
  clinicalRecord?: InputMaybe<ClinicalRecordFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  stars?: InputMaybe<IntComparisonFilterLookup>;
};

export type StarRatingsType = {
  __typename?: 'StarRatingsType';
  bubbles: Maybe<Scalars['String']['output']>;
  clinicalRecord: DjangoModelType;
  comment: Maybe<Scalars['String']['output']>;
  confidenceRating: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  stars: Scalars['Int']['output'];
};

export type StrFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  interactions: InteractionType;
};

export type TagSelectorFilter = {
  AND?: InputMaybe<TagSelectorFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<TagSelectorFilter>;
  OR?: InputMaybe<TagSelectorFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isActive?: InputMaybe<BoolBaseFilterLookup>;
  isProcedure?: InputMaybe<BoolBaseFilterLookup>;
  isTechnician?: InputMaybe<BoolBaseFilterLookup>;
  name?: InputMaybe<StrFilterLookup>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TagSelectorType = {
  __typename?: 'TagSelectorType';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isContagious: Scalars['Boolean']['output'];
  isProcedure: Scalars['Boolean']['output'];
  isTechnician: Scalars['Boolean']['output'];
  keywords: Scalars['String']['output'];
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  procedureWeight: Scalars['Float']['output'];
  product: Maybe<ProductType>;
  productPackages: Array<ProductPackageType>;
  timeRequired: Maybe<Scalars['String']['output']>;
  veterinarianLevel: Maybe<Scalars['Int']['output']>;
};


export type TagSelectorTypeProductPackagesArgs = {
  filters: InputMaybe<ProductPackageFilter>;
  order: InputMaybe<ProductPackageOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};

export type TaskAttachmentInput = {
  attachment: Scalars['Upload']['input'];
  task: OneToManyInput;
};

export type TaskAttachmentInputWithoutTask = {
  attachment: Scalars['Upload']['input'];
  task?: InputMaybe<Scalars['Void']['input']>;
};

export type TaskAttachmentType = {
  __typename?: 'TaskAttachmentType';
  attachment: DjangoFileType;
  id: Scalars['ID']['output'];
  task: TaskType;
};

export type TaskAutoRoutingDestinationType = {
  __typename?: 'TaskAutoRoutingDestinationType';
  location: Maybe<LocationType>;
  role: Maybe<Scalars['String']['output']>;
  staff: Maybe<StaffType>;
};

export type TaskFilter = {
  AND?: InputMaybe<TaskFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<TaskFilter>;
  OR?: InputMaybe<TaskFilter>;
  dueDate?: InputMaybe<DateDateFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<StaffFilter>;
  status?: InputMaybe<StaffTaskStatusEnumFilterLookup>;
};

export type TaskInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  additionalPrescriptionInfo?: InputMaybe<Scalars['String']['input']>;
  autoAssignSelection?: InputMaybe<StaffTaskAutoAssignSelectionEnum>;
  category: StaffTaskCategoryEnum;
  clinicalRecord?: InputMaybe<OneToManyInput>;
  creditCard?: InputMaybe<OneToManyInput>;
  diagnosticTestResult?: InputMaybe<OneToManyInput>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  integratedDiagnostic?: InputMaybe<OneToManyInput>;
  location?: InputMaybe<OneToManyInput>;
  medicationLastTaken?: InputMaybe<Scalars['String']['input']>;
  medicationReason?: InputMaybe<Scalars['String']['input']>;
  medicationSideEffects?: InputMaybe<Scalars['String']['input']>;
  medicationTakenBefore?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  otherMedications?: InputMaybe<Scalars['String']['input']>;
  patient: OneToManyInput;
  patientWeightInLbs?: InputMaybe<Scalars['String']['input']>;
  prescription?: InputMaybe<OneToManyInput>;
  reasonAutoAssigned?: InputMaybe<Scalars['String']['input']>;
  reasonInappropriatelyAssigned?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<StaffTaskRoleEnum>;
  staff?: InputMaybe<OneToManyInput>;
  status?: InputMaybe<StaffTaskStatusEnum>;
  title: Scalars['String']['input'];
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskInputPartial = {
  action?: InputMaybe<Scalars['String']['input']>;
  additionalPrescriptionInfo?: InputMaybe<Scalars['String']['input']>;
  autoAssignSelection?: InputMaybe<StaffTaskAutoAssignSelectionEnum>;
  category?: InputMaybe<StaffTaskCategoryEnum>;
  clinicalRecord?: InputMaybe<OneToManyInput>;
  creditCard?: InputMaybe<OneToManyInput>;
  diagnosticTestResult?: InputMaybe<OneToManyInput>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  integratedDiagnostic?: InputMaybe<OneToManyInput>;
  location?: InputMaybe<OneToManyInput>;
  medicationLastTaken?: InputMaybe<Scalars['String']['input']>;
  medicationReason?: InputMaybe<Scalars['String']['input']>;
  medicationSideEffects?: InputMaybe<Scalars['String']['input']>;
  medicationTakenBefore?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  otherMedications?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<OneToManyInput>;
  patientWeightInLbs?: InputMaybe<Scalars['String']['input']>;
  prescription?: InputMaybe<OneToManyInput>;
  reasonAutoAssigned?: InputMaybe<Scalars['String']['input']>;
  reasonInappropriatelyAssigned?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<StaffTaskRoleEnum>;
  staff?: InputMaybe<OneToManyInput>;
  status?: InputMaybe<StaffTaskStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaskOrder = {
  dueDate?: InputMaybe<Ordering>;
  urgent?: InputMaybe<Ordering>;
};

export type TaskType = {
  __typename?: 'TaskType';
  action: Scalars['String']['output'];
  additionalPrescriptionInfo: Maybe<Scalars['String']['output']>;
  autoAssignSelection: Maybe<StaffTaskAutoAssignSelectionEnum>;
  category: StaffTaskCategoryEnum;
  clinicalRecord: Maybe<ClinicalRecordType>;
  created: Scalars['DateTime']['output'];
  creditCard: Maybe<CreditCardType>;
  diagnosticTestResult: Maybe<DiagnosticTestResultType>;
  dueDate: Scalars['Date']['output'];
  history: Array<HistoricalTaskType>;
  id: Scalars['ID']['output'];
  integratedDiagnostic: Maybe<IntegratedDiagnosticType>;
  location: Maybe<LocationType>;
  medicationLastTaken: Maybe<Scalars['String']['output']>;
  medicationReason: Maybe<Scalars['String']['output']>;
  medicationSideEffects: Maybe<Scalars['String']['output']>;
  medicationTakenBefore: Maybe<Scalars['Boolean']['output']>;
  modified: Scalars['DateTime']['output'];
  note: Maybe<Scalars['String']['output']>;
  /** @deprecated To be removed once Header branch merged in to use history field instead */
  noteModified: Maybe<Scalars['DateTime']['output']>;
  noteModifiedBy: Maybe<Scalars['String']['output']>;
  otherMedications: Maybe<Scalars['String']['output']>;
  patient: Maybe<PatientType>;
  patientWeightInLbs: Maybe<Scalars['String']['output']>;
  prescription: Maybe<PrescriptionType>;
  reasonAutoAssigned: Maybe<Scalars['String']['output']>;
  reasonInappropriatelyAssigned: Maybe<Scalars['String']['output']>;
  role: Maybe<StaffTaskRoleEnum>;
  staff: Maybe<StaffType>;
  status: StaffTaskStatusEnum;
  taskAttachments: Array<TaskAttachmentType>;
  title: Scalars['String']['output'];
  urgent: Scalars['Boolean']['output'];
};


export type TaskTypeHistoryArgs = {
  filters: InputMaybe<HistoricalTaskFilter>;
  order: InputMaybe<HistoricalTaskOrder>;
  pagination: InputMaybe<OffsetPaginationInput>;
};

export type TerminalFilter = {
  AND?: InputMaybe<TerminalFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<TerminalFilter>;
  OR?: InputMaybe<TerminalFilter>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export type TerminalType = {
  __typename?: 'TerminalType';
  created: Scalars['DateTime']['output'];
  hsn: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: LocationType;
  modified: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type TouchInput = {
  client: OneToManyInput;
  env?: InputMaybe<Scalars['String']['input']>;
  ipAddress: Scalars['String']['input'];
  make: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  source: CustomerTouchSourceEnum;
  version: Scalars['String']['input'];
};

export type TouchOrder = {
  created?: InputMaybe<Ordering>;
};

export type TouchType = {
  __typename?: 'TouchType';
  client: DjangoModelType;
  created: Scalars['DateTime']['output'];
  env: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress: Scalars['String']['output'];
  make: Scalars['String']['output'];
  model: Maybe<Scalars['String']['output']>;
  modified: Scalars['DateTime']['output'];
  source: CustomerTouchSourceEnum;
  version: Scalars['String']['output'];
};

export type TransactionFilter = {
  AND?: InputMaybe<TransactionFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<TransactionFilter>;
  OR?: InputMaybe<TransactionFilter>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<BillingTransactionStatusEnumFilterLookup>;
};

export type TransactionInput = {
  amountAuth: Scalars['String']['input'];
  creditCard?: InputMaybe<OneToManyInput>;
  household: OneToManyInput;
  invoice?: InputMaybe<OneToManyInput>;
  method: BillingTransactionMethodEnum;
  note?: InputMaybe<Scalars['String']['input']>;
  referenceTransactionForRefund?: InputMaybe<OneToManyInput>;
  referenceTransactionForVoid?: InputMaybe<OneToManyInput>;
  saveCardAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  terminal?: InputMaybe<OneToManyInput>;
};

export type TransactionType = {
  __typename?: 'TransactionType';
  accountCredit: Maybe<DjangoModelType>;
  allowedRefundAmount: Scalars['Decimal']['output'];
  amountAuth: Scalars['Decimal']['output'];
  amountCharged: Maybe<Scalars['Decimal']['output']>;
  batchId: Maybe<Scalars['String']['output']>;
  cardConnectTransactionId: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  creditCard: Maybe<CreditCardType>;
  household: HouseholdType;
  id: Scalars['ID']['output'];
  invoice: Maybe<InvoiceType>;
  isAutoship: Scalars['Boolean']['output'];
  isRefund: Scalars['Boolean']['output'];
  isRefundable: Scalars['Boolean']['output'];
  isRenewal: Scalars['Boolean']['output'];
  isVoid: Scalars['Boolean']['output'];
  isVoidable: Scalars['Boolean']['output'];
  merchantAccount: Maybe<DjangoModelType>;
  method: BillingTransactionMethodEnum;
  modified: Scalars['DateTime']['output'];
  note: Maybe<Scalars['String']['output']>;
  reasonForFailure: Maybe<Scalars['String']['output']>;
  referenceTransactionForHold: Maybe<DjangoModelType>;
  referenceTransactionForRefund: Maybe<DjangoModelType>;
  referenceTransactionForVoid: Maybe<TransactionType>;
  saveCardAsDefault: Scalars['Boolean']['output'];
  status: BillingTransactionStatusEnum;
  terminal: Maybe<DjangoModelType>;
};

export type TriageBookingFormType = {
  __typename?: 'TriageBookingFormType';
  category: AiTriageBookingFormCategoryEnum;
  erAnswerIndices: Maybe<Array<Scalars['Int']['output']>>;
  prescriptionAnswerIndices: Maybe<Array<Scalars['Int']['output']>>;
  questions: Array<TriageFormQuestionType>;
  sedationAnswerIndices: Maybe<Array<Scalars['Int']['output']>>;
  singleSelectAnswerIndices: Maybe<Array<Scalars['Int']['output']>>;
  standardAnswerIndices: Maybe<Array<Scalars['Int']['output']>>;
  techAnswerIndices: Maybe<Array<Scalars['Int']['output']>>;
  title: Scalars['String']['output'];
  urgentAnswerIndices: Maybe<Array<Scalars['Int']['output']>>;
  vcAnswerIndices: Maybe<Array<Scalars['Int']['output']>>;
};

export type TriageFormQuestionType = {
  __typename?: 'TriageFormQuestionType';
  isRequired: Scalars['Boolean']['output'];
  limit: Maybe<Scalars['Int']['output']>;
  options: Maybe<Array<Scalars['String']['output']>>;
  optionsLayout: Maybe<Scalars['String']['output']>;
  prefilledAnswers: Maybe<Array<Scalars['String']['output']>>;
  question: Scalars['String']['output'];
  type: AiTriageFormQuestionTypeEnum;
};

export type TriageFormType = {
  __typename?: 'TriageFormType';
  category: AiTriageFormCategoryEnum;
  questions: Array<TriageFormQuestionType>;
  title: Scalars['String']['output'];
};

export type TriageMessage = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type TriageRoutingBookingData = {
  __typename?: 'TriageRoutingBookingData';
  appointmentType: Maybe<StaffAppointmentAvailabilityTypeEnum>;
  followUpForm: Maybe<TriageBookingFormType>;
  forceDropOff: Scalars['Boolean']['output'];
  isGibberish: Scalars['Boolean']['output'];
  isPotentialSedation: Scalars['Boolean']['output'];
  reasonForVisit: Scalars['String']['output'];
  routingDestination: AiTriageBookingRoutingDestinationEnum;
};

export type TriageRoutingChatData = {
  __typename?: 'TriageRoutingChatData';
  category: Scalars['String']['output'];
  form: Maybe<TriageFormType>;
  reasonForConversation: Scalars['String']['output'];
  routeToBooking: Scalars['Boolean']['output'];
  routingDestination: AiTriageRoutingDestinationEnum;
  triageSupportType: AiTriageSupportTypeEnum;
};

export type TwilioAccessTokenType = {
  __typename?: 'TwilioAccessTokenType';
  identity: Maybe<Scalars['String']['output']>;
  token: Maybe<Scalars['String']['output']>;
};

export type VaccineFilter = {
  AND?: InputMaybe<VaccineFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<VaccineFilter>;
  OR?: InputMaybe<VaccineFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type VaccineInput = {
  clinicalRecord?: InputMaybe<OneToManyInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expirationDate: Scalars['Date']['input'];
  friendlyVaccine: OneToManyInput;
  historical?: InputMaybe<Scalars['Boolean']['input']>;
  immunizationType?: InputMaybe<MedicalVaccineImmunizationTypeEnum>;
  isDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
  lotExpiration?: InputMaybe<Scalars['Date']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patient: OneToManyInput;
  product?: InputMaybe<OneToManyInput>;
  rabiesTagNumber?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<MedicalVaccineRouteEnum>;
  siteOfInjection?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  vaccineLot?: InputMaybe<OneToManyInput>;
};

export type VaccineInputPartial = {
  clinicalRecord?: InputMaybe<OneToManyInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  friendlyVaccine?: InputMaybe<OneToManyInput>;
  historical?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  immunizationType?: InputMaybe<MedicalVaccineImmunizationTypeEnum>;
  isDiscontinued?: InputMaybe<Scalars['Boolean']['input']>;
  lotExpiration?: InputMaybe<Scalars['Date']['input']>;
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<OneToManyInput>;
  product?: InputMaybe<OneToManyInput>;
  rabiesTagNumber?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<MedicalVaccineRouteEnum>;
  siteOfInjection?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<OneToManyInput>;
  vaccineLot?: InputMaybe<OneToManyInput>;
};

export type VaccineLotFilter = {
  AND?: InputMaybe<VaccineLotFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<VaccineLotFilter>;
  OR?: InputMaybe<VaccineLotFilter>;
  expirationDate?: InputMaybe<DateDateFilterLookup>;
  id?: InputMaybe<IdBaseFilterLookup>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<LocationFilter>;
  product?: InputMaybe<ProductFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type VaccineLotOrder = {
  created?: InputMaybe<Ordering>;
  expirationDate?: InputMaybe<Ordering>;
};

export type VaccineLotType = {
  __typename?: 'VaccineLotType';
  brandName: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  expirationDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  location: LocationType;
  lotNumber: Scalars['String']['output'];
  manufacturer: ManufacturerType;
  modified: Scalars['DateTime']['output'];
  product: ProductType;
  serialNumber: Maybe<Scalars['String']['output']>;
};

export type VaccineOrder = {
  created?: InputMaybe<Ordering>;
};

export type VaccineType = {
  __typename?: 'VaccineType';
  brandName: Maybe<Scalars['String']['output']>;
  clinicalRecord: Maybe<ClinicalRecordType>;
  created: Scalars['DateTime']['output'];
  date: Scalars['Date']['output'];
  expirationDate: Scalars['Date']['output'];
  friendlyVaccine: ClientFriendlyVaccineType;
  historical: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  immunizationType: MedicalVaccineImmunizationTypeEnum;
  isDiscontinued: Maybe<Scalars['Boolean']['output']>;
  license: Maybe<LicenseType>;
  lotExpiration: Maybe<Scalars['Date']['output']>;
  lotNumber: Maybe<Scalars['String']['output']>;
  manufacturer: Maybe<Scalars['String']['output']>;
  modified: Scalars['DateTime']['output'];
  note: Maybe<Scalars['String']['output']>;
  patient: PatientType;
  product: Maybe<ProductType>;
  rabiesTagNumber: Maybe<Scalars['String']['output']>;
  route: Maybe<MedicalVaccineRouteEnum>;
  siteOfInjection: Maybe<Scalars['String']['output']>;
  staff: Maybe<StaffType>;
  starRatings: Maybe<StarRatingsType>;
  vaccineLot: Maybe<VaccineLotType>;
};

export type VitalsFilter = {
  AND?: InputMaybe<VitalsFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<VitalsFilter>;
  OR?: InputMaybe<VitalsFilter>;
  weight?: InputMaybe<FloatComparisonFilterLookup>;
};

export type VitalsInput = {
  bcs?: InputMaybe<Scalars['Int']['input']>;
  clinicalRecord: OneToOneInput;
  crt?: InputMaybe<MedicalVitalsCrtEnum>;
  diet?: InputMaybe<Scalars['String']['input']>;
  fasScore?: InputMaybe<Scalars['Int']['input']>;
  heartRate?: InputMaybe<Scalars['Float']['input']>;
  hydration?: InputMaybe<MedicalVitalsHydrationEnum>;
  mentation?: InputMaybe<MedicalVitalsMentationEnum>;
  mucousMembrane?: InputMaybe<MedicalVitalsMucousMembraneEnum>;
  painScore?: InputMaybe<Scalars['Int']['input']>;
  petechiation?: InputMaybe<Scalars['Boolean']['input']>;
  respiratoryRate?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type VitalsInputPartial = {
  bcs?: InputMaybe<Scalars['Int']['input']>;
  clinicalRecord?: InputMaybe<OneToOneInput>;
  crt?: InputMaybe<MedicalVitalsCrtEnum>;
  diet?: InputMaybe<Scalars['String']['input']>;
  fasScore?: InputMaybe<Scalars['Int']['input']>;
  heartRate?: InputMaybe<Scalars['Float']['input']>;
  hydration?: InputMaybe<MedicalVitalsHydrationEnum>;
  id: Scalars['ID']['input'];
  mentation?: InputMaybe<MedicalVitalsMentationEnum>;
  mucousMembrane?: InputMaybe<MedicalVitalsMucousMembraneEnum>;
  painScore?: InputMaybe<Scalars['Int']['input']>;
  petechiation?: InputMaybe<Scalars['Boolean']['input']>;
  respiratoryRate?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type VitalsType = {
  __typename?: 'VitalsType';
  bcs: Maybe<Scalars['Int']['output']>;
  clinicalRecord: DjangoModelType;
  created: Scalars['DateTime']['output'];
  crt: Maybe<MedicalVitalsCrtEnum>;
  diet: Maybe<Scalars['String']['output']>;
  fasScore: Maybe<Scalars['Int']['output']>;
  heartRate: Maybe<Scalars['Float']['output']>;
  hydration: Maybe<MedicalVitalsHydrationEnum>;
  id: Scalars['ID']['output'];
  mentation: Maybe<MedicalVitalsMentationEnum>;
  modified: Scalars['DateTime']['output'];
  mucousMembrane: Maybe<MedicalVitalsMucousMembraneEnum>;
  painScore: Maybe<Scalars['Int']['output']>;
  petechiation: Maybe<Scalars['Boolean']['output']>;
  respiratoryRate: Maybe<Scalars['String']['output']>;
  temperature: Maybe<Scalars['String']['output']>;
  weight: Maybe<Scalars['Float']['output']>;
};

export type WaitlistInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dogOrCatOwner?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fullName?: InputMaybe<Scalars['String']['input']>;
  isReleased?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
  previousClinicName?: InputMaybe<Scalars['String']['input']>;
  previousVetName?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type WaitlistType = {
  __typename?: 'WaitlistType';
  address: Maybe<Scalars['String']['output']>;
  apartment: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  dogOrCatOwner: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isReleased: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  phoneNumber: Scalars['String']['output'];
  previousClinicName: Maybe<Scalars['String']['output']>;
  previousVetName: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
  zipcode: Maybe<Scalars['String']['output']>;
};

export type WorkflowFilter = {
  AND?: InputMaybe<WorkflowFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<WorkflowFilter>;
  OR?: InputMaybe<WorkflowFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  name?: InputMaybe<StrFilterLookup>;
};

export type WorkflowOrder = {
  name?: InputMaybe<Ordering>;
};

export type WorkflowSlotFilter = {
  AND?: InputMaybe<WorkflowSlotFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<WorkflowSlotFilter>;
  OR?: InputMaybe<WorkflowSlotFilter>;
  id?: InputMaybe<IdBaseFilterLookup>;
  workflow?: InputMaybe<WorkflowFilter>;
};

export type WorkflowSlotType = {
  __typename?: 'WorkflowSlotType';
  appointmentType: ScheduleWorkflowSlotAppointmentTypeEnum;
  created: Scalars['DateTime']['output'];
  dropoffEnd: Maybe<Scalars['Time']['output']>;
  dropoffStart: Maybe<Scalars['Time']['output']>;
  end: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isDropOff: Scalars['Boolean']['output'];
  modified: Scalars['DateTime']['output'];
  start: Scalars['Time']['output'];
  usage: Maybe<SlotUsageType>;
  workflow: Array<WorkflowType>;
};


export type WorkflowSlotTypeWorkflowArgs = {
  order: InputMaybe<WorkflowOrder>;
};

export type WorkflowType = {
  __typename?: 'WorkflowType';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type LocationPartsFragment = { __typename?: 'LocationType', id: string, name: string, webBookingShowCreditCardStep: boolean, region: { __typename?: 'RegionType', id: string, timezone: string } };

export type GetRegionLocationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRegionLocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'LocationType', id: string, region: { __typename?: 'RegionType', id: string, locationSet: Array<{ __typename?: 'LocationType', id: string, name: string, webBookingShowCreditCardStep: boolean, region: { __typename?: 'RegionType', id: string, timezone: string } }> } }> };

export type GetAvailableSlotsQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  startGte: Scalars['DateTime']['input'];
  endLte: Scalars['DateTime']['input'];
}>;


export type GetAvailableSlotsQuery = { __typename?: 'Query', slots: Array<{ __typename?: 'SlotType', id: string, start: string, end: string, staff: { __typename?: 'StaffType', id: string } | null, location: { __typename?: 'LocationType', id: string, name: string, webBookingShowCreditCardStep: boolean, region: { __typename?: 'RegionType', id: string, timezone: string } } }> };

export type ClientBasicInfoFragment = { __typename?: 'ClientType', id: string, token: string, email: string | null, fullName: string };

export type GetMembershipProductsAndComprehensiveExamQueryVariables = Exact<{
  locationId: Scalars['String']['input'];
}>;


export type GetMembershipProductsAndComprehensiveExamQuery = { __typename?: 'Query', memberships: Array<{ __typename?: 'ProductType', id: string, name: string, salePrice: string }>, comprehensiveExam: Array<{ __typename?: 'ProductType', id: string, name: string, salePrice: string }> };

export type AuthorizePhoneWebookingMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
}>;


export type AuthorizePhoneWebookingMutation = { __typename?: 'Mutation', authorizePhone: { __typename?: 'AuthorizePhone', ok: boolean } };

export type VerifyCodeMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
}>;


export type VerifyCodeMutation = { __typename?: 'Mutation', authorizePhone: { __typename?: 'AuthorizePhone', ok: boolean, client: { __typename?: 'ClientType', id: string, token: string, email: string | null, fullName: string, household: { __typename?: 'HouseholdType', id: string, patients: Array<{ __typename?: 'PatientType', id: string, tier: string, name: string, birthdate: string, species: CustomerPatientSpeciesEnum, isMixed: boolean, sex: CustomerPatientSexEnum | null, spayedOrNeutered: boolean | null, hasDeclaredNoPreviousRecords: boolean, needsRecords: boolean, appointments: Array<{ __typename?: 'AppointmentType', status: StaffAppointmentStatusEnum }>, breedLookup: { __typename?: 'BreedType', id: string, name: string }, colorLookup: { __typename?: 'ColorType', id: string, name: string } }>, derivedLocation: { __typename?: 'LocationType', id: string, region: { __typename?: 'RegionType', id: string, timezone: string } } } } | null } };

export type CreateClientMutationVariables = Exact<{
  input: ClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'ClientType', id: string, token: string, email: string | null, fullName: string, household: { __typename?: 'HouseholdType', id: string, derivedLocation: { __typename?: 'LocationType', id: string, region: { __typename?: 'RegionType', id: string, timezone: string } } } } };

export type PatchClientMutationVariables = Exact<{
  input: ClientInputPartial;
}>;


export type PatchClientMutation = { __typename?: 'Mutation', patchClient: { __typename?: 'ClientType', id: string } };

export type CreateCreditCardMutationVariables = Exact<{
  input: CreditCardInput;
}>;


export type CreateCreditCardMutation = { __typename?: 'Mutation', createCreditCard: { __typename?: 'CreditCardType', id: string } };

export type CreateAppointmentMutationVariables = Exact<{
  input: AppointmentInput;
}>;


export type CreateAppointmentMutation = { __typename?: 'Mutation', createAppointment: { __typename?: 'AppointmentType', id: string, start: string, end: string, reasonForVisitDescription: string, location: { __typename?: 'LocationType', name: string, address: string, city: string, state: string, zipcode: string, phone: string, visitorInformation: string | null, latitude: string, longitude: string, image: { __typename?: 'DjangoImageType', url: string }, region: { __typename?: 'RegionType', id: string, timezone: string } }, staff: { __typename?: 'StaffType', name: string, firstName: string | null, lastName: string | null } | null, dynamicText: { __typename?: 'AppointmentDynamicTextType', changeOfPlansText: string, dayOfVisitInstructions: Array<string> } | null } };

export type GetBreedsQueryVariables = Exact<{
  species: CustomerBreedSpeciesEnum;
}>;


export type GetBreedsQuery = { __typename?: 'Query', breeds: Array<{ __typename?: 'BreedType', id: string, name: string }> };

export type GetColorsQueryVariables = Exact<{
  species: CustomerColorSpeciesEnum;
}>;


export type GetColorsQuery = { __typename?: 'Query', colors: Array<{ __typename?: 'ColorType', id: string, name: string }> };

export type CreatePatientMutationVariables = Exact<{
  input: PatientInput;
}>;


export type CreatePatientMutation = { __typename?: 'Mutation', createPatient: { __typename?: 'PatientType', id: string } };

export type PatchPatientMutationVariables = Exact<{
  input: PatientInputPartial;
}>;


export type PatchPatientMutation = { __typename?: 'Mutation', patchPatient: { __typename?: 'PatientType', id: string } };

export type ExternalClinicPartsFragment = { __typename?: 'ExternalClinicType', id: string, name: string, address: string | null, phone: string | null };

export type CreateExternalClinicMutationVariables = Exact<{
  input: ExternalClinicInput;
}>;


export type CreateExternalClinicMutation = { __typename?: 'Mutation', createExternalClinic: { __typename?: 'ExternalClinicType', id: string, name: string, address: string | null, phone: string | null } };

export type GetExternalClinicsQueryVariables = Exact<{
  googlePlacesId: Scalars['String']['input'];
}>;


export type GetExternalClinicsQuery = { __typename?: 'Query', externalClinics: Array<{ __typename?: 'ExternalClinicType', id: string, name: string, address: string | null, phone: string | null }> };

export type CreateInboundMedicalRecordRequestMutationVariables = Exact<{
  input: InboundMedicalRecordRequestInput;
}>;


export type CreateInboundMedicalRecordRequestMutation = { __typename?: 'Mutation', createInboundMedicalRecordRequest: { __typename?: 'InboundMedicalRecordRequestType', id: string } };

export type CreateAccountCreditMutationVariables = Exact<{
  data: AccountCreditInput;
}>;


export type CreateAccountCreditMutation = { __typename?: 'Mutation', createAccountCredit: { __typename?: 'AccountCreditType', id: string } };

export type CreateClinicalRecordMutationVariables = Exact<{
  data: ClinicalRecordInput;
}>;


export type CreateClinicalRecordMutation = { __typename?: 'Mutation', createClinicalRecord: { __typename?: 'ClinicalRecordType', id: string } };

export type CreateInvoiceMutationVariables = Exact<{
  data: InvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice: { __typename?: 'InvoiceType', id: string } };

export type CreateInvoiceItemsMutationVariables = Exact<{
  data: Array<InvoiceItemInput> | InvoiceItemInput;
}>;


export type CreateInvoiceItemsMutation = { __typename?: 'Mutation', createInvoiceItems: Array<{ __typename?: 'InvoiceItemType', id: string, invoice: { __typename?: 'InvoiceType', id: string, postTaxTotal: string } }> };

export type CreateTransactionMutationVariables = Exact<{
  data: TransactionInput;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransaction: { __typename?: 'TransactionType', id: string, status: BillingTransactionStatusEnum, reasonForFailure: string | null } };

export type PatchInvoiceMutationVariables = Exact<{
  data: InvoiceInputPartial;
}>;


export type PatchInvoiceMutation = { __typename?: 'Mutation', patchInvoice: { __typename?: 'InvoiceType', id: string } };

export type CreateMembershipMutationVariables = Exact<{
  data: MembershipInput;
}>;


export type CreateMembershipMutation = { __typename?: 'Mutation', createMembership: { __typename?: 'MembershipType', id: string } };

export type GetValidPromoCodeAndReferringHouseholdQueryVariables = Exact<{
  promoCode: Scalars['String']['input'];
  referredHouseholdId: Scalars['String']['input'];
}>;


export type GetValidPromoCodeAndReferringHouseholdQuery = { __typename?: 'Query', validPromoCodeAndReferringHousehold: { __typename?: 'ReferralPromoCodeType', promo: { __typename?: 'PromoType', id: string, code: string, isValid: boolean, amountOff: string | null, percentOff: string | null } | null, referringHousehold: { __typename?: 'HouseholdType', id: string, householdHash: string | null } | null } | null };

export const LocationPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"webBookingShowCreditCardStep"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<LocationPartsFragment, unknown>;
export const ClientBasicInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientBasicInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]} as unknown as DocumentNode<ClientBasicInfoFragment, unknown>;
export const ExternalClinicPartsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalClinicParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalClinicType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]} as unknown as DocumentNode<ExternalClinicPartsFragment, unknown>;
export const GetRegionLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRegionLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"comingSoon"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationParts"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"webBookingShowCreditCardStep"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<GetRegionLocationsQuery, GetRegionLocationsQueryVariables>;
export const GetAvailableSlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableSlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startGte"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endLte"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startGte"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"end"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endLte"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"appointmentType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exact"},"value":{"kind":"EnumValue","value":"STANDARD"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"appointment"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"published"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"isDropOff"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"start"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"staff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationParts"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LocationType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"webBookingShowCreditCardStep"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<GetAvailableSlotsQuery, GetAvailableSlotsQueryVariables>;
export const GetMembershipProductsAndComprehensiveExamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMembershipProductsAndComprehensiveExam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"productType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exact"},"value":{"kind":"IntValue","value":"1"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"salePrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}]}]}},{"kind":"Field","alias":{"kind":"Name","value":"comprehensiveExam"},"name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"disabled"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exact"},"value":{"kind":"IntValue","value":"154"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"salePrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}]}]}}]}}]} as unknown as DocumentNode<GetMembershipProductsAndComprehensiveExamQuery, GetMembershipProductsAndComprehensiveExamQueryVariables>;
export const AuthorizePhoneWebookingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthorizePhoneWebooking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizePhone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<AuthorizePhoneWebookingMutation, AuthorizePhoneWebookingMutationVariables>;
export const VerifyCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"verificationCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizePhone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"verificationCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verificationCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientBasicInfo"}},{"kind":"Field","name":{"kind":"Name","value":"household"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"patients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"birthdate"}},{"kind":"Field","name":{"kind":"Name","value":"species"}},{"kind":"Field","name":{"kind":"Name","value":"isMixed"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"spayedOrNeutered"}},{"kind":"Field","name":{"kind":"Name","value":"hasDeclaredNoPreviousRecords"}},{"kind":"Field","name":{"kind":"Name","value":"needsRecords"}},{"kind":"Field","name":{"kind":"Name","value":"breedLookup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colorLookup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"derivedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientBasicInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]} as unknown as DocumentNode<VerifyCodeMutation, VerifyCodeMutationVariables>;
export const CreateClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientBasicInfo"}},{"kind":"Field","name":{"kind":"Name","value":"household"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"derivedLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientBasicInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]} as unknown as DocumentNode<CreateClientMutation, CreateClientMutationVariables>;
export const PatchClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PatchClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientInputPartial"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patchClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PatchClientMutation, PatchClientMutationVariables>;
export const CreateCreditCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCreditCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreditCardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCreditCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCreditCardMutation, CreateCreditCardMutationVariables>;
export const CreateAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAppointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"visitorInformation"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"staff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reasonForVisitDescription"}},{"kind":"Field","name":{"kind":"Name","value":"dynamicText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeOfPlansText"}},{"kind":"Field","name":{"kind":"Name","value":"dayOfVisitInstructions"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAppointmentMutation, CreateAppointmentMutationVariables>;
export const GetBreedsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBreeds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"species"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerBreedSpeciesEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"breeds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"species"},"value":{"kind":"Variable","name":{"kind":"Name","value":"species"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetBreedsQuery, GetBreedsQueryVariables>;
export const GetColorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetColors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"species"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerColorSpeciesEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"species"},"value":{"kind":"Variable","name":{"kind":"Name","value":"species"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetColorsQuery, GetColorsQueryVariables>;
export const CreatePatientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePatient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPatient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePatientMutation, CreatePatientMutationVariables>;
export const PatchPatientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PatchPatient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PatientInputPartial"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patchPatient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PatchPatientMutation, PatchPatientMutationVariables>;
export const CreateExternalClinicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExternalClinic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalClinicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExternalClinic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalClinicParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalClinicParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalClinicType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]} as unknown as DocumentNode<CreateExternalClinicMutation, CreateExternalClinicMutationVariables>;
export const GetExternalClinicsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExternalClinics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"googlePlacesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalClinics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"googlePlacesId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"googlePlacesId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalClinicParts"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalClinicParts"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalClinicType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]} as unknown as DocumentNode<GetExternalClinicsQuery, GetExternalClinicsQueryVariables>;
export const CreateInboundMedicalRecordRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInboundMedicalRecordRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InboundMedicalRecordRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInboundMedicalRecordRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateInboundMedicalRecordRequestMutation, CreateInboundMedicalRecordRequestMutationVariables>;
export const CreateAccountCreditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAccountCredit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccountCredit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAccountCreditMutation, CreateAccountCreditMutationVariables>;
export const CreateClinicalRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateClinicalRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClinicalRecordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createClinicalRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateClinicalRecordMutation, CreateClinicalRecordMutationVariables>;
export const CreateInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateInvoiceMutation, CreateInvoiceMutationVariables>;
export const CreateInvoiceItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInvoiceItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceItemInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInvoiceItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postTaxTotal"}}]}}]}}]}}]} as unknown as DocumentNode<CreateInvoiceItemsMutation, CreateInvoiceItemsMutationVariables>;
export const CreateTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForFailure"}}]}}]}}]} as unknown as DocumentNode<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const PatchInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PatchInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceInputPartial"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patchInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PatchInvoiceMutation, PatchInvoiceMutationVariables>;
export const CreateMembershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMembership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MembershipInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMembership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMembershipMutation, CreateMembershipMutationVariables>;
export const GetValidPromoCodeAndReferringHouseholdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidPromoCodeAndReferringHousehold"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referredHouseholdId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validPromoCodeAndReferringHousehold"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"promoCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promoCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"referredHouseholdId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referredHouseholdId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"amountOff"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referringHousehold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"householdHash"}}]}}]}}]}}]} as unknown as DocumentNode<GetValidPromoCodeAndReferringHouseholdQuery, GetValidPromoCodeAndReferringHouseholdQueryVariables>;